export default {
  // 导航菜单
  menu: {
    home: 'Home',
    copilot: 'Copilot',
    sage: 'Sage',
    help: 'Help',
    show: 'Showcase',
    price: 'Pricing',
    account: 'Account',
    calendar: 'Origin date',
    updateTime: 'Latest update',
    JANUS:'JANUS',
    JANUSCopilot: 'JANUS Copilot',
    version: 'V3.1.0',
    selectDate: 'Select date',
    placeholder: 'Enter a stock, industry, or fund name or code',
  },
  sidebar: {
    home: 'Home',
    aiBase: 'AI Base',
    companyProfile: 'Company',
    media: 'Media',
    zh: '中'
  },
  mainHeader: {
    industry: 'Industry',
    stock: 'Stock',
    fund: 'Fund',
    tradingRefreshSoon: 'Trading session detected, the page will refresh soon'
  },

  // 登录和注册页面
  login: {
    PasswordLogin: 'Password',
    SmsLogin: 'SMS',
    username: 'Username',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    login: 'Sign in',
    registerNewAccount: 'Create account',
    contactInfo: 'Contact: inquiry＠jitai.ai',
    pleaseEnterUsernameOrPhone: 'Please enter a username or phone number',
    phone: 'Phone number',
    verificationCode: 'SMS code',
    getVerificationCode: 'Get code',
    confirmPassword: 'Confirm Password',
    name: 'Username',
    email: 'Email',
    company: 'Company',
    job: 'Job title',
    referrer: 'Referrer',
    howDidYouHearAboutUs: 'Source',
    riskDisclaimer: '《Risk Disclaimer》',
    privacyPolicy: '《Privacy Policy》',
    termsOfService: '《Terms of Service》',
    register: 'Register',
    alreadyHaveAccount: 'Already have an account? Log in',
    pleaseEnterUsername: 'Please enter username',
    pleaseEnterPassword: 'Please enter password',
    pleaseConfirmPassword: 'Please confirm password',
    pleaseEnterFullName: 'Please enter full name',
    pleaseEnterEmail: 'Please enter email',
    pleaseEnterCompany: 'Please enter company',
    pleaseEnterPosition: 'Please enter position',
    pleaseEnterReferrer: 'Please enter referrer',
    pleaseEnterHowYouHeard: 'Please enter how you heard',
    pleaseEnterPhone: 'Please enter phone',
    pleaseEnterVerificationCode: 'Please enter SMS code',
    pleaseAgreeToTerms: 'Please agree to the terms and policies.',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    confirm: 'Confirm',
    emailMsg: 'Please check your email for the activation notification. If you have any questions or issues, feel free to contact us at any time.',
    ContinueBrowsing: 'Continue browsing',
  },

  // 错误信息
  errorMessage: {
    errorPassword: 'Incorrect password',
    invalidPhoneNumber: 'Invalid phone number',
    invalidVerificationCode: 'Failed to send the verification code',
    minLength: 'Password must be at least 8 characters long',
    uppercaseRequired: 'Password must contain at least one uppercase letter',
    lowercaseRequired: 'Password must contain at least one lowercase letter',
    digitRequired: 'Password must contain at least one digit',
    specialCharRequired: 'Password must contain at least one special character',
    startWithAlphanumeric: 'Password must start with a letter or digit',
    VerificationCodeSentSuccessfully: 'verification code sent successfully',
    passwordMismatch: 'The passwords do not match. Please check and try again',
    invalidEmailFormat: 'Invalid email format',
    registerSuccess: 'Registration successful! Please log in.',
    ApplicationSubmittedSuccessfully: 'Application submitted successfully!',
    PasswordResetFailed: 'Password reset failed',
    VerificationCodeSentFailed: 'Verification code sent failed',
    AccountExistSignIn: 'An account already exists. Please sign in'
  },

  // 定价页面
  pricing: {
    // 页面标题 & 模块标题
    versionComparison: 'Version Comparison',
    getQuote: 'Get Quote',

    // 功能模块名称（左侧标签）
    accountType: 'Account Type',
    aomPrediction: 'AOM Prediction',
    industryPrediction: 'Industry Prediction',
    stockPrediction: 'Stock Prediction',
    mutualFund: 'Mutual Fund',
    accountQuantity: 'Number of Accounts',

    // 账户类型
    ultimate: 'Ultimate',
    flagship: 'Flagship',
    enhanced: 'Enhanced',
    standard: 'Standard',
    basic: 'Basic',

    // 数据映射中的标签
    aom: 'AOM',
    indus: 'Industry',
    ticker: 'Stock',
    fund: 'Fund',
    bond: 'Bond',
    commodity: 'Commodity',

    // 文字
    longTermForecast: 'Long-term forecast',
    standardForecast: 'Standard forecast',
    preciseForecast: 'Precise forecast',
    trendForecast: 'Trend forecast',
    dailyForecast: 'Daily forecast',
    weeklyForecast: 'Weekly forecast',

    preciseScoring: 'Precise scoring',
    tierScoring: 'Tier scoring',

    multiDimensional: 'Multi dimensional',
    singleDimensional: 'Single dimensional',

    strength: 'AI Score',
    consistency: 'Consistency',
    liquidity: 'Liquidity',

    fineExtremeDistribution: 'Fine extreme distribution',
    extremeDistribution: 'Extreme distribution',

    nonNormal: 'Non_normal',
    normal: 'Normal',
    day: 'Day',
    percentageScale: 'Percentage scale',
    tieredSystem: 'Tiered system',


    // 账号类型选项
    professionalEdition: 'Professional',
    institutionalEdition: 'Institutional',

    // 支付周期选项
    quarterlyPayment: 'Quarterly',
    annualPayment: 'Annual',

    // 行业预测层级
    industryLevelL1: 'L1',
    industryLevelL1L2: 'L1 + L2',

    // 个股预测说明文字
    stockQueryVolume: 'Daily Stock Query Volume',
    queriesPerDay: 'queries/day',
    sharedQueryVolume: 'Query volume shared across all accounts within the institution',

    // 不需要选项
    Needed: 'Needed',
    notNeeded: 'Not needed',

    // 行业地图: 百分制; 5档制;
    industryMap: 'Industry map',
    percentile: 'Percentile',
    fiveLevel: 'Five level',

    // 弹窗提示
    loginRequiredTitle: 'Note: Please log in to get a quote',
    atLeastOneModuleRequired: 'Note: Please select at least one prediction module',
    goToLogin: 'To login',

    // 报价结果页
    quoteResult: 'Quote',
    priceUnit: 'RMB 10k',
    contactForDetails: 'Please contact our staff for detailed consultation and to purchase Copilot'
  },

  // copilot header: copilot 头标题
  copilotHeader: {
    macro: 'Macro',
    commodityIndex: 'Commodities',
    bondIndex: 'Bond Mkt',
    forex: 'Forex',
    allMarket: 'Markets',
    AShareMarket: 'AShare Forecast',
    indexPerformance: 'Glb Mkt Indicies',
    globalPerformance: 'Glb Mkt Perf',
    industry: 'Sectors',
    industryPerformance: 'Sector Perf',
    multiDimensionalMap: 'MultiDim Map',
    trendForecast: 'Forecast Rotation',
    industryForecast: 'Detailed Forecast',
    stockForecast: 'Stocks',
    fund: 'Funds',
    fundEvaluation: 'Indvidual Funds',
    fundManager: 'Portfolio Mgrs',
    fundCompany: 'AMFs',
    watchlist: 'Watchlist',
  },

  // aom view
  aomView: {
    leverageMoney: 'Leverage Money',
    reverseRepoMoney: 'Reverse Repo Money',
    shortSellingMoney: 'Short Selling Money',
    majorShareholderTrading: 'Major Shareholder Trading',
    northSouthBoundMoney: 'North South Bound Money',

    majorShareholderBuy: 'Major Share Holder Buy',
    majorShareholderSell: 'Major Share Holder Sell',

    fundInflow: 'Fund Inflow',
    fundOutflow: 'Fund Outflow',

    buy: 'Buy',
    sell: 'Sell',

    newShortPosition: 'New Short Position',
    shortCovering: 'Short Covering',

    netInflowLeverage: 'Net Inflow Leverage',
    netInflowReverseRepo: 'Net Inflow Reverse Repo',
    netInflowShortSelling: 'Net Inflow Short Selling',

    netMajorShareholderBuy: 'Net Major Shareholder Buy',
    southboundFunds: 'Southbound Funds',
    northboundFunds: 'Northbound Funds',

    billion: 'B',
    marketMean: 'Market Mean',
    marketWeightedMean: 'Market Weighted Mean',
    percentile: 'Percentile',
    tradingVolume: 'Trading Volume',

    strength: 'AI Score',
    consistency: 'Consistency',
    liquidity: 'Liquidity',
    day: 'D',
    turnoverRate: 'Turnover Rate',

    allATrendChart: 'All A Trend Chart',
    selectOverlayIndicators: 'Select Overlay Indicators',
    entireMarketOverlay: 'Overlay',
    indicatorSelection: 'Indicator Selection',
    noData: 'No Data',
    extremeStateAiScore: 'AI Score',
    timeWindowSelection: 'Time Window Selection',
    pleasePurchasePermission: 'Please Purchase Permission',
    coreMarketIndicators: 'Core Market Indicators',
    predictDate: 'Predict Date',
    mean: 'Mean',
    low: 'Low',
    q1: '25 quantile',
    q2: '50 quantile',
    q3: '75 quantile',
    high: 'High',
  },

  // high chart
  highChart: {
    companyName: 'JANUS AI',
    minute: 'Minute',
    all: 'All',
    from: 'From',
    to: 'To',
    zoom: 'Zoom',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    viewFullscreen: 'View Full Screen',
    exitFullscreen: 'Exit Full Screen',
    year: 'Y',
    month: 'M',
    month3: '3M',
    month6: '6M',
    yearToDate: 'YTD',
    year1: '1Y',
  },

  // 汇率
  forexView:{
    unknownCurrency: 'Unknown Currency',
    exchangeRateQuery: 'Exchange Rate Query',
    selectCurrency: 'Select Currency',
    viewTrend: 'View Trend',
    majorWorldCurrencies: 'Major World Currencies',
    exchange: 'Exchange',
    currencySelector: 'Currency Selector',

    continent: 'Continent',
    asia: 'Asia',
    europe: 'Europe',
    africa: 'Africa',
    northAmerica: 'North America',
    southAmerica: 'South America',
    oceania: 'Oceania',

    usd: 'USD',
    eur: 'EUR',
    cny: 'CNY',
    world: 'World',
    pleaseSelectCurrencyFirst: 'Please select currency first',
    bubble: 'Bubble',
    forexIndex: 'Forex Index',
    index: 'Index',
    price: 'Price',
    turnover: 'Turnover',
  },

  commodityView: {
    commodityIndex: 'Commodity Index',
    selectCommodityIndex: 'Select commodity index',
    fiveYears: '5Y',
    all: 'All',
    search: 'Search',
    noSelectedData: 'No selected data',
    maxSelections: 'You can select up to {count} items',
    open: 'Open',
    high: 'High',
    low: 'Low',
    close: 'Close',
  },

  bondView: {
    singleIndex: 'Single Index',
    multiIndexCompare: 'Multi-Index Compare',
    bondIndex: 'Bond Index',
    selectBondIndex: 'Select bond index',
    bondType: 'Bond Type',
    selectIndexType: 'Select index type',
    compensationPeriod: 'Tenor',
    selectTenor: 'Select tenor',
    fiveYears: '5Y',
    all: 'All',
    search: 'Search',
    noSelectedData: 'No selected data',
    rateTrend: 'Yield Curve Trend',
    noDailyData: 'No daily data',
    maxSelections: 'You can select up to {count} items',
    wealth: 'Wealth',
    fullPrice: 'Full Price',
    cleanPrice: 'Clean Price',
    settlementVolume: 'Settlement Volume (CNY B)',
    marketValueDuration: 'Market Value Duration (Years)',
    cashflowDuration: 'Cash Flow Duration (Years)',
    marketValueConvexity: 'Market Value Convexity',
    cashflowConvexity: 'Cash Flow Convexity',
    marketValueYtm: 'Market Value YTM (%)',
    cashflowYtm: 'Cash Flow YTM (%)',
    bpValue: 'BP Value (CNY)',
    averageCompensationPeriod: 'Average Compensation Period (Years)',
    averageCouponRate: 'Average Coupon Rate (%)',
    totalMarketValuePrevDay: 'Prev Total Market Value (CNY B)',
    wealthChangePct: 'Wealth Index Change (%)',
    fullPriceChangePct: 'Full Price Index Change (%)',
    cleanPriceChangePct: 'Clean Price Index Change (%)',
    total: 'Total',
    over10Years: '10Y+',
    years7to10: '7-10Y',
    years5to7: '5-7Y',
    years3to5: '3-5Y',
    years1to3: '1-3Y',
    under1Year: '<1Y',
    months9to12: '9-12M',
    months6to9: '6-9M',
    months3to6: '3-6M',
    months0to3: '0-3M',
    szse: 'SZSE',
    interbankMarket: 'Interbank Market',
    otcCounter: 'OTC Counter',
    offshoreOtc: 'Offshore OTC',
    sse: 'SSE',
  },

  // 指数详情
  indexFilterView: {
    SSEC: 'SSEC',
    SZI: 'SZI',
    gemIndex: 'gemIndex',
    star50: 'star50',
    gemComposite: 'gemComposite',
    SSE50: 'SSE50',
    csi300: 'csi300',
    csi500: 'csi500',
    csi1000: 'csi1000',
    csiA500: 'csiA500',
    '000001.SH': 'SSE Composite',
    '399001.SZ': 'SZSE Component',
    '399006.SZ': 'ChiNext Index',
    '000688.SH': 'STAR 50',
    '399102.SZ': 'ChiNext Composite',
    '000016.SH': 'SSE 50',
    '399300.SZ': 'CSI 300',
    '000905.SH': 'CSI 500',
    '000852.SH': 'CSI 1000',
    '000510.SH': 'CSI A500',
    '000510.CSI': 'CSI A500',
    '000985.CSI': 'CSI All Share Index',
    '931023.CSI': 'BJ 50',

    majorChinaIndex: 'Major China Index',
    majorWorldIndex: 'Major World Index',
    FTXIN9: 'FTXIN9',
    DJSH: 'DJSH',
    HK50: 'HK50',
    US500: 'US500',
    IXIC: 'IXIC',
    US2000: 'US2000',
    VIX: 'VIX',
    GSPTSE: 'GSPTSE',
    BVSP: 'BVSP',
    MXX: 'MXX',
    DE40: 'DE40',
    UK100: 'UK100',
    FCHI: 'FCHI',
    AEX: 'AEX',
    ES35: 'ES35',
    IT40: 'IT40',
    SWI20: 'SWI20',
    PSI20: 'PSI20',
    BFX: 'BFX',
    ATX: 'ATX',
    OMXS30: 'OMXS30',
    IMOEX: 'IMOEX',
    IRTS: 'IRTS',
    WIG20: 'WIG20',
    BUX: 'BUX',
    XU100: 'XU100',
    TA35: 'TA35',
    TASI: 'TASI',
    JP225: 'JP225',
    AXJO: 'AXJO',
    TWII: 'TWII',
    SETI: 'SETI',
    KS11: 'KS11',
    JKSE: 'JKSE',
    NSEI: 'NSEI',
    BSESN: 'BSESN',
    VNI30: 'VNI30',
    HSCAHPI: 'HSCAHPI',
    HSTECH: 'HSTECH',
    DJI: 'DJI',
    SPTSX: 'SPTSX',
    KLSE: 'KLSE',

    index: 'Index',
    majorIndex: 'Major Index'

  },

  // AomCorrelation.vue 全球表现
  AomCorrelationVue:{
    annualReturn: 'Annual Return',
    periodReturn: 'Period Return',
    risk: 'Risk',
    sharpe: 'Sharpe Performance',
    sortino: 'Sortino Performance',
    noDataTip: 'No Data Tip',
    quarter: '3M',
    halfYear: '6M',
    oneYear: '1Y',
    threeYear: '3Y',
    globalPerformance: 'Global Performance',
    indexCorrelation: 'Index Correlation',
    china: 'China',
    northLatinAmerica: 'North Latin America',
    europe: 'Europe',
    asiaPacific: 'Asia Pacific',
    timeWindow: 'Time Window',
    logarithmic: 'Logarithmic',
    region: 'Region',
    correlation: 'Correlation',
  },

  // 账户页面
  accountVue: {
    basic: 'Basic',
    available: 'Available',
    notActivated: 'Not Activated',
    notApplied: 'Not Applied',
    applicationUnderReview: 'Application Under Review',
    approved: 'Approved',
    rejected: 'Rejected',
    accountInfo: 'Account Information',
    username: 'Username:',
    phone: 'Phone:',
    accountStatus: 'Account Status:',
    accountTier: 'Account Tier:',
    companyAccount: 'Company Account:',
    start_time: 'start_time:',
    end_time: 'end_time:',
    sageRole: 'Sage Role:',
    applicationInformation: 'Application Information',
    nickname: 'Nickname"',
    email: 'Email:',
    company: 'Company:',
    position: 'Position:',
    referrer: 'Referrer:',
    trialStatus: 'Trial Status:',
    permission: 'Permission',
    activatedMenus: 'Activated Menus',
    activatedPredictionFeatures: 'Activated Prediction Features',
    aomPrediction: 'AOM Prediction',
    day: 'Day',
    week: 'Week',
    percentile: 'Percentile',
    fiveLevel: 'Five Level',
    noData: 'No Data',
    nonNormalDistribution: 'Non-Normal Distribution',
    normalDistribution: 'Normal Distribution',
    strength: 'AI Score',
    consistency: 'Consistency',
    liquidity: 'Liquidity',
    industryPrediction: 'Industry Prediction',
    levelRestriction: 'Level Restriction',
    stockPrediction: 'Stock Prediction',
    predictionLevel: 'Prediction Level',
    scoreType: 'Score Type',
    predictionWindow: 'Prediction Window',
    evd: 'EVD',
    scoreCategory: 'Score Category',
    dailyQueryLimit: 'Daily Query Limit',
    predictionTraceback: 'Prediction Traceback',
    number: 'No.',
    total: 'Total',
  },

  // 行业表现
  industryCorrelationVue: {
    annualReturn: 'Annual Return',
    periodReturn: 'Period Return',
    risk: 'Risk',
    sharpe: 'Sharpe Performance',
    sortino: 'Sortino Performance',
    noDataTip: 'No Data Tip',
    correlation: 'Correlation',
    industryCorrelation: 'Industry Correlation',
    quarter: '3M',
    halfYear: '6M',
    oneYear: '1Y',
    threeYear: '3Y',
    logarithmic: 'Logarithmic',
    industry: 'Industry',
    marketIndex: 'Market Index',
    primaryIndustry: 'Primary Industry',
    secondaryIndustry: 'Secondary Industry',
    tertiaryIndustry : 'Tertiary Industry',
    to: 'To',
    industryPerformance: 'Industry Performance',
    timeWindow: 'Time Window',
    kpiTips1:
      '### Industry Performance\nThe x-axis represents risk:\n- Definition: annualized dispersion of returns within the time window\n- Annualized dispersion = $\\sqrt{N_t} * std(r_t)$\n- $r_t$ = daily return\n- $N_t$ = annual trading days\n\n<br>\n\nThe y-axis represents return:\n- Definition: annualized return within the time window\n- Annualized return: $r_{yr} = r_p * M_p$\n- $r_p$ = period return\n- $M_p$ = number of periods in one year',
    kpiTips2:
      '### Sharpe Performance\n- Sharpe ratio = $(r_p - r_f)/\\sigma_p$\n- $r_p$ represents the annualized return in the time window\n- $r_f$ represents the risk-free rate, using the average 10-year government bond yield in the period\n- $\\sigma_p$ represents the annualized standard deviation of industry returns, used to measure volatility or risk\n\n<br>\n\n### Sortino Performance\n- Sortino ratio = $(r_p - r_f)/DR$\n- $r_p$ represents the annualized return in the time window\n- $r_f$ represents the risk-free rate, using the average 10-year government bond yield in the period\n- $DR$ represents downside deviation\n- Downside risk measures the degree to which investment returns fall below the risk-free rate, focusing only on negative returns and ignoring positive volatility',
    kpiTips3:
      '### Industry Correlation\nMeasures the price-movement correlation between two industries or indices, using daily log price differences as the calculation basis.\nResult range: [-1, +1]\n- Correlation = +1: price movements are fully aligned\n- Correlation = 0: the price movements of the two industries or indices are independent\n- Correlation = -1: price movements are fully opposite\n\n<br>\n\nCalculation notes:\n- When estimating a correlation matrix, the sample size (N) is often smaller than the number of assets (P), so estimates can be overly sensitive to input data or become ill-conditioned.\n- To address this, the standard method in finance is to use shrinkage algorithms to reduce the volatility of estimated correlation coefficients. A common method is the Ledoit-Wolf Method.\n- Jitai\'s correlation matrix uses an improved shrinkage method. Compared with Ledoit-Wolf, it is more stable under N << P conditions, and the matrix is post-processed with principal component analysis to further reduce the impact of market noise on estimates.',
    kpiTips4: '- Click an industry-level button to filter and highlight the corresponding industries or market indices. Click again to restore the full view.'
  },

  // 行业地图
  indusTreeMapVue: {
    comparedToPreviousDay: 'T-1',
    score: 'Score',
    turnover: 'Turnover',
    billion: 'B',
    mvFloat: 'MV_float',
    trillion: 'Trillion',
    doubleClickHint: '(Double-clickable)',
    all: 'All',
    predictionScoreMap: 'Prediction Score Map',
    priceVolumeMap: 'Price Volume Map',
    valuationMetricsMap: 'Valuation Metrics Map',
    fundFlowMap: 'Fund Flow Map',
    industry: 'Industry',
    filterPanel: 'Filter Panel',
    metricCategory: 'Metric Category',
    heatTreemap: 'Heat Treemap',
    mapArea: 'Map Area',
    timeWindow: 'Window',
    day: 'Day',
    kpiTips1: '- Map Area controls the sizing basis of industry blocks in the heat treemap.\n- Float Market Cap: size by industry float market cap.\n- Turnover: size by industry turnover.',
    kpiTips2: '- The Industry Prediction Score Map shows industry score distribution across dimensions such as strength, liquidity, and crowding.',
    kpiTips3: '- The Industry Valuation Metrics Map shows cross-sectional distribution across valuation dimensions such as PE, PB, PS, and dividend yield.',
    kpiTips4: '- The Industry Fund Flow Map shows changes across dimensions such as leveraged flow, short-selling flow, major shareholder accumulation, and trading crowding.',
    industryPredictionScoreMap: 'Industry Prediction Score Map',
    strengthWithTimeOption: 'Strength',
    liquidityWithTimeOption: 'Liquidity',
    crowdingWithTimeOption: 'Crowding',
    timeOptional: 'Time Optional',
    industryPriceVolumeMap: 'Industry Price Volume Map',
    changePercentWithTimeOption: 'Change Percent (Time Optional)',
    turnoverRateWithTimeOption: 'Turnover Rate (Time Optional)',
    changePercent: 'Change Percent',
    turnoverRate: 'Turnover Rate',
    industryValuationMetricsMap: 'Industry Valuation Metrics Map',
    pe: 'PE',
    peTtm: 'PE-TTM',
    pb: 'PB',
    ps: 'PS',
    psTtm: 'PS-TTM',
    dv: 'DV',
    dvTtm: 'DV-TTM',
    industryFundFlowMap: 'Industry Fund Flow Map',
    leveragedFundFlowSpeedT1: 'Leveraged Fund Flow Speed T-1',
    leveragedPositionRatioT1: 'Leveraged Position Ratio T-1',
    shortSellingFundFlowSpeedT1: 'Short Selling Fund Flow Speed T-1',
    shortSellingPositionRatioT1: 'Short Selling Position Ratio T-1',
    majorShareholderNetIncrease: 'Major Shareholder Net Increase',
    totalFundInflowSpeed: 'Total Fund Inflow Speed',
    largeFundInflowSpeed: 'Large Fund Inflow Speed',
    smallFundInflowSpeed: 'Small Fund Inflow Speed',
    tradingCrowding: 'Trading Crowding',
    noData: 'No Data',
    pleasePurchasePermission: 'Please Purchase Permission',
    level: 'Level',
    times: 'x',
  },

  // 趋势预测
  industryTendencyVue:{
    title:'Weekly Industry Trend Forecast',
    strength:'AI Score',
    crowding:'Crowding',
    crowded:'Crowded',
    relaxed:'Relaxed',
    strong:'Strong',
    weak:'Weak',
    marketValue:'Market Value',
    kpiTips1:'- Circle size: log of market capitalization. \n- Brightest circle: JANUS AI’s latest prediction for the coming week for the Shenwan Level-1 (L1) industry. \n- Fainter circles: weekly prediction history; the older the prediction, the lighter the color. \n- On hover: highlight the current L1 industry and connect its circles with a line to show the historical prediction trajectory.',
    kpiTips2:'- JANUS AI’s ranking of predicted relative strength for Shenwan Level-1 industries over the next week.',
    kpiTips3:'-JANUS AI’s ranking of predicted crowding for Shenwan Level-1 industries over the next week.',
    noData:'No data. Please try again later.',
    doubleClickHint: '(Double-clickable)',
    trillion: 'Trillion',
  },

  // 行业筛选
  industryFilterVue: {
    primaryIndustry: 'Primary Industry',
    secondaryIndustry: 'Secondary Industry',
    tertiaryIndustry : 'Tertiary Industry',
    searchHint: 'Search L1 and L2 industries above.',
    noTopData: 'No Top Data',
    swL1: 'sw-l1 ',
    last: 'Last',
    day: 'Day',
    change: 'Change',
    turnoverRate: 'Turnover Rate',
  },

  // 行业详情
  industryViewVue: {
    mshInflowTotal: 'msh_inflow_total',
    mshOutflowTotal: 'msh_inflow_total',
    w: ' 10K',
    buy: 'buy',
    sell: 'sell',
    ssSellTotal: 'ss_sell_total',
    ssRepurchaseTotal: 'ss_repurchase_total',
    lb: 'lb',
    ssFlow: 'ss_Flow',
    mshFlow: 'msh_flow',
    snFlow: 'sn_flow',
    mfVelocity: 'mf_velocity',
    tradeCongestionIndex: 'trade_congestion_index',
    lbPositionRatio: 'lb_position_ratio',
    lbFlow: 'lb_flow',
    lbFlowNet: 'lb_flow_net',
    ssFlowNet: 'ss_flow_net',
    mshFlowNet: 'msh_flow_net',
    mfDirectionLrg: 'mf_direction_lrg',
    mfDirectionSml: 'mf_direction_sml',
    mfVelocityLrg: 'mf_velocity_lrg',
    mfVelocitySml: 'mf_velocity_sml',
    MA5: 'MA5',
    MA14: 'MA14',
    priceChannel: 'price_channel',
    BBands: 'BBands(20,2)',
    marginBuyRepay: 'Margin Buy Repay',
    marginNetBuy: 'Margin Net Buy',
    noData: 'No data. Please try again later.',
    strength: 'AI Score',
    conviction: 'Conviction',
    liquidity: 'Liquidity',
    level: 'Level',
    day: 'Day',
    forecastDate: 'Forecast',
    industryIndex: 'Industry Index',
    open: 'Open',
    high: 'High',
    low: 'Low',
    close: 'Close',
    turnover: 'Turnover',
    percentile: '{percentile} Percentile',
    predictedTurnover: 'Predicted Turnover',
    predictedPrice: 'Predicted Price',
    ungrouped: 'Ungrouped',
    all: 'All',
    previousClose: 'Previous Close',
    price: 'Price',
    TimestampAlreadyExistsSkippingPush: 'timestamp already exists,skipping push',
    prediction: 'Prediction',
    constituents: 'Constituents',
    industry: 'Industry',
    IncludeL2: 'Include L2',
    addToWatchlist: 'Add to Watchlist',
    intraday: 'Intraday',
    dailyKLine: 'Daily K',
    selectOverlayIndicator: 'Select Overlay Indicator',
    selectIndustryOverlayIndicator: 'Select Industry Overlay Indicator',
    color: 'Color',
    logarithmic: 'Logarithmic',
    SelectIndicators: 'Select Indicators',
    JANUSAIPredictionScore: 'AI Score',
    NoData: 'NoData',
    SelectTimeWindow: 'select time window',
    pleasePurchasePermission: 'Please Purchase the Required Permissions',
    tradeDate: 'Trade Date',
    mvTotal: 'mv_total',
    avgMvTotal: 'avg_mv_total',
    dy: 'dy',
    pe: 'pe',
    ps: 'ps',
    turnoverRateE: 'turnover_Rate_e',
    companyNumber: 'Company Number',
    mvFloat: 'mv_float',
    avgMvFloat: 'avg_mv_float',
    dyTTM: 'dy_TTM',
    peTTM: 'pe_TTM',
    psTTM: 'ps_TTM',
    pb: 'pb',
    times: 'times',
    billion: 'B',
    kpiTips: `
### AI Relative Strength Index
**Definition:** A score that measures the probability that a company or industry will outperform the market in the future.
It is computed as the difference between the expected return (mean logged return) of the covered companies on the current cross-sectional date and the expected return of the A-share market over the same period.
A score above 50: the future horizon is expected to outperform the market.
A score below 50: the future horizon is expected to underperform the market.
<br>
### AI Relative Trend Confidence Index
**Definition:** A score that measures how confident the AI is in the future trend of a company or industry.
It is computed based on expected volatility (higher volatility implies lower prediction confidence) and the expected range between price extremes (a larger range implies greater uncertainty in the prediction).
A score above 50: the AI’s confidence in the future trend is better than the market average.
A score below 50: the AI’s confidence in the future trend is worse than the market average.
<br>
### AI Liquidity Forecast Index
**Definition:** A score that measures whether the AI expects future liquidity for a company or industry to be relatively loose or tight.
It is computed based on the expected liquidity expressed as a multiple of historical liquidity (the larger the multiple, the better the expected future liquidity).
A score above 50: future liquidity is expected to be better than the market average.
A score below 50: future liquidity is expected to be worse than the market average.
<br>
### Small number after the score
Indicates: the change in the score compared with the previous day.
`,
    kpiTips2: `
#### Leverage funds:
  - Shows the inflow and outflow trends of margin financing (leveraged funds).
  - <br/>

#### Reverse repo funds:
  - Calculation logic:
  - Reverse repo funds = total amount of repos maturing on the day − total amount of newly initiated repos on the day.
  - Coverage: SSE reverse repo GCXXX series and SZSE reverse repo R-XXX series.
  - Maturity coverage: 1–28 days.
  - Positive value: reverse repo funds are flowing into the market.
  - Negative value: reverse repo funds are flowing out of the market (used to purchase reverse repos).
  - <br/>

#### Short-selling funds (stock lending):
  - Shows the trend of funds used for stock borrowing / short selling.
  - <br/>

#### Controlling shareholders’ stake changes:
  - Above the zero line (red): increases in holdings by controlling shareholders.
  - Below the zero line (green): reductions in holdings by controlling shareholders.
  - <br/>
  
#### Southbound and northbound funds:
  - Blue: southbound funds.
  - Orange: northbound funds.
  - Definitions:
    - Southbound funds:
      - Funds from mainland investors buying Hong Kong-listed stocks via Shanghai–Hong Kong and Shenzhen–Hong Kong Stock Connect.
      - Direction of capital flow: north → south (into the Hong Kong market).
    - Northbound funds:
      - Hong Kong and international funds flowing into A-shares via Shanghai and Shenzhen Stock Connect.
      - Direction of capital flow: south → north (into the A-share market).
`,
  },

  // top 20
  industryTopVue: {
    kpiTips3: '### Target Price\n- Compares the target price range issued by rating agencies over the past year with the stock price.\n- The target low, target high, and target average are all based on the average over the past 60 trading days.',
    kpiTips4: '### Rating Distribution\n- Shows the distribution of institutional ratings on the stock over the past three months and compares it with the average rating mix of all stocks in its L2 industry.\n- Nearly one hundred rating labels are normalized into: Strong Buy, Buy, Hold, Sell, and Strong Sell.',
    tableTitleTop20: 'Top 20 Constituents',
    columnName: 'Name',
    mvTotal: 'Market Cap',
    mvTotalRatio: 'Market Cap Weight',
    columnClose: 'Price',
    pctChg: 'Performance',
    pctChg7: '1W Performance',
    pctChg30: '1M Performance',
    pctChg90: '1Q Performance',
    pctChg365: '1Y Performance',
    turnoverRateF: 'Turnover Rate',
    pe: 'pe',
    peTtm: 'pe(ttm)',
    dvRatio: 'Dividend Yield (div%)',
    dvTtm: 'Dividend Yield (ttm)',
    billion: 'B',
  },

  // tickerFilter.vue
  tickerFilterVue: {
    turnoverRateFAvg: 'Turnover Rate',
    pctChg: 'Return',
    pctChgAnnlzd: 'Annualized Return',
    ssFlowNetSum: 'Margin and Short Interest',
    mfAmtAllSum: 'Fund Flow',

    opIncome: 'Operating Revenue Growth',
    netProfit: 'Net Profit Growth',
    roe: 'ROE Growth',
    roa: 'ROA Growth',

    volatility: 'Volatility',
    volatilityAnnlzd: 'Annualized Volatility',
    semiDev: 'Downside Deviation',
    maxDrawDownType2: 'Period Max Drawdown',
    sharpe: 'Sharpe Ratio',
    sortino: 'Sortino Ratio',
    calmarType1: 'Calmar Ratio',
    calmarType2: 'Period Calmar Ratio',
    beta: 'Beta',

    afaf: 'Agriculture, Forestry, Animal Husbandry and Fishery',
    agriculture: 'Agriculture',
    forestry: 'Forestry',
    animalHusbandry: 'Animal Husbandry',
    fishery: 'Fishery',
    marketValue: 'Market Value',
    billion: 'B',
    billionDown: 'B and Below',
    billionUp: 'B and Above',
    rank: 'Rank',
    top: 'Top',
    bottom: 'Bottom',
    week: 'W',
    pastWeek: 'Past Week',
    loss: 'Loss',
    below: 'Below',
    above: 'Above',
    mvFloat: 'Float Market Cap',
    upcomingEarnings: 'Upcoming Earnings',
    mshFlow: 'Major Shareholder Change',
    past1m: 'Past 1M',
    InstitutionalRating: 'Institutional Rating',
    ratingCount: 'Rating Count',
    Non: 'None',
    times: ' Times',
    swIndustry: 'SW Industry',
    unlimited: 'All',
    swIndustryPlaceholder: 'Select SW Industry',
    indexConstituents: 'Index Constituents',
    marketBoard: 'Market Board',
    crossSectionMetrics: 'Cross-sectional Metrics',
    stageSorting: 'Stage Sorting',
    keyword: 'Keyword',
    keywordPlaceholder: 'Enter keyword',
    selectedTags: 'Selected Tags',
    clearAll: 'Clear All',
    filterResult: 'Filter Results',
    resultHint: 'Results update dynamically with selected tags',
    pe: 'P/E',
    pb: 'P/B',
    ps: 'P/S',
    dividendYield: 'Dividend Yield',
    stockName: 'Stock Name',
    industryBelonging: 'Industry',
    closePrice: 'Close Price',
    change: 'Change',
    dividendYieldTtm: 'Dividend Yield TTM',
    totalMarketCap: 'Total Market Cap',
    totalShares: 'Total Shares',
    floatShares: 'Float Shares',
    shareUnit: ' Shares',
    shareUnit10k: ' K Shares',
    oneDay: '1D',
    oneWeek: '1W',
    oneMonth: '1M',
    sixMonths: '6M',
    oneYear: '1Y',
    avgTurnoverRate: 'Average Turnover Rate',
    fundInOut: 'Fund In/Out',
    marginFinancingAndSecuritiesLending: 'Margin Financing and Securities Lending',
    maxDrawdownL2: 'Period Max Drawdown',
    calmarL2: 'Period Calmar Ratio',
    oneYearCagr: '1Y CAGR',
    threeYearCagr: '3Y CAGR',
    fetchLastTradingDayFailed: 'Failed to fetch the latest trading day',
    fetchTickerDataFailed: 'Failed to fetch ticker filter data',
  },

  // tickerViewVue
  tickerViewVue: {
    past2Y: 'Past 2Y',
    past5Y: 'Past 5Y',
    past10Y: 'Past 10Y',
    all: 'All',
    mshInflowTotal: 'msh_inflow_total',
    yuan: 'yuan',
    mshOutflowTotal: 'msh_out_flow_total',
    buy: 'buy',
    sell: 'sell',
    ssSellTotal: 'ss_sell_total',
    ssRepurchaseTotal: 'ss_repurchase_total',
    lb: 'lb',
    ssFlow: 'ss_flow',
    mshFlow: 'msh_flow',
    snFlow: 'sn_flow',
    mfVelocity: 'mf_velocity',
    tradeCongestionIndex: 'trade_congestion_index',
    lbPositionRatio: 'lb_position_ratio',
    lbFlow: 'lb_flow',
    lbFlowNet: 'lb_flow_net',
    ssFlowNet: 'ss_flow_net',
    mshFlowNet: 'msh_flow_net',
    mfDirectionLrg: 'mf_direction_lrg',
    mfDirectionSml: 'mf_direction_sml',
    mfVelocityLrg: 'mf_velocity_lrg',
    mfVelocitySml: 'mf_velocity_sml',
    financing: 'Financing',
    billion: 'B',
    marginNetBuy: 'Margin Net Buy',
    l1: ' (L1)',
    l2: ' (L2)',
    scoreDeltaUnit: ' pts',
    strength: 'AI Score',
    conviction: 'Conviction',
    liquidity: 'Liquidity',
    level: 'Level',
    day: 'Day',
    NoFinancingData: 'No Financing Data',
    forecastDate: 'Forecast',
    price: 'Price',
    predictedPrice: 'Predicted Price',
    percentile: 'Percentile',
    event: 'Event',
    trade: 'Trade',
    total: 'Total',
    records: 'Records (Click to View)',
    assets: 'Assets',
    sentiment: 'Sentiment',
    financialReport: 'Financial Report',
    change: 'Change',
    open: 'Open',
    high: 'High',
    low: 'Low',
    close: 'Close',
    turnover: 'Turnover',
    predictedTurnover: 'Predicted Turnover',
    kpiTips: `
### AI Relative Strength Index
**Definition:** A score that measures the probability that a company will outperform the market in the future.
It is computed as the difference between the company’s expected return (mean logged return) on the current cross-sectional date and the expected return of the A-share market over the same period.
Above 50: expected to outperform the market over the future horizon.
Below 50: expected to underperform the market over the future horizon.
<br>
### AI Relative Trend Confidence Index
**Definition:** A score that measures how confident the AI is in the company’s future trend.
It is computed from expected volatility and the expected range of price extremes.
Above 50: AI confidence in the future trend is better than the market average.
Below 50: AI confidence in the future trend is worse than the market average.
<br>
### AI Liquidity Forecast Index
**Definition:** A score that measures whether AI expects future liquidity to be relatively loose or tight.
It is computed from expected liquidity as a multiple of historical liquidity.
Above 50: expected future liquidity is better than the market average.
Below 50: expected future liquidity is worse than the market average.
<br>
### Small number after the score
Indicates the score change versus the previous day.
`,
    kpiTips1: `
### Valuation Metrics
- Shows the distribution of the stock’s valuation metrics over the past year.
- <br>

- Outlier handling:
$ IQR = Q_{75} - Q_{25} $
$ \\text{Upper} = Q_{75} + 3 \\times IQR $
$ \\text{Lower} = Q_{25} - 3 \\times IQR $
`,
    kpiTips2: `
#### Leverage funds:
  - Shows the inflow and outflow trend of margin financing funds.
  - <br/>

#### Reverse repo funds:
  - Calculation logic
  - Reverse repo funds = maturing repo amount on the day - newly initiated repo amount on the day
  - Coverage: SSE reverse repo GCXXX series and SZSE R-XXX series
  - Maturity coverage: 1 - 28 days
  - Positive value: reverse repo funds flow into the market.
  - Negative value: reverse repo funds flow out of the market.
  - <br/>

#### Short-selling funds:
  - Shows the trend of securities lending / short-selling funds.
  - <br/>

#### Major shareholder stake changes:
  - Above zero line (red): shareholder increased holdings.
  - Below zero line (green): shareholder reduced holdings.
  - <br/>

#### Southbound / Northbound funds:
  - Blue: Southbound funds.
  - Orange: Northbound funds.
  - Definition:
    - Southbound funds:
      - Mainland investors buying Hong Kong-listed shares via Stock Connect.
      - Flow direction: North -> South.
    - Northbound funds:
      - Hong Kong and international capital flowing into A-shares via Stock Connect.
      - Flow direction: South -> North.
`,
    ungrouped: 'Ungrouped',
    loss: 'Loss',
    past1y: 'Past 1Y',
    lowest: 'Lowest',
    current: 'Current',
    q75: '75th percentile',
    q50: '50th percentile',
    q25: '25th percentile',
    prevClose: 'Prev Close',
    forecast: 'Forecast',
    rating: 'Rating',
    shareholder: 'Shareholder',
    stock: 'Stock',
    highest: 'Highest',
    limitUp: 'Limit Up',
    limitDown: 'Limit Down',
    volume: 'Volume',
    addToWatchlist: 'Add to Watchlist',
    intraday: 'Intraday',
    dailyKLine: 'Daily K',
    selectOverlayIndicator: 'Select Overlay Indicator',
    selectIndustryOverlayIndicator: 'Select Industry Overlay Indicator',
    color: 'Color',
    logarithmic: 'Logarithmic',
    resetView: 'Reset',
    fullscreen: 'Fullscreen',
    selectIndicators: 'Select Indicators',
    JANUSAIPredictionScore: 'AI Score',
    NoData: 'NoData',
    reachedLimit: 'You have reached the limit for single-stock prediction searches.',
    selectTimeWindow: 'Select Time Window',
    pleasePurchasePermission: 'Please Purchase the Required Permissions',
    mvTotal: 'mv_total',
    turnoverRate5d: '5d turnover rate',
    mvFloat: 'mv_float',
    turnoverRate20d: '20d turnover rate',
    valuationMetrics: 'Valuation Metrics',
    orderBook: 'Order Book',
    bid: 'Bid',
    ask: 'Ask',
    bid1: 'Bid',
    ask1: 'Ask',
    listingBoard: 'Listing Board',
    exchange: 'Exchange',
    listingDate: 'Listing Date',
    region: 'Region',
    employeeCount: 'Employee Count',
    companyWebsite: 'Company Website',
    actualController: 'Actual Controller',
    actualControllerType: 'Actual Controller Type',
    legalRep: 'Legal Rep',
    generalManager: 'General Manager',
    boardSecretary: 'Board Secretary',
    mainBusiness: 'Main Business',
    forward: 'Forward',
    backward: 'Backward',
    noAdjustment: 'No Adjustment',
    introduction: 'Introduction',
    w: '10K',
    gu: 'shares',
    timestampAlreadyExistsSkippingPush: 'timestamp already exists,skipping push',
  },
    highchartStockToolsVue: {
      indicator: 'Indicator',
    sma: 'Simple Moving Average',
    ema: 'Exponential Moving Average',
    bb: 'Bollinger Bands',
    period: 'Period',
    add: 'Add',
    color: 'Color',
    width: 'Width',
    save: 'Save',
    shapes: 'Shapes',
    label: 'Label',
    circle: 'Circle',
    rectangle: 'Rectangle',
    ellipse: 'Ellipse',
    lines: 'Lines',
    segment: 'Segment',
    arrowSegment: 'Arrow Segment',
    ray: 'Ray',
    arrowRay: 'Arrow Ray',
    line: 'Line',
    arrowLine: 'Arrow Line',
    horizontalLine: 'Horizontal Line',
    verticalLine: 'Vertical Line',
    crookedLines: 'Crooked Lines',
    elliott3: 'Elliott 3',
    elliott5: 'Elliott 5',
    crooked3: 'Crooked 3',
    crooked5: 'Crooked 5',
    measure: 'Measure',
    measureXY: 'Measure XY',
    measureX: 'Measure X',
    measureY: 'Measure Y',
    advanced: 'Advanced',
    fibonacci: 'Fibonacci',
    pitchfork: 'Pitchfork',
    parallelChannel: 'Parallel Channel',
    seriesType: 'Series Type',
      lineChart: 'Line Chart',
      candlestick: 'Candlestick'
    },

    tickerRatingVue: {
      targetPrice: 'Target Price',
      targetPriceTip1: 'Compare the target price range given by rating institutions over the past year with the stock price.',
      targetPriceTip2: 'The target low, high, and average prices are all 60-trading-day averages.',
      ratingDistribution: 'Rating Distribution',
      ratingDistributionTip1: 'Show the rating mix for the stock over the past 3 months and compare it with the average mix of all stocks in its level-2 industry.',
      ratingDistributionTip2: 'Nearly one hundred rating names are normalized into Strong Buy, Buy, Hold, Sell, and Strong Sell.',
      strongBuy: 'Strong Buy',
      buy: 'Buy',
      hold: 'Hold',
      sell: 'Sell',
      strongSell: 'Strong Sell',
      industryAverage: 'Average',
      targetPriceRange: 'Target Price Range',
      targetAveragePrice: 'Average Target Price',
      price: 'Price',
      past1Year: '(Past 1 Year)',
      ratingDistributionPercent: 'Rating Distribution %',
      past3Months: '(Past 3 Months)',
      ratingChange: 'Rating Change',
      totalAnalystsFor: 'A total of ',
      analystsRated: ' analysts rated ',
      analystsRatedIndustry: ' analysts rated companies in the industry ',
      upgraded: 'Upgraded',
      downgraded: 'Downgraded',
      maintained: 'Maintained',
      institutions: '',
      ratingDetails: 'Rating Details',
      institutionName: 'Institution',
      analystName: 'Analyst',
      initialRating: 'Initial Rating',
      targetPriceLower: 'Target Price Lower',
      targetPriceUpper: 'Target Price Upper',
      ratingChangeColumn: 'Rating Change',
      newRating: 'New Rating',
      previousRating: 'Previous Rating',
      tradeDate: 'Trade Date'
    },

    tickerValuationVue: {
      valuation: 'Valuation',
      valuationTip1: 'Compare the current stock valuation with the valuations of its level-1 and level-2 industries.',
      valuationOutlierHandling: 'Valuation Outlier Handling',
      upperLimit: 'Upper Limit',
      lowerLimit: 'Lower Limit',
      targetPrice: 'Target Price',
      targetPriceTip1: 'Compare the target price range given by rating institutions over the past year with the stock price.',
      targetPriceTip2: 'The target low, high, and average prices are all 60-trading-day averages.',
      low: 'Low',
      percentile25: '25th Percentile',
      percentile50: '50th Percentile',
      percentile75: '75th Percentile',
      high: 'High',
      loss: 'Loss',
      l2Average: 'L2 Average',
      l2Valuation: 'L2 Valuation',
      operation: 'Operation',
      growth: 'Growth',
      risk: 'Risk',
      l2Industry: 'L2 Industry',
      trendLine: 'Trend Line',
      observations: 'Observations',
      powerDetails: 'Power Details',
      investmentAmount: 'Investment Amount',
      repaymentAmount: 'Repayment Amount',
      comparedWithIndustry: '(Compared with Industry)',
      level1Industry: 'Level-1 Industry: ',
      level2Industry: 'Level-2 Industry: ',
      valuationAnalysis: 'Valuation Analysis',
      beforeAdjustment: 'Before Adjustment',
      afterAdjustment: 'After Adjustment',
      enterpriseValue: 'Enterprise Value',
      past1Year: '(Past 1 Year)',
      past3Months: '(Past 3 Months)',
      powerItems: 'Power Items',
      power: 'Power',
      powerTrend: 'Power Trend'
    },
  
  
    // tickerFrVue
    tickerFrVue: {
      overview: 'Overview',
      annualReport: 'Annual',
      quarterlyReport: 'Quarterly',
      profit: 'Profit',
      netProfitShort: 'Net Profit',
      totalRevenueShort: 'Revenue',
      industryNetProfit: 'Industry Net Profit',
      industryTotalRevenue: 'Industry Revenue',
      yoyGrowth: 'YoY Growth',
      threeYearCagr: '3Y CAGR',
      qoqGrowth: 'QoQ Growth',
      cashFlow: 'Cash Flow',
      operatingNetCashFlow: 'Operating Net Cash Flow',
      freeCashFlow: 'Free Cash Flow',
      industryOperatingNetCashFlow: 'Industry Operating Net Cash Flow',
      industryFreeCashFlow: 'Industry Free Cash Flow',
      assetsAndLiabilities: 'Assets & Liabilities',
      ownerEquity: 'Owner Equity',
      totalAssetsShort: 'Total Assets',
      industryOwnerEquity: 'Industry Owner Equity',
      industryTotalAssets: 'Industry Total Assets',
      incomeStatement: 'Income Statement',
      cashFlowStatement: 'Cash Flow Statement',
      balanceSheet: 'Balance Sheet',
      plsTrend: 'Income Statement Trend',
      past5Years: '(Past 5 Years)',
      past3Years: '(Past 3 Years)',
      plsBreakdown: 'Income Statement Breakdown',
      revenueDistribution: 'Revenue Distribution',
      annualOnly: 'Annual Reports Only',
      costDistribution: 'Cost Distribution',
      plsDetails: 'Income Statement Details',
      subject: 'Subject',
      cashFlowTrend: 'Cash Flow Trend',
      cashFlowBreakdown: 'Cash Flow Breakdown',
      cashInDistribution: 'Cash Inflow Distribution',
      cashOutDistribution: 'Cash Outflow Distribution',
      cfsDetails: 'Cash Flow Statement Details',
      bssTrend: 'Balance Sheet Trend',
      bssBreakdown: 'Balance Sheet Breakdown',
      assetDistribution: 'Asset Distribution',
      liabilityDistribution: 'Liability Distribution',
      bssDetails: 'Balance Sheet Details',
      dupontAnalysis: 'DuPont Analysis',
      salesExpenseShort: 'Sales',
      rdExpenseShort: 'R&D',
      adminExpenseShort: 'Admin',
      financeExpenseShort: 'Finance',
      operatingCostShort: 'Operating Cost',
      profitTrendTab: 'Profit Trend',
      costTrendTab: 'Cost Trend',
      totalOperatingRevenue: 'Total Operating Revenue',
      grossProfit: 'Gross Profit',
      salesExpense: 'Selling Expense',
      rdExpense: 'R&D Expense',
      adminExpense: 'Admin Expense',
      financeExpense: 'Finance Expense',
      netCashFlowTab: 'Net Cash Flow',
      essentialSpendingTab: 'Essential Spending',
      singleFlowTab: 'Single Inflow/Outflow',
      investingNetCashFlow: 'Investing Net Cash Flow',
      financingNetCashFlow: 'Financing Net Cash Flow',
      cashFlowNode: 'Cash Flow',
      operatingInflow: 'Operating Inflow',
      investingInflow: 'Investing Inflow',
      financingInflow: 'Financing Inflow',
      exchangeRateCashEffect: 'FX Cash Effect',
      otherCashEffect: 'Other Cash Effects',
      operatingOutflow: 'Operating Outflow',
      investingOutflow: 'Investing Outflow',
      financingOutflow: 'Financing Outflow',
      netCashIncrease: 'Net Cash Increase',
      currentAssets: 'Current Assets',
      nonCurrentAssets: 'Non-current Assets',
      currentLiabilities: 'Current Liabilities',
      nonCurrentLiabilities: 'Non-current Liabilities',
      totalLiabilitiesShort: 'Total Liabilities',
      assetsRoot: 'Assets',
      liabilitiesRoot: 'Liabilities',
      ownerEquityRoot: 'Owner Equity',
      details: 'Details',
      mainBusiness: 'Main Business',
      payGoodsAndServices: 'Goods and Services Paid',
      salaryShort: 'Payroll',
      cashTaxRefund: 'Tax Refund Received',
      otherOperatingInflow: 'Other Operating Inflow',
      investmentRecovery: 'Investment Recovery',
      assetDisposalShort: 'Asset Disposal',
      disposeSubsidiary: 'Subsidiary Disposal',
      otherInvestment: 'Other Investment',
      receiveInvestment: 'Equity Financing',
      obtainBorrowing: 'Borrowings Received',
      otherFinancing: 'Other Financing',
      bondIssuanceIncome: 'Bond Issuance',
      taxPayments: 'Tax Payments',
      otherOperatingExpense: 'Other Operating Expense',
      purchaseAssets: 'Asset Purchase',
      investmentSpending: 'Investment Spending',
      acquireSubsidiary: 'Subsidiary Acquisition',
      otherInvestmentExpense: 'Other Investment Expense',
      debtRepaymentShort: 'Debt Repayment',
      dividendAndInterest: 'Dividends and Interest',
      otherFinancingExpense: 'Other Financing Expense',
      billion: 'B',
      w: '10K',
    //  PLS
    totalOpIncomeY: 'first、total_op_income(yuan)',
    oiGrossRevY: 'of which：oi_gross_rev(yuan)',
    opCoreExpense: 'second、op_core_expense(yuan)',
    oeCogsY: 'of which：oe_cogs(yuan)',
    oeSellingExpenseY: 'oe_selling_expense(yuan)',
    oeRdExpenseY: 'oe_rd_expense(yuan)',
    oeAdminExpenseY: 'oe_admin_expense(yuan)',
    oeExplorationExpense: 'oe_exploration_expense(yuan)',
    oeFinanceExpenseY: 'oe_finance_expense(yuan)',
    oeFeInterestExpense2019: 'of which：oe_fe_interest_expense',
    oeFeTnterestIncome2019: 'of which：oe_fe_tnterest_income',
    oeInterestExpense: 'oe_interest_expense(yuan)',
    oeSalesTaxY: 'oe_sales_tax(yuan)',
    oeFeeCommissionExpense: 'oe_fee_commission_expense(yuan)',
    opCapitalGainLoss: 'third、op_capital_gain_loss',
    netFairValueGain: 'add：net_fair_value_gain(yuan)',
    investmentIncomeY: 'investment_income(yuan)',
    investmentIncome: 'investment_income',
    investmentIncomeAssocJoint: 'of which：investment_income_assoc_joint(yuan)',
    assetDisposalGain: 'asset_disposal_gain',
    assetImpairmentLoss: '资产减值损失-营业总成本(yuan)',
    assetImpairmentLoss2019: 'asset_impairment_loss2019',
    exchangeGain: 'exchange_gain(yuan)',
    netHedgingGain: 'net_hedging_gain',
    otherItemsOpProfit: 'other_items_op_profit(yuan)',
    oiNonMainBusiness: 'oi_non_main_business',
    opProfitY: 'fourth、op_profit(yuan)',
    subsidy: 'add：subsidy(yuan)',
    nonOpIncomeY: 'non_op_income(yuan)',
    nonCurrAssetDisposalGain: 'of which：non_curr_asset_disposal_gain(yuan)',
    nonOpExpense: 'less：non_op_expense(yuan)',
    nonCurrAssetDisposalLoss: 'of which：non_curr_asset_disposalLoss(yuan)',
    otherItemsTotalProfit: 'add：other_items_total_profit(yuan)',
    ebtY: 'fifth、ebt(yuan)',
    incomeTaxY: 'less：income_tax(yuan)',
    otherItemsNetProfit: 'add：other_itemsNet_profit(yuan)',
    netProfitY: 'sixth、net_profit(yuan)',
    classificationByContinuityOfOperations: '(first)classification_by_continuity_of_operations',
    continuousNetProfit: 'continuous_net_profit',
    discontinuedNetProfit: 'discontinued_net_profit',
    classificationByOwnership: '(second)classification_by_ownership',
    netProfitParentCompany: 'net_profit_parent_company(yuan)',
    minorityInterest: 'minority_interest(yuan)',
    eps: 'seventh、eps',
    basicEps: 'basic_eps',
    dilutedEps: 'diluted_eps',
    netOtherIncome: 'net_other_income(yuan)',
    totalComprehensiveIncome: 'total_comprehensive_income(yuan)',
    cincomeParent: 'of which：cincome_parent(yuan)',
    cincomeMinority: 'of which：cincome_minority(yuan)',

    // CFS
    cashFlowsFromOperatingActivities: 'first、cash_flows_from_operating_activities',
    netCashOpActivity: 'net_cash_op_activity(yuan)',
    totalCashinOpActivity: 'total_cashin_op_activity(yuan)',
    cashinSales: 'cashin_sales(yuan)',
    cashinTaxRefundY: 'cashin_tax_refund(yuan)',
    cashinOtherOpActivity: 'cashin_other_op_activity(yuan)',
    totalCashoutOpActivity: 'total_cashout_op_activity(yuan)',
    cashoutGoodsService: 'cashout_goods_service(yuan)',
    cashoutSalary: 'cashout_salary(yuan)',
    cashoutTaxesY: 'cashout_taxes(yuan)',
    cashoutOtherOpActivity: 'cashout_other_op_activity(yuan)',
    cashFlowsFromInvestingActivities: 'second、cash_flows_from_investing_activities',
    netCashInvestment: 'net_cash_investment(yuan)',
    totalCashinInvestment: 'total_cashin_investment(yuan)',
    cashinDivestment: 'cashin_divestment(yuan)',
    cashinInvestmentIncome: 'cashin_investment_income(yuan)',
    netCashAssetDisposal: 'net_cash_asset_disposal(yuan)',
    netCashSubsidSale: 'net_cash_subsid_sale(yuan)',
    cashinOtherInvestment: 'cashin_other_investment(yuan)',
    totalCashoutInvestment: 'total_cashout_investment(yuan)',
    cashoutAssetPurchase: 'cashout_asset_purchase(yuan)',
    cashoutInvestment: 'cashout_investment(yuan)',
    netCashSubsidAcquire: 'net_cash_subsid_acquire(yuan)',
    cashoutOtherInvestment: 'cashout_other_investment(yuan)',
    cashFlowsFromFinancingActivities: 'third、cash_flows_from_financing_activities',
    netCashFinancing: 'net_cash_financing(yuan)',
    totalCashinFinancing: 'total_cashin_financing(yuan)',
    cashinInvestors: 'cashin_investors(yuan)',
    cashinInvestorsSubsidMinority: 'of which：cashin_investors_subsid_minority(yuan)',
    cashinBorrowing: 'cashin_borrowing(yuan)',
    cashinBondIssuance: 'cashin_bond_issuance(yuan)',
    cashinOtherFinancing: 'cashin_other_financing(yuan)',
    totalCashoutFinancing: 'total_cashout_financing(yuan)',
    cashoutDebtRepayment: 'cashout_debt_repayment(yuan)',
    cashoutDividendsInterest: 'cashout_dividends_interest(yuan)',
    cashoutDividendsSubsidMinority: 'of which：cashout_dividends_subsid_minority(yuan)',
    cashoutOtherFinancing: 'cashout_other_financing(yuan)',

    exchangeRateEffect: 'fourth、exchange_rate_effect(yuan)',
    otherReasonsEffectY: 'fifth、other_reasons_effect(yuan)',
    netIncCash: 'sixth、net_inc_cash(yuan)',
    beginCash: 'add：begin_cash(yuan)',
    endCash: 'end_cash(yuan)',

    // BSS
    totalAsset: 'first、total_asset',
    currAssetTotal: 'curr_asset_total(yuan)',
    cashY: 'cash(yuan)',
    cash: 'cash',
    currMarketableSecurities: 'curr_marketable_securities',
    derivativeAsset: 'derivative_asset',
    notesAccountReceivable: 'notes_account_receivable',
    notesReceivable: 'of which：notes_receivable',
    accountReceivable: 'of which：account_receivable',
    accountReceivableFinancing: 'account_receivable_financing',
    prepayment: 'prepayment',
    otherReceivable: 'other_receivable',
    inventory: 'inventory',
    inventoryBioConsumables: 'of which：inventory_bio_consumables',
    receivableRelatedComp: 'receivable_related_comp',
    receivableRelatedCompInterest: 'of which：receivable_related_comp_interest',
    receivableRelatedCompDividend: 'of which：receivable_related_comp_dividend',
    assetForSale: 'asset_for_sale',
    currLoans: 'curr_loans',
    ncurrAssetDueOneYear: 'ncurr_asset_due_one_year',
    ncurrAssetDueOneyear: 'ncurr_asset_due_one_year',
    contractAsset: 'contract_asset',
    currAssetOther: 'curr_asset_other',

    ncurrAssetTotal: 'ncurr_asset_total(yuan)',
    ncurrLoan: 'ncurr_loan',
    ncurrMarketableSecurities: 'ncurr_marketable_securities',
    finAssetHeldMaturity: 'fin_asset_held_maturity',
    ncurrReceivable: 'ncurr_receivable',
    ncurrEquity: 'ncurr_equity',
    ncurrInvestmentProperty: 'ncurr_investment_property',
    fixedAssets: 'fixed_assets',
    constructionInProgress: 'construction_in_progress',
    engineeringMaterial: 'engineering_material',
    fixedAssetLiquidation: 'fixed_asset_liquidation',
    bioAsset: 'bio_asset',
    oilGas: 'oil_gas',
    intangibleAsset: 'intangible_asset',
    useRightAsset: 'use_right_asset',
    devExpenditure: 'dev_expenditure',
    goodwill: 'goodwill',
    ncurrDeferredExpense: 'ncurr_deferred_expense',
    deferredTaxAsset: 'deferred_tax_asset',
    debtInvestment: 'debt_investment',
    otherDebtInvestment: 'other_debt_investment',
    otherEquityInvestment: 'other_equity_investment',
    ncurrOtherFinAsset: 'ncurr_other_finAsset',
    ncurrOtherAsset: 'ncurr_other_asset',

    totalLiabilityY: 'second、total_liability',
    currLiabilityTotal: 'curr_liability_total(yuan)',
    shortTermLoan: 'short_term_loan',
    derivativeLiability: 'derivative_liability',
    notesAccountPayable: 'notes_account_payable',
    notesPayable: 'of which：notes_payable',
    accountPayable: 'of which：account_payable',
    advancePayment: 'advance_payment',
    commissionPayable: 'commission_payable',
    salaryPayable: 'salary_payable',
    taxesPayable: 'taxes_payable',
    payableRelatedComp: 'payable_related_comp',
    payableRelatedCompInterest: 'of which：payable_related_comp_interest',
    payableRelatedCompDividend: 'of which：payable_related_comp_dividend',
    otherPayable: 'other_payable',
    liabilitiesForSale: 'liabilities_for_sale',
    ncurrLiabilityDueOneyear: 'ncurr_liability_due_oneyear',
    currLiabilityProvision: 'curr_liability_provision',
    deferredIncome: 'deferred_income',
    tradingLiability: 'trading_liability',
    contractLiability: 'contract_liability',
    currOtherLiability: 'curr_other_liability',

    ncurrLiabilityTotal: 'ncurr_liability_total(yuan)',
    ncurrDebt: 'ncurr_debt',
    leaseLiabilities: 'lease_liabilities',
    bondPayable: 'bond_payable',
    preferredStock: 'of which：preferred_stock',
    perpetualBonds: 'perpetual_bonds',
    ncurrPayable: 'ncurr_payable',
    ncurrSalaryPayable: 'ncurr_salary_payable',
    ncurrSpecialPayable: 'ncurr_special_payable',
    ncurrProvision: 'ncurr_provision',
    ncurrDeferredIncome: 'ncurr_deferred_income',
    ncurrTaxLiability: 'ncurr_tax_liability',
    ncurOtherLiability: 'ncur_other_liability',
    ncurrOtherLiability: 'ncurr_other_liability',

    totalOwnerEquity: 'third、total_owner_equity',
    paidInCapital: 'paid_in_capital',
    otherEquityInstrument: 'other_equity_instrument',
    preferredStockOwnerEquity: 'of which：preferred_stock_owner_equity',
    perpetualBondOwnerEquity: 'perpetual_bond_owner_equity',
    capitalSurplus: 'capital_surplus',
    lessTreasuryStock: 'less：less_treasury_stock',
    otherComprehensiveIncome: 'other_comprehensive_income',
    specialReserve: 'special_reserve',
    surplusReserve: 'surplus_reserve',
    undistributedProfit: 'undistributed_profit',
    currencyConversionDiff: 'currency_conversion_diff',
    minorityInterests: 'minority_interests',
    ownerEquityParentCompany: 'owner_equity_parent_company',
    totalOwnerLiabilityEquity: 'fourth、total_owner_liability_equity',

    netProfit: 'net_profit',
    oiGrossRev: 'oi_gross_rev',
    oeCogs: 'oe_cogs',
    oeSalesTax: 'oe_sales_tax',
    opProfit: 'op_profit',
    otherOpProfit: 'other_op_profit',
    nonOpIncome: 'non_op_income',
    ebt: 'ebt',
    incomeTax: 'income_tax',

    grossProfit: 'gross_profit',
    expenses: 'expenses',
    sales: 'sales',
    RD: 'RD',
    administrative: 'administrative',
    financial: 'financial',

    wy: 'wy',
    profitTrend: 'profit_trend',
    costTrend: 'cost_trend',
    totalOpIncome: 'total_op_income',
    oeSellingExpense: 'oe_selling_expense',
    oeRdExpense: 'oe_rd_expense',
    oeAdminExpense: 'oe_admin_expense',
    oeFinanceExpense: 'oe_finance_expense',
    operatingInflow: 'operating_inflow',
    investmentInflow: 'investment_inflow',
    financingCashInflow: 'financing_cash_inflow',
    effectOfExchangeRateChangesOnCash: 'effect_of_exchange_rate_changes_on_cash',
    otherReasonsEffect: 'other_reasons_effect',
    operatingCashOutflow: 'operating_cash_outflow',
    investingCashOutflow: 'investing_cash_outflow',
    financingCashOutflow: 'financing_cash_outflow',
    netIncreaseInCash: 'net_increase_inCash',
    cashFlow: 'cash_flow',
    cashinTaxRefund: 'cashin_tax_refund',
    otherOperatingInflow: 'other_operating_inflow',
    returnOfInvestment: 'return_of_investment',
    assetDisposal: 'asset_disposal',
    disposalOfASubsidiary: 'disposal_of_a_subsidiary',
    otherInvestments: 'other_investments',
    equityInfusion: 'equity_infusion',
    proceedsFromBorrowings: 'proceeds_from_borrowings',
    otherFinancingActivities: 'other_financing_activities',
    bondProceeds: 'bond_proceeds',
    paymentsForGoodsAndServices: 'payments_for_goods_and_services',
    salariesAndWages: 'salaries_and_wages',
    cashoutTaxes: 'cashout_taxes',
    acquisitionOfAssets: 'acquisition_of_assets',
    investmentExpenditure: 'investment_expenditure',
    acquisitionOfSubsidiaries: 'acquisition_of_subsidiaries',
    otherInvestingOutflow: 'other_investing_outflow',
    debtRepayment: 'debt_repayment',
    dividendsAndInterestPaid: 'dividends_and_interest_paid',
    otherFinancingOutflow: 'other_financing_outflow',
    operatingNetCashFlow: 'operating_net_cash_flow',
    investingNetCashFlow: 'investing_net_cash_flow',
    financingNetCashFlow: 'financing_net_cash_flow',
    debtRepaymentOutflow: 'debt_repayment_outflow',
    ownerEquity: 'owner_equity',
    details: 'details',
    totalLiability: 'total_liability',
    currLiability: 'curr_liability',
    ncurrLiability: 'ncurr_liability',

    // 资产
    generalRiskReserve: 'general_risk_reserve',
    interestIncome: 'interest_income',
    averageInterest: 'average_interest',
    loanBalance: 'loan_balance',
    disbursementAmount: 'disbursement_amount',
    repaymentAmount: 'repayment_amount',
    repaymentTerm: 'repayment_term',
    totalRevenue: 'total_revenue',
    industryNetProfit: 'industry_net_profit',
    industryTotalRevenue: 'industry_total_revenue',
    yearOverYearGrowth: 'YOY',
    cagr3: 'cagr3',
    quarterOverQuarterGrowth: 'QOQ',
    freeCashFlow: 'free_cash_flow',
    industryNetCashFlow: 'industry_net_cash_flow',
    industryFreeCashFlow: 'industry_free_cash_flow',
    assetsAndLiabilities: 'assets_and_liabilities',
    totalAssets: 'total_assets',
    industryEquity: 'industry_equity',
    industryTotalAssets: 'industry_total_assets',
    incomeStatement: 'income_statement',
    cashFlowStatement: 'cash_flow_statement',
    balanceSheet: 'balance_sheet',
    incomeStatementTrend: 'income_statement_trend',
    past5Years: '(past5Years)',
    past3Years: '(past3Years)',
    annualReport: 'annual_report',
    quarterlyReport: 'quarterly_report',
    profitBreakdown: 'profit_breakdown',
    revenueDistribution: 'revenue_distribution',
    annualReportOnly: 'annual_report_only',
    costDistribution: 'cost_distribution',
    incomeStatementDetails: 'income_statement_details',
    accountItem: 'account_item',
    cashFlowTrend: 'cash_flow_trend',
    cashFlowBreakdown: 'cash_flow_breakdown',
    cashInflowDistribution: 'cash_inflow_distribution',
    cashOutflowDistribution: 'cash_outflow_distribution',
    cashFlowStatementDetails: 'cash_flow_statement_details',
    balanceSheetTrend: 'balance_sheet_trend',
    balanceSheetBreakdown: 'balance_sheet_breakdown',
    assetDistribution: 'asset_distribution',
    liabilityDistribution: 'liability_distribution',
    balanceSheetDetails: 'balance_sheet_details',
    dupontAnalysis: 'dupont_analysis',
    otherOperatingExpenses: 'other_operating_expenses',
    profit: 'profit',

    assets: 'assets',
    currAsset: 'curr_asset',
    ncurrAsset: 'ncurr_asset',
    liability: 'liability',
  },

  // tickerRating
  tickerRating: {
    avg: 'Average',
    strongBuy: 'Strong Buy',
    buy: 'Buy',
    hold: 'Hold',
    sell: 'Sell',
    strongSell: 'Strong Sell',
    targetPriceRange: 'Target Price Range',
    targetPriceAvg: 'Target Price Avg',
    price: 'Price',
    targetPrice: 'Target Price',
    past1Year: '(Past 1 Year)',
    ratingDistributionPct: 'Rating Distribution %',
    past3Months: '(Past 3 Months)',
    ratingChange: 'Rating Change',
    total: 'A total of ',
    analystsCovered: ' analysts have rated',
    ratingGiven: '',
    upgrades: 'Upgrades',
    firmsUpgraded: 'No.',
    downgrades: 'Downgrades',
    maintains: 'Maintains',
    industryCoverage: '',
    ratingDetails: 'Rating Details',
    institutionName: 'Institution Name',
    analystName: 'Analyst Name',
    initialRating: 'Initial Rating',
    targetPriceLower: 'Target Price Lower',
    targetPriceUpper: 'Target Price Upper',
    ratingChg: 'Rating Chg',
    ratingNew: 'New Rating',
    previousRating: 'Previous Rating',
    tradeDate: 'Trade Date',
  },

  // tickerShareholderVue
  tickerShareholderVue: {
    details: 'Details',
    price: 'Price',
    top10HoldingRatio: 'Top10 Holding Ratio',
    clickToViewDetails: 'Click To View Details',
    shareholderCount: 'Shareholder Count',
    unchanged: 'Unchanged',
    decreased: 'Decreased',
    increased: 'Increased',
    newEntry: 'New Entry',
    top10FloatShareholdersAndCount: 'Top10 Float Shareholders And Count',
    past3Years: '(Past 3 Years)',
    top10FloatShareholders: 'Top10 Float Shareholders',
    top10FloatShareholdersDetails: 'Top10 Float Shareholders Details',
    shareholderName: 'Shareholder Name',
    holdingQuantity: 'Holding Quantity (Shares)',
    floatHoldingRatio: 'Float Holding Ratio',
    holdingChange: 'Holding Change',
    holdingRatio: 'Holding Ratio',
    shareholderCountDetails: 'Shareholder Count Details',
    totalShareholderCount: 'Total Shareholder Count',
    shareholderCountChange: 'Shareholder Count Change',
    avgSharesPerHolder: 'Avg Shares Per Holder (Shares)',
    avgHoldingRatio: 'Avg Holding Ratio',
    avgHoldingChange: 'Avg Holding Change',
    top10FloatShareholdersDistribution: 'Top10 Float Shareholders Distribution',
    others: 'Others',
    tipsOverview:
      '### Top10 Float Shareholders\n- Compare the top 10 float shareholder holding ratio with price over the past 3 years\n- <br>\n\n### Shareholder Count\n- Compare shareholder count with price over the past 3 years',
    tipsTop10Details:
      '### Top10 Float Shareholder Details\n- Show the Top10 float shareholder holdings for the selected announcement date, which can be switched by clicking details on the chart above',
    tipsShareholderCountDetails:
      '### Shareholder Count Details\n- Show shareholder count and average holding change for the selected announcement date, which can be switched by clicking details on the chart above',
    tipsTop10Distribution:
      '### Top10 Float Shareholder Distribution\n- Show the Top10 float shareholder holding ratio for the selected announcement date, which can be switched by clicking details on the chart above'

  },

  // tickerEventVue
  tickerEventVue: {
    reduceHoldings: '减持',
    increaseHoldings: '增持',
    tickerCodeP: '证券代码',
    stockSymbol: '证券简称',
    annDate: '公告日期',
    deadlineForSharePurchaseAndSale: '增（减）持截止日',
    shareholderName: '股东名称',
    shareholderId: '股东ID',
    changeVol: '变动数量',
    changeRatioTotalShare: '变动数量占总股本比例（%）',
    postChangeRatio: '变动后占比（%）',
    changePriceUpperLimit: '增（减）持价格上限',
    postChangeShareTotal: '变动后持股数量',
    postChangeShareFloat: '变动后持有流通股数量',
      shares: '股',
      wanShares: '10K shares',
      percent: '%',

    reportDetails: '报告详情',
    reportingPeriod: '报告期',
    recordTime: '发布预报时间',
    explanationOfTheReportingPeriod: '报告期解释',
    rptDateActual: '真实发布时间',
    rptDateEstimate: '预告时间',

    pledgor: '质押方',
    numberOfPledgedShares: '质押数量',
    releaseOfPledge: '收回质押',
    cumulative_plg_mvt_pct: '累计比例',
    plg_mvt_pct: '本次比例',
    lender: '出借方',
    details: '详情',

    shareholdingDetails: '持股详情',
    expReleaseDate: '预计解除限售日期',
    expReleaseVol: '预计解除限售数量',
    restrictionReason: '限售原因',

    tradeDetails: '交易详情',
    tradeDate: '交易日期',
    exchange: '交易所',
    buyer: '买方营业部',
    seller: '卖方营业部',
    price: '成交价格',
    vol: '成交量',
    amount: '成交金额',

    clickCount: '点击量',
    q: '问',
    a: '答',
    latestRating: '最新评级',
    previousRating: '上次评级：',
    institution: '机构',

    startDate: '开始日期',
    netProfit: '净利润',
    wy: '万元',
    totalAsset: '总资产',
    AttributableToOwnersOfParent: '股东权益（不含少数股东权益）',
    eps: '每股收益',
    roe: '净资产收益率',
    roeWeighted: '净资产收益率-加权',
    netEquityPerShare: '每股净资产',
    y: '元',

    ReportingType: '业绩类型',
    EarningsGuidance: '业绩预告内容',
    changeReason: '业绩变化原因',
    netProfLow: '净利润下限',
    netProfHigh: '净利润上限',
    netProfLowPct: '净利润增减幅下限',
    netProfHighPct: '净利润增减幅上限',

    stockIssuanceDetails: '股票发行详情',
    stockType: '股票类别',
    parValue: '每股面值',
    issueSize: '发行规模(万股)',
    issueObject: '发行对象',
    pricingMethod: '发行定价方式',
    expectedFundAmount: '预计募资金额(万元)',
    fundPurpose: '预计募资投向',
    planProgress: '方案进度',

    shResolutionDate: '股东决议公告日期',
    approvalDate: '增发获准公告日期',
    changeDescription: '变更说明',
    issuePrice: '发行价格',
    issueMethod: '发行方式',
    resolutionValidUntil: '股东决议有效期截止日',
    xplanStatusx: '方案状态',
    terminationDate: '终止公告日期',

    totalIssueVolume: '总发行数量',
    publicIssueVolume: '公开发行数量',
    issuePriceRmb: '发行价格(人民币)',
    issuePriceForeign: '发行价格（外币）',
    currency: '币种',
    upperBidPrice: '竞价上限',
    lowerBidPrice: '竞价下限',
    shareholderPlacementMethod: '老股东配售方式',
    shareholderPlacementPrice: '老股东配售价格',
    shareholderPlacementRatio: '老股东配售比例',
    weightedPeRatio: '加权发行市盈率',
    dilutedPeRatio: '摊薄发行市盈率',
    preIssueNaps: '发行前每股净资产',
    postIssueNaps: '发行后每股净资产',
    actualFundRaised: '实际募资总额',
    issueRegion: '发行地区',
    underwritingMethod: '承销方式',
    recordDate: '股权登记日',
    exRightDate: '除权日',

    DetailsOfUnlockingRestrictedShares: '解除限售详情',
    actualReleaseDate: '实际解除限售日',
    actualReleaseVol: '实际解除限售数量',
    actualReleaseRatio: '实际解除限售比例',
    actualFloatVol: '实际可流通数量',

    detailsOfFrozenShares: '股份冻结详情',
    holderId: '被冻结当事人ID',
    holderName: '被冻结当事人',
    freezeReason: '冻结事项',
    NatureOfFrozenShares: '被冻结股份性质',
    freezeStock: '冻结数量',
    freezePct: '占总股份比例',
    applicant: '冻结申请人',
    executioner: '冻结执行人',
    freezeStartDate: '冻结起始日',
    freezeEndDate: '冻结终止日',
    unfreezeDate: '解冻日期',
    cumulativeUnfreezeStock: '累计解冻数量',
    unfreezingSummary: '解冻处理说明',

    pledgeDetails: '质押详情',
    pledgorId: '出质人ID',
    pledgee: '质权人',
    pledgeReason: '质押事项',
    pledgedSharesType: '质押股份性质',
    pledgedVol: '质押数量',
    pledgedSharesRatio: '占总股本比例',
    pledgeStartDate: '质押起始日',
    pledgeEndDate: '质押终止日',
    pledgeReleaseDate: '质押解除日',
    pledgeReleaseVol: '质押解除数量',

    pledgeReleaseReason: '解除质押说明',
    isRepoTransaction: '是否质押式回购交易',
    yes: '是',
    no: '否',

    DividendDetails: '分红详情',
    divYear: '分红年度',
    boardMeetingDate: '董事会预案公告日期',
    boardMeetingDivPlan: '董事会预案分红说明',
    shareholderMeetingDate: '股东大会预案公告日期',
    shareholderMeetingDivPlan: '股东大会预案分红说明',
    divAnnDate: '实施方案公告日期',

    divPlanSummary: '实施方案分红说明',
    divBaseShare: '分配股本基数（实施）',
    baseYear: '股本基准年度',
    bonusShareRatio: '送股比例',
    transferRatio: '转增比例',
    divRatioRmb: '派息比例(人民币)',
    divRatioUsd: '派息比例（美元)',
    divRatioHkd: '派息比例（港币)',
    bonusShareCount: '送股数量',
    transferShareCount: '转增数量',
    divAmountRmb: '派息金额(人民币)',
    aShareRecordDate: 'A股股权登记日',

    bShareRecordDate: 'B股股权登记日',
    aShareExDate: 'A股除权日',
    bShareExDate: 'B股除权基准日',
    bShareLastTradeDate: 'B股最后交易日',
    aShareDivDate: '派息日(A)',
    bShareDivDate: '派息日(B)',
    aShareBonusShareDate: 'A股送红股到帐日',
    aShareListingDate: 'A股新增股份上市日',
    bShareListingDate: 'B股新增股份上市日',
    dividendCancelDate: '取消分红公告日期',
    aShareTransferShareDate: 'A股转赠股份到帐日',
    bShareTransferShareDate: 'B股转赠股份到帐日',
    bShareBonusShareDate: 'B股送红股到帐日',
    exchangeRate: '汇率',
    latestAnnDate: '最新公告日期',
    dividendType: '分红类型',
    debtRestructuringDetails: '债务重组详情',
    debtor: '债务人',
    creditor: '债权人',
    restructureMethod: '重组方式',
    restructureAmt: '重组金额',
    restructureIncome: '重组收益',
    contingentExpenditure: '或有支出',
    restructureBaseDate: '重组基准日',
    isRelatedTransaction: '是否关联交易',
    impactOnCompany: '对公司经营的影响',
    restructureDetails: '重组情况说明',
    progressStatus: '进展状态',

    patentDetails: '专利详情',
    patentName: '专利名称',
    applicationNum: '申请号',
    publicationNum: '申请公布号',
    classificationCode: '分类号',
    publicationDate: '申请公布日',
    applicationDate: '申请日期',
    patentType: '专利类型',
    inventor: '发明人',
    detailId: '专利详情查询ID',

    trademarkDetails: '商标详情',
    trademarkName: '商标名称',
    classificationType: '类别名称简化',
    applicationStatus: '流程状态',
    applicantName: '申请人',

    ResearchActivityDetails: '调研活动详情',
    researchTopic: '调研主题',
    participants: '参与者',
    penaltyDetails: '处罚信息详情',
    sanctionTypeCode: '处罚类型编码',
    sanctionType: '处罚类型',
    sanctionReason: '处罚原因',
    regulatoryBody: '处罚部门',
    sanctionObject: '处罚对象',
    sanctionDetails: '处罚内容',
    sanctionAmt: '处罚金额',

    guaranteeDetails: '担保信息详情',
    guarantor: '担保方',
    guaranteed: '被担保方',
    matterDetails: '担保事项',
    matterType: '担保类别',
    contractDate: '协议签署日期',
    relatedPartyTransaction: '是否关联交易',

    partyRelationship: '双方关联关系',
    guaranteedAmt: '担保金额',
    guaranteedPeriod: '担保期限',
    loanStartDate: '借款开始日期',
    loanEndDate: '借款结束日期',
    loanRate: '借款年利率',
    collateral: '抵押或质押物',
    debtHolder: '债权人',
    postPeriodMatters: '期后相关事项',
    guaranteeReleaseDate: '担保免除日期',

    progress: '担保进程',
    guaranteeStartDate: '担保开始日期',
    guaranteeEndDate: '担保截止日期',
    stkHolderMeeting: '是否经股东大会审议',
    stkHolderMeetingDate: '股东大会决议公告日',
    relatedPartyGuarantee: '是否为关联方担保',
    companyGuaranteeTotal: '公司及控股子公司对外担保总额',
    exchangeMarket: '交易市场',

    assetAcquisitionDetails: '资产收购详情',
    assetBuyer: '资产受让方',
    assetSeller: '资产出让方',
    assetType: '受让资产类型',
    assetDescription: '受让资产',
    transactionAmt: '成交金额',

    valuationDate: '资产评估基准日',
    bookValue: '资产账面值',
    assessedValue: '资产评估值',
    settlementMethod: '结算方式',
    financialAdvisorName: '独立财务顾问机构名称',
    isMajorAssetAcquisition: '是否重大资产收购',

    sellerRelationship: '出让方与公司关联关系',
    assetAcquisitionDescription: '资产受让情况说明',

    assetDisposalDetails: '资产出让详情',

    isMajorAssetSale: '是否重大资产出让',
    buyerRelationship: '受让方与公司关联关系',
    assetTransferDescription: '资产出让情况说明',

    assetSwapDetails: '资产置换详情',
    assetSwapOutParty: '资产置换方',
    assetSwapInParty: '资产置换协议方',
    assetSwapOutType: '置出资产类型',
    assetSwapOut: '置出资产',
    assetSwapOutAmt: '置出资产金额',
    assetSwapOutAssessedValue: '置出资产评估值',

    assetSwapOutBookValue: '置出资产账面值',
    assetSwapInType: '置入资产类型',
    assetSwapIn: '置入资产',
    assetSwapInAmt: '置入资产金额',
    assetSwapInAssessedValue: '置入资产评估值',

    assetSwapInBookValue: '置入资产账面值',
    swapBalance: '资产置换差额',
    balanceSettlementMethod: '差额结算方式',
    isMajorAssetSwap: '是否重大资产置换',
    relatedPartyRelation: '协议方与公司关联关系',
    assetSwapDescription: '资产置换情况说明',

    AssetFreezeDetails: '资产冻结详情',
    entityImpacted: '被冻结单位',
    assetFreezeTypeCode: '冻结资产类型编码',
    assetFreezeType: '冻结资产类型',
    assetValue: '冻结资产金额',
    enforcementAgency: '冻结单位',
    reason: '冻结原因',
    postMatters: '持限售(未流通)股数量',
    applicantParty: '持流通股数量',

    InvestmentDetails: '投资信息详情',
    entityInvesting: '投资主体',
    relationToListedEntity: '从属关系',
    investmentType: '投资类型',
    investmentProvince: '投资省份',
    investmentCity: '投资城市',
    investmentLocation: '投资位置',
    projectName: '项目名称/下属公司名称',
    totalProjectSize: '项目投资总额/下属公司注册资本',
    investmentAmt: '出资金额',
    currencyType: '币种编码',
    investmentPct: '出资比例',
    investmentDetail: '建设内容',
    investmentAim: '投资目的',
    effectSummary: '对公司的影响',
    annUrl: '公告网址',

    LitigationDetails: '诉讼详情',
    litigationSummary: '诉讼事项',
    legalBasis: '案由',
    amountInQuestion: '涉及金额',
    courtDate: '开庭日期',
    courtFirstInstance: '诉讼一审机构',
    courtSecondInstance: '诉讼二审机构',
    courtOfAppeal: '诉讼申诉机构',
    judgmentFirstInstance: '一审裁决情况',
    judgmentSecondInstance: '二审裁决情况',
    judgmentAppeal: '申诉情况',
    enforcementStatus: '判决执行情况',
    impactAssesment: '对本公司的影响',
    litigationCost: '诉讼费用',
    paymentAmount: '偿还金额',

    ArbitrationDetails: '仲裁详情',
    plaintiff: '原告',
    defendant: '被告',
    arbitrationSummary: '诉讼事项',
    companyPositionCode: '公司所处地位',
    companyPosition: '案由',
    subjectMatterCode: '涉及金额',
    subjectMatter: '币种',
    subjectAmt: '标的',
    currecyCode: '开庭日期',
    firstInstanceCourt: '诉讼一审机构',
    secondInstanceCourt: '诉讼二审机构',
    appealCourt: '诉讼申诉机构',
    firstInstanceRuling: '一审裁决情况',
    secondInstanceRuling: '二审裁决情况',
    judgmentEnforcementStatus: '判决执行情况',
    litigationCosts: '诉讼费用',
    repaymentAmount: '偿还金额',

    RightsOfferingDetails: '配股详情',
    declareDate: '公告日期',
    allotRatio: '配股比例',
    allotPrice: '配股价格',
    expAllotVol: '预计配股数量',
    expAllotAmt: '预计募集资金',
    expIssueCost: '预计发行费用',
    underwriteMethod: '承销方式',
    equityRecordDate: '股权登记日',
    exRightsDate: '除权基准日',
    paymentStartDate: '配股缴款起始日',
    paymentEndDate: '配股缴款截止日',
    allotQuantity: '实际配股数量',
    underwriteBalance: '承销余额',
    fundRaisedTotal: '实际募资总额',
    fundRaisedNet: '实际募资净额',
    totalIssueCost: '发行费用总额',
    underwritingCost: '承销费用',
    fundArrivalDate: '资金到账日',
    beforeShareTotal: '配股前总股本',
    afterShareTotal: '配股后总股本',
    beforeShareFloat: '配股前流通股本',
    afterShareFloat: '配股后流通股本',
    stateAllotVol: '国家股实配数量',
    corporateAllotVol: '法人股实配数量',
    employeeAllotVol: '职工股实配数量',
    transferredShareVol: '转配股实配数量',
    otherShareVol: '其他股份实配数量',
    publicShareVol: '公众股实配数量',
    mshSubscriVol: '大股东认购数量',
    mshSubscriMethod: '大股东认购方式',
    transferableShareVol: '可转配股数量',
    corporateTransferVol: '法人获转配数量',
    publicTransferVol: '公众获转配数量',
    transferFeePerShare: '每股配权转让费',
    publicSubscriCode: '公众配售代码',
    publicSubscriName: '公众配售简称',
    otherSubscriCode: '其他配售代码',
    otherSubscriAbbr: '其他配售简称',
    listingAnnDate: '上市公告日期',
    allotListingDate: '配股上市日',
    warrantTradeStartDate: '配股权证交易起始日',
    warrantTradeEndDate: '配股权证交易截止日',
    refundDate: '配股失败退还申购款日期',
    suspensionStartDate: '停牌起始日',
    suspensionEndDate: '停牌截止日',
    subscriptionObject: '配售对象',
    issueResultAnnDate: '配股发行结果公告日',
    entrustUnit: '委托单位',
    subId: '记录标识',
    publicSubscriAbbrEn1: '申购简称1（英文）',
    publicSubscriAbbrEn2: '申购简称2（英文）',
    couponRate: '票面股息率',
    capitalVerificationDate: '验资日',

      boardAllotDetail: '配股预案详情',
      stockTypeCode: '股票类别编码',
      boardMeetingContent: '董事会预案内容',
      shareholderMeetingContent: '股东大会预案内容',
      fundUseDetails: 'Fund Use Details',
      fundUseType: 'Fund Use Type',
      fundUser: 'Fund User',
      year: 'Year',
      relationship: 'Relationship',
      accountingTreatment: 'Accounting Treatment',
      periodStartFund: 'Beginning Fund Balance',
      periodAdditionFund: 'Period Addition',
      periodInterest: 'Period Interest',
      periodRepayment: 'Period Repayment',
      periodEndFund: 'Ending Fund Balance',
      fundUseReason: 'Reason for Fund Use',
      useNature: 'Use Nature',
      compAnnCode: 'Internal Announcement Code',
      copyrightDetails: 'Copyright Details',
      articleName: 'Work Name',
      articleCategory: 'Work Category',
      copyrightHolder: 'Copyright Holder',
      creationDate: 'Creation Date',
      regDate: 'Registration Date',
      regNumber: 'Registration Number',
      websiteRegDetails: 'Website Registration Details',
      auditTime: 'Audit Time',
      websiteName: 'Website Name',
      websiteLink: 'Website Link',
      domain: 'Domain',
      websiteRegNum: 'Website Registration Number',
      ratingDetailsTitle: 'Rating Details',
      ratingAgency: 'Rating Agency',
      ratingLabel: 'Rating',
      researchReportDetails: 'Research Report Details',
      reportTitle: 'Report Title',
      author: 'Author',
      auditDetails: 'Audit Details',
      isAudit: 'Audited',
      onsFirmId: 'Onshore Firm ID',
      onsFirmName: 'Onshore Firm Name',
      onsRegAccName: 'Onshore CPA',
      onsAuditOpinionCode: 'Onshore Opinion Code',
      onsAuditOpinionType: 'Onshore Opinion Type',
      onsAuditSupplementary: 'Onshore Supplementary Note',
      ofsFirmId: 'Offshore Firm ID',
      ofsFirmName: 'Offshore Firm Name',
      ofsRegAccName: 'Offshore CPA',
      ofsAuditOpinionCode: 'Offshore Opinion Code',
      ofsAuditOpinionType: 'Offshore Opinion Type',
      ofsAuditSupplementary: 'Offshore Supplementary Note',
      boardComment: 'Board Comment',
      csrcComment: 'Supervisor/Regulator Comment',
      endDate: 'End Date',
      snrMgmtName: 'Senior Management Name',
      snrMgmtRole: 'Senior Management Role',
      relationType: 'Relation Type',
      holdingPeriodStart: 'Beginning Holding',
      holdingPeriodEnd: 'Ending Holding',
      holdingChangeAmt: 'Holding Change',
      holdingChangePct: 'Holding Change %',
      avgStockPrice: 'Average Price',
      holdingValuePeriodEnd: 'Ending Market Value',
      dataSource: 'Data Source',
      snrMgmtSalary: 'Salary',
    boardAllotRatio: '配股比例（董）',
    shareholderAllotRatio: '配股比例',
    parValuePerShare: '每股面值',
    allotBaseShares: '配股基准股本',
    estAllotPriceUpper: '预计配股价格上限',
    estAllotPriceLower: '预计配股价格下限',
    allotPricingMethod: '配股价格确定方式',
    estAllotVol: '预计配股数量',
    estFundRaising: '预计募集资金',
    expUseOfFunds: '预计募资投向',
    shareholderResolutionDate: '股东决议公告日期',
    allotApprovalDate: '配股获准公告日期',
    fundUseDetails: '资金占用详情',
    fundUseType: '资金占用类别',
    fundUser: '资金占用方名称',
    year: '年度',
    relationship: '占用方与上市公司的关联关系',
    accountingTreatment: '上市公司核算的会计科目',
    periodStartFund: '期初占用资金余额',
    periodAdditionFund: '年度占用累计发生金额',
    periodInterest: '年度资金占用利息',
    periodRepayment: '年度偿还累计发生金额',
    periodEndFund: '期末占用资金余额',
    fundUseReason: '占用形成原因',
    useNature: '占用性质',
    compAnnCode: '公告内部编码',

    CopyrightDetails: '著作权详情',
    articleName: '作品名称',
    articleCategory: '作品类别',
    copyrightHolder: '著作权人',
    creationDate: '创作完成日期',
    regDate: '登记日期',
    regNumber: '登记号',

    websiteRegDetails: '网站备案详情',
    auditTime: '审核时间',
    websiteName: '网站名称',
    websiteLink: '网站链接',
    domain: '域名',
    websiteRegNum: '网站备案/许可证号',
    regNum: '备案号',

    ratingDetails: '评级详情',
    agency: '评级机构',
    rating: '评级',
    ResearchReportDetails: '研报详情',
    reportTitle: '报告名称',
    author: '作者',

    AuditDetails: '审计详情',
    endDate: '报告期',
    isAudit: '是否经审计',
    onsFirmId: '境内会计师事务所ID',
    onsFirmName: '境内会计师事务所名称',
    onsRegAccName: '境内会计师事务所签名注册会计师',
    onsAuditOpinionCode: '境内会计师事务所审计意见类型编码',
    onsAuditOpinionType: '境内会计师事务所审计意见类型',
    onsAuditSupplementary: '非标准审计意见的事项内容',
    ofsFirmId: '境外会计师事务所ID',
    ofsFirmName: '境外会计师事务所名称',
    ofsRegAccName: '境外会计师事务所签名注册会计师',
    ofsAuditOpinionCode: '境外审计报告会计师事务所审计意见类型编码',
    ofsAuditOpinionType: '境外审计报告会计师事务所审计意见类型',
    ofsAuditSupplementary: '境外审计意见非标准的事项说明',
    boardComment: '董事会对会计师事务所出具的有保留意见书、解释说明',
    csrcComment: '监事会对董事会就上述事项的说明所表示的意见',

    snrMgmtName: '董监高姓名',
    snrMgmtRole: '董监高职务',
    relationType: '变动人与董监高关系',
    holdingPeriodStart: '期初持股数量',
    holdingPeriodEnd: '期末持股数量',
    holdingChangeAmt: '变动数量',
    holdingChangePct: '变动比例(‰)',
    avgStockPrice: '成交均价',
    holdingValuePeriodEnd: '期末市值',
    dataSource: '数据来源',
    snrMgmtSalary: '年薪'

  },

  // selfGroupsTable.vue
  selfGroupsTable: {
    industry: 'Industry',
    stock: 'Stock',
    billion: 'B',
    deleteSuccess: 'Deleted successfully',
    deleteFailure: 'Failed to delete',
    setSuccess: 'Set successfully',
    setFailure: 'Failed to set',
    name: 'Name',
    attribute: 'Attribute',
    levelOneIndustry: 'Level 1 Industry',
    levelTwoIndustry: 'Level 2 Industry',
    parentIndustry: 'Parent Industry',
    realPrice: 'Price',
    realPct: 'Change',
    mv_total: 'Market Cap',
    turnover_rate_f: 'Turnover Rate',
    dv_ratio: 'Dividend Yield (div%)',
    dv_ttm: 'Dividend Yield (ttm)',
    action: 'Action',
    addToGroup: 'Add to Group',
    ungrouped: 'Ungrouped',
    confirmRemove: 'Remove from this group?',
    remove: 'Remove',
  },

  accountShow: {
    title: 'LLM Prediction Probability Comparison',
    selectDate: 'Select date',
    detailTitle: 'Prediction Details',
    stockCount: '{count} stocks',
    stockName: 'Stock Name',
    llmPrediction: '{llm} Prediction',
    llmAccuracy: '{llm} Accuracy',
    actualMovement: 'Actual Move',
    up: 'Up',
    down: 'Down',
  },

  // selfSelected.vue
  selfSelected: {
    industry: 'Industry',
    stock: 'Stock',
    all: 'All',
    ungrouped: 'Ungrouped',
    addWatchlist: 'Add to Watchlist:',
    searchPlaceholder: 'Enter stock name or ticker code',
    add: 'Add',
    alreadyAdded: 'Already added',
    addSuccess: 'Added successfully',
    addFailure: 'Failed to add',
    deleteSuccess: 'Deleted successfully',
    deleteFailure: 'Failed to delete',
    setSuccess: 'Set successfully',
    rankUpdated: 'Ranking updated',
    addGroupSuccess: 'Group added successfully',
    addGroupFailure: 'Failed to add group',
    renameSuccess: 'Renamed successfully',
    renameFailure: 'Failed to rename',
    selectStockFirst: 'Please select stocks from the left checkbox column first',
    myWatchlist: 'My Watchlist',
    editGroups: 'Edit Groups',
    syncView: 'Sync View',
    emptyDescription: 'No watchlist items yet. Use the search above to add a stock or industry.',
    editWatchlistGroups: 'Edit Watchlist Groups',
    addGroup: 'Add Group',
    groupName: 'Group Name',
    action: 'Action',
    editName: 'Rename',
    confirmDeleteGroup: 'Are you sure you want to delete this group?',
    delete: 'Delete',
    setGroupName: 'Set Group Name',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },

  // fundCo.vue
  fundCo: {
    kpiTips1: '### Company Aggregate Return vs Volatility:\n - X-axis: annualized volatility.\n - Y-axis: annualized return.\n - Each point shows the company-level scale-weighted return and volatility of its funds.\n - Reflects the firm\'s overall risk-return profile.',
    kpiTips2: '### Managed Fund Type Mix:\n - Distribution of managed funds by type such as equity, bond, and mixed funds.\n - Shows product-line diversity and style tilt.',
    kpiTips3: '### Managed AUM Trend:\n - Shows how the company\'s total managed assets changed over time.\n - Based on the cumulative assets of all managed funds.\n - The red line indicates the market average.',
    kpiTips4: '### Managed AUM Rank Trend:\n - Compares the company\'s ranking with other fund companies over time.\n - The y-axis is percentile rank, where smaller values indicate better ranks.',
    kpiTips5: '### Managed Fund Size Distribution:\n - Shows the distribution of all managed funds by size.\n - Funds are grouped into size buckets.',
    kpiTips6: '### Top 10 Managed Funds by AUM:\n - Lists the top 10 funds by size within the company.\n - Shows each fund\'s AUM and its share of total company AUM.',
    kpiTips7: '### Top 10 Concentration:\n - Calculates the share of total AUM contributed by the top 10 funds.\n - Higher concentration means greater reliance on large funds.',
    kpiTips8: '### Manager Tenure Distribution:\n - Shows the tenure distribution of the company\'s fund managers.\n - X-axis: tenure. Y-axis: number of managers.\n - The red line indicates the market-average count.',
    billionUnit: 'B',
    currencyUnit: 'CNY',
    aum: 'AUM',
    aumRank: 'AUM Rank',
    other: 'Other',
    managerCount: 'Manager Count',
    marketAvgManagerCount: 'Market Avg. Manager Count',
    fundUnit: '',
    fundCountWithUnit: 'Funds',
    fundCount: 'Fund Count',
    marketAvgFundCount: 'Market Avg. Fund Count',
    annualizedVolatility: 'Annualized Volatility',
    annualizedReturn: 'Annualized Return',
    managedAum: 'Managed AUM',
    managedFunds: 'Managed Funds',
    managedAumRank: 'Managed AUM Rank',
    fundManager: 'Fund Managers',
    basicInfo: 'Basic Info',
    pastOneYear: '(Past 1Y)',
    inceptionDate: 'Inception Date',
    registeredCapital: 'Registered Capital',
    legalRepresentative: 'Legal Representative',
    officialWebsite: 'Official Website',
    companyAddress: 'Company Address',
    companyProfile: 'Company Profile',
    aumTrend: 'Managed AUM Trend',
    aumRankTrend: 'Managed AUM Rank Trend',
    vsOtherFirms: '(vs Other Firms)',
    managerTenureDistribution: 'Manager Tenure Distribution',
    personCount: '(Managers)',
    fundSizeDistribution: 'Managed Fund Size Distribution',
    fundCountInParentheses: '(Fund Count)',
    fundTypeProportion: 'Managed Fund Type Mix',
    returnVsVolatility: 'Company Aggregate Return vs Volatility',
    lastOneYear: '(Last 1Y)',
    top10ManagedFunds: 'Top 10 Managed Funds by AUM',
    top10Concentration: 'Top 10 Concentration',
    shareholders: 'Shareholders',
    shareholderName: 'Shareholder',
    shareholdingRatio: 'Ratio',

  },

  // fundCoFundList.vue
  fundCoFundList: {
    tips1: '### Target Price \n - Shows the target price range from rating agencies over the past year \n - Target low, high, and average are the average over the past 60 trading days',
    fetchFundDataFailed: 'Failed to fetch fund data',
    riskLevelHigh: 'High',
    riskLevelMediumHigh: 'Medium High',
    riskLevelMedium: 'Medium',
    riskLevelMediumLow: 'Medium Low',
    riskLevelLow: 'Low',
    fundList: 'Fund List',
    fundName: 'Fund Name',
    fundManager: 'Fund Manager',
    maxTenure: 'Max Tenure',
    institutionalHoldingRatio: 'Institutional Holding Ratio',
    inceptionDate: 'Inception Date',
    benchmark: 'Benchmark',
    nav: 'Unit NAV',
    accumulatedNav: 'Accumulated NAV',
    fundSize: 'Fund Size',
    riskRating: 'Risk Rating',
    oneDay: '(1D)',
    returnLabel: 'Return',
    annualizedReturn: 'Annualized Return',
    oneYearAnnualized: '(1Y Ann.)',
    periodReturn: 'Period Return',
    lastOneWeek: '(1W)',
    lastOneMonth: '(1M)',
    lastThreeMonths: '(3M)',
    lastSixMonths: '(6M)',
    lastThreeYears: '(3Y)'
  },

  // fundCoMagList.vue
  fundCoMagList: {
    tips1: '### Target Price \n - Shows the target price range from rating agencies over the past year \n - Target low, high, and average are the average over the past 60 trading days',
    fundManagerList: 'Fund Manager List',
    managedFunds: 'Managed Funds',
    managedFundAum: 'Managed AUM',
    billionUnit: 'B',
    tenureStartDate: 'Start Date',
    tenureYears: 'Tenure',
    fundCompany: 'Fund Company',
    yearUnit: 'Y',
  },

  // fundComp.vue
  fundComp:{
    Tips1: '### Category Guide:\n - Equity investment: invested in stocks.\n - Fund investment: invested in other funds.\n - Bond investment: invested in bonds.\n - Cash: cash and cash equivalents.\n - Other investment: includes derivatives, precious metals, and other assets.',
    Tips2: '- Allocation analysis of held stocks by Shenwan L1 industry.',
    Tips3: '#### Institutional vs Retail Holders:\n - Shows the time trend of institutional and retail holding ratios.\n#### Holder Count:\n - Tracks the historical trend of the number of holders.',
    Tips4: '- Sum of the market-value weights of the top 10 heavy holdings, used to measure concentration.',
    top10Concentration: 'Top 10 Concentration',
    other: 'Other',
    holdingRatioPct: 'Ratio (%)',
    holderCount: 'Holder Count',
    institutionalHoldingRatio: 'Institutional Holding Ratio',
    individualHoldingRatio: 'Retail Holding Ratio',
    domestic: 'Domestic',
    overseas: 'Overseas',
    stockInvestment: 'Equity Investment',
    fundInvestment: 'Fund Investment',
    bondInvestment: 'Bond Investment',
    warrantInvestment: 'Warrant Investment',
    absInvestment: 'ABS Investment',
    cdInvestment: 'Certificate of Deposit',
    settlementReserve: 'Settlement Reserve',
    derivativeAssets: 'Derivative Assets',
    preciousMetalsInvestment: 'Precious Metals',
    otherInvestment: 'Other Investment',
    tenThousandUnit: '10K CNY',
    noData: 'No Data',
    constituentTop10: 'Top 10 Constituents',
    constituentTop10Concentration: 'Top 10 Constituent Concentration',
    fundConstituentsDetails: 'Fund Constituents Detail',
    holderTop10: 'Top 10 Holders',
    holderStructure: 'Holder Structure',
    industryDistribution: 'Industry Distribution',
    domesticOverseasDistribution: 'Domestic vs Overseas',
    constituentName: 'Constituent',
    holdingQuantity: 'Shares Held',
    holdingMarketValue: 'Holding Market Value',
    holdingRatio: 'Ratio'

  },

  // fundCompanyFilterTable.vue
  fundCompanyFilterTable: {
    fetchFundDataFailed: 'Failed to fetch fund data',
    fundCompany: 'Fund Company',
    aum: 'AUM',
    fundCount: 'Fund Count',
    managerCount: 'Manager Count',
    aumRankPercentile: 'AUM Rank Percentile',
    inceptionDate: 'Inception Date',
    inceptionYears: 'Years Since Inception',
    yearUnit: 'Y'
  },

  // fundFilterTable.vue
  fundFilterTable: {
    fetchFundDataFailed: 'Failed to fetch fund data',
    high: 'High',
    mediumHigh: 'Medium High',
    medium: 'Medium',
    mediumLow: 'Medium Low',
    low: 'Low',
    fundName: 'Fund Name',
    fundSize: 'Fund Size',
    inceptionDate: 'Inception Date',
    riskRating: 'Risk Rating',
    institutionHoldingRatio: 'Institutional Holding Ratio',
    managerTenure: 'Manager Tenure',
    unitNav: 'Unit NAV',
    accumNav: 'Accumulated NAV',
    returnLabel: 'Return',
    oneDay: '(1D)',
    annualized: 'Annualized Return',
    periodReturn: 'Period Return',
    lastOneWeek: '(1W)',
    lastOneMonth: '(1M)',
    lastThreeMonths: '(3M)',
    lastSixMonths: '(6M)',
    lastThreeYears: '(3Y)',
    lastFiveYears: '(5Y)',
    yearToDate: '(YTD)',
    sinceInception: '(Since Inception)',
    volatility: 'Volatility',
    semiDevAnnlzd: 'Downside Deviation',
    maxDrawdown: 'Max Drawdown',
    periodMaxDrawdown: 'Period Max Drawdown',
    oneYear: '(1Y)',
    oneYearAnnlzd: '(1Y Ann.)',
    sharpeRatio: 'Sharpe Ratio',
    sortinoRatio: 'Sortino Ratio',
    calmarRatio: 'Calmar Ratio',
    fundManager: 'Fund Manager',
    maxTenure: 'Max Tenure',
    institutionHoldingPct: 'Institutional Holding Ratio',
    performanceBenchmark: 'Performance Benchmark',
    yearUnit: 'Y'
  },

  // fundManagerFilterTable.vue
  fundManagerFilterTable:{
    fetchFundDataFailed: 'Failed to fetch fund data',
    fundHumanName: 'Fund Manager',
    fundCompanyName: 'Fund Company',
    liveFundCount: 'Managed Funds',
    liveNetAssetSum: 'Managed AUM',
    liveFundInvestType: 'Managed Fund Types',
    startTenure: 'Start Date',
    maxTenure: 'Tenure'

  },

  // fundMg.vue
  fundMg: {
    tips1: '### Manager Composite Score\n - Fund types include equity, bond, mixed, money market, closed-end, fund-of-funds, commodity, and REITs.\n - The score is the average of six metrics:\n 1. Overall performance: 5Y Sharpe weighted by type AUM share.\n 2. Recent performance: 6M Sharpe weighted by type AUM share.\n 3. Performance stability: standard deviation of performance scores over rolling quarters from 1Y to 5Y.\n 4. Overall scale: weighted by scale rank.\n 5. Overall experience: weighted by tenure, managed fund count, and fund-type breadth.\n 6. Style stability: change in type-allocation share over full history.',
    tips2: '### Manager Scale Rank\n - Current cross-sectional ranking.',
    tips3: '- Statistics based on managed funds.',
    percentile: 'Percentile',
    overallPerformance: 'Overall Performance',
    recentPerformance: 'Recent Performance',
    performanceStability: 'Performance Stability',
    styleStability: 'Style Stability',
    overallExperience: 'Overall Experience',
    overallScale: 'Overall Scale',
    gapPeriod: 'Gap Period',
    managedFunds: 'Managed Funds',
    managedAum: 'Managed AUM',
    managementExperience: 'Management Experience',
    careerStartDate: 'Career Start Date',
    education: 'Education',
    managedFundTypes: 'Managed Fund Types',
    professionalCertifications: 'Professional Certifications',
    profile: 'Profile',
    viewMore: 'View More >>',
    collapse: 'Collapse <<',
    managerOverallScore: 'Manager Composite Score',
    overallScore: 'Overall Score',
    radarChart: 'Radar Chart',
    employmentHistory: 'Employment History',
    tenureCompany: 'Company',
    tenureStartDate: 'Start Date',
    tenureEndDate: 'End Date',
    present: 'Present',
    tenureDuration: 'Tenure',
    scaleRank: 'Manager Scale Rank',
    fundType: 'Fund Type',
    all: 'All',
    rank: 'Rank',
    rankPercentile: 'Rank Percentile',
    performanceRank: 'Manager Performance Rank',
    annualizedReturn: 'Annualized Return',
    periodGrowthRate: 'Period Growth'

  },

  // fundMgHolding.vue
  fundMgHolding: {
    tips: '- Types include equity, bond, mixed, money market, closed-end, fund-of-funds, commodity, and REITs.\n - The analysis calculates the share of each type among managed funds.',
    managedFundTypeProportion: 'Managed Fund Type Mix',
    managedFundTypeProportionTrend: 'Managed Fund Type Mix Trend',
    top10ManagedFundSizeProportionHistory: 'Top 10 Managed Fund Size Share History'
  },

  // fundMgPerformance.vue
  fundMgPerformance: {
    tips1: '### Performance\n - Shows the overall growth of managed funds using AUM-weighted aggregation.\n - Funds managed in different periods are merged into one time series.\n - Aggregation is computed by time-slice weighted accumulation.\n - Slice return = $$r^t = (\\sum_{i}r_{i}^t*w_{i}^t)/\\sum_{i}w_{i}^t$$',
    tips4: '### Usage\n - Performance for each fund is rebased to zero at the start of the manager\'s tenure.\n - Single-fund view shows each fund during its managed period.\n - Multi-fund view merges selected funds using the checkboxes on the left.',
    cumulativeGrowthRate: 'Cumulative Growth',
    cumulativeNav: 'Accumulated NAV',
    tenureFundAggregatedPerformanceTrend: 'Aggregated Tenure Performance History',
    all: 'All',
    managedFundsHistorical: 'Managed Funds',
    total: 'Total',
    fundUnit: '',
    selectTop: 'Select Top',
    itemsSelectedOrCancel: ' / Clear',
    currentlyManaged: 'Active',
    historical: 'Historical',
    to: 'to',
    present: 'Now',
    tenureFundPerformanceTrend: 'Tenure Fund Performance History',
    switchFundTip: '(Switch funds on the left)'
  },

  // fundMgPerformanceAnalysis.vue
  fundMgPerformanceAnalysis: {
    tips3: '### Risk-Return Trend Analysis\n - The date range is customizable and covers the manager\'s full history.\n - Compares aggregate manager performance with market indices over the same period.\n #### Sharpe Trend:\n - Shows normalized Sharpe over the selected rolling window.\n - Mean > 0 indicates positive average return.\n #### Sharpe Rank Trend:\n - Mean > 0 indicates the manager ranks above peers on average.',
    all: 'All',
    oneMonth: '1M',
    threeMonths: '3M',
    sharpe: 'Sharpe',
    meanLabel: 'Mean:',
    sharpeRank: 'Sharpe Rank',
    aggregatedPerformance: 'Aggregate Performance',
    normalizedSharpe: 'Normalized Sharpe',
    stdRank: 'Std Rank',
    managerRiskReturnTrend: 'Manager Risk-Return Trend',
    periodReturn: 'Period Return',
    to: 'to',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectOverlayIndicator: 'Select Overlay Indicator',
    sharpeRollingWindowLabel: 'Sharpe Window:',
    selectRollingWindow: 'Select Window',
    sharpeTypeLabel: 'Sharpe Type:'

  },

  // fundMgScale.vue
  fundMgScale: {
    tips1: '- Ranking is based on managed fund AUM.\n - The closer to 0%, the better the rank.\n - The closer to 100%, the lower the rank.',
    aum: 'AUM',
    rank: 'Rank',
    aumRank: 'AUM Rank',
    aumAndRankTrend: 'AUM & Rank Trend',
    currencyUnit: 'CNY',
    all: 'All'
  },

  // fundMgVolatilityPerformance.vue
  fundMgVolatilityPerformance: {
    tip2: '### Return vs Risk\n - Distribution of manager performance and risk over the selected time window.\n - Annualized volatility = average daily volatility in the window * sqrt(242).\n - Annualized return = 1 - (1 + period return) ^ (242 / trading days in the window).\n - The fitted line reflects average market return at each risk level.',
    lastThreeMonths: 'Last 3M',
    lastSixMonths: 'Last 6M',
    lastOneYear: 'Last 1Y',
    lastThreeYears: 'Last 3Y',
    lastFiveYears: 'Last 5Y',
    volatility: 'Volatility',
    returnRate: 'Return',
    annualizedVolatility: 'Annualized Volatility',
    annualizedReturn: 'Annualized Return',
    intercept: 'Intercept',
    slope: 'Slope',
    managerAggregatedReturnVsVolatility: 'Manager Return vs Volatility',
    allTypes: 'All Types',
    selectTimeWindow: 'Select Window'
  },

  // fundRankBar.vue
  fundRankBar: {
  },

  // fundCompany.vue
  fundCompany: {
    fundCompany: 'Fund Company',
    managedFunds: 'Managed Funds',
    fundManager: 'Fund Managers'
  },

  // fundCompanyFilter.vue
  fundCompanyFilter:{
    aumBelow10B: 'Below 10B',
    aum10BTo20B: '10B~20B',
    aum20BTo50B: '20B~50B',
    aum50BTo100B: '50B~100B',
    aumAbove100B: 'Above 100B',
    tenureBelow5Years: 'Within 5 Years',
    tenure5To10Years: '5~10 Years',
    tenure10To15Years: '10~15 Years',
    tenure15To20Years: '15~20 Years',
    tenureAbove20Years: 'Above 20 Years',
    companySizeLabel: 'Company Size:',
    inceptionTimeLabel: 'Inception Time:',
    keywordLabel: 'Keyword:',
    placeholderKeyword: 'Enter keyword',
    selectedTagsLabel: 'Selected Tags:',
    clearAll: 'Clear',
    filterResults: 'Filter Results',
    rollingWindowOneYear: 'Window: Last 1 Year'

  },

  // fundFilter.vue
  fundFilter: {
    pctChg: 'Return',
    pctChgAnnlzd: 'Annualized Return',
    volatility: 'Volatility',
    volatilityAnnlzd: 'Annualized Volatility',
    semiDev: 'Downside Deviation',
    drawDownType2: 'Max Drawdown',
    sharpe: 'Sharpe Ratio',
    sortino: 'Sortino Ratio',
    calmarType2: 'Calmar Ratio',
    fundSize: 'Fund Size',
    fundSize0To1B: '0~1B',
    fundSize1BTo2B: '1~2B',
    fundSize2BTo5B: '2~5B',
    fundSizeAbove5B: 'Above 5B',
    billionUnit: 'B',
    inceptionDate: 'Inception Date',
    tenureLast1Year: 'Last 1 Year',
    tenure1To5Years: '1~5 Years',
    tenureAbove5Years: 'Above 5 Years',
    riskRating: 'Risk Rating',
    riskLevelLow: 'Low',
    riskLevelMedium: 'Medium',
    riskLevelHigh: 'High',
    institutionalHoldingRatio: 'Institutional Holding Ratio',
    managerTenure: 'Manager Tenure',
    tenureBelow2Years: 'Below 2 Years',
    tenure2To4Years: '2~4 Years',
    tenure4To6Years: '4~6 Years',
    tenure6To8Years: '6~8 Years',
    tenure8To10Years: '8~10 Years',
    tenure10To15Years: '10~15 Years',
    tenure15To20Years: '15~20 Years',
    tenureAbove20Years: 'Above 20 Years',
    top20Percent: 'Top 20%',
    bottom20Percent: 'Bottom 20%',
    lastOneWeek: 'Last Week',
    fundTypeLabel: 'Fund Type:',
    investmentCategoryLabel: 'Investment Category:',
    noLimit: 'All',
    fundMetricLabel: 'Fund Metrics:',
    rankingStageLabel: 'Ranking Stage:',
    keywordLabel: 'Keyword:',
    placeholderKeyword: 'Enter keyword',
    selectedTagsLabel: 'Selected Tags:',
    clearAll: 'Clear',
    filterResults: 'Filter Results'
  },

  // fundManager.vue
  fundManager: {
    fundManager: 'Fund Manager',
    historicalPerformance: 'Historical Performance',
    performanceAnalysis: 'Performance Analysis',
    riskReturn: 'Risk and Return',
    holdingAnalysis: 'Holding Analysis',
    scaleAnalysis: 'Scale Analysis'

  },

  // fundManagerFilter.vue
  fundManagerFilter: {
    fundSizeBelow0_5B: 'Below 0.05 B',
    fundSize0_5BTo1B: '0.05 B~0.1 B',
    fundSize1BTo2B: '0.1 B~0.2 B',
    fundSize2BTo4B: '0.2 B~0.4 B',
    fundSize4BTo8B: '0.4 B~0.8 B',
    fundSize8BTo15B: '0.8 B~1.5 B',
    fundSize15BTo30B: '1.5 B~3 B',
    fundSize30BTo60B: '3 B~6 B',
    fundSize60BTo100B: '6 B~10 B',
    fundSize100BTo500B: '10 B~50 B',
    fundSizeAbove500B: 'Above 50 B',
    fundTypeLabel: 'Fund Type:',
    managedAumLabel: 'Managed AUM:',
    billionUnit: 'B',
    keywordLabel: 'Keyword:',
    noLimit: 'All',
    placeholderKeyword: 'Enter keyword',
    selectedTagsLabel: 'Selected Tags:',
    clearAll: 'Clear',
    rollingWindowOneYear: 'Window: Last 1 Year'

  },

  // FundView.vue
  FundView:{
    tips1: '### Fund Classification\n - Includes active equity, enhanced index, short-duration bond, long-duration bond, primary bond, secondary bond, bond index, replicated index, balanced mixed, equity-biased mixed, bond-biased mixed, capital guaranteed, money market, short-term wealth bond, fund-of-funds, precious metals, other commodities, and infrastructure.\n ### Style Definition\n #### Market-Cap Style\n - Large-cap funds mainly invest in larger-cap stocks.\n - Small-cap funds mainly invest in smaller-cap stocks.\n #### Growth vs Value\n - Growth funds focus on growth potential and usually carry higher risk and return.\n - Value funds focus on current valuation and usually prefer steadier returns.\n - Green dots represent the current fund.\n - Blue dots represent peer funds.',
    tips2: '### Score Metrics\n 1. Return: rank-based score on return over the selected window. Higher score means higher return.\n 2. Volatility: rank-based score on volatility. Higher score means lower volatility.\n 3. Max Drawdown: rank-based score on maximum drawdown. Higher score means smaller drawdown.\n 4. Excess Return: rank-based score on excess return. Higher score means stronger excess return.\n 5. Sharpe: rank-based score on Sharpe ratio. Higher score means stronger Sharpe.',
    tenThousandUnit: '10K CNY',
    billionUnit: 'B',

    open: 'Open',
    high: 'High',
    low: 'Low',
    close: 'Close',
    price: 'Price',
    predictedPrice: 'Predicted Price',
    tradingAmount: 'Trading Amount',
    predictedTradingAmount: 'Predicted Trading Amount',
    predictionDate: 'Prediction Date',

    unitNav: 'Unit NAV',
    unitNavLabel: 'Unit NAV:',
    accumulatedNav: 'Accumulated NAV',
    accumulatedNavLabel: 'Accumulated NAV:',
    cumulativeGrowthRate: 'Cumulative Growth',
    returnRate: 'Return',
    annualizedReturn: 'Annualized Return',
    periodGrowthRate: 'Period Growth',

    volatility: 'Volatility',
    maxDrawdown: 'Max Drawdown',
    excessReturn: 'Excess Return',
    sharpe: 'Sharpe',
    percentile: 'Percentile',
    performance: 'Performance',
    style: 'Fund Style',

    value: 'Value',
    balanced: 'Balanced',
    growth: 'Growth',
    smallCap: 'Small Cap',
    midCap: 'Mid Cap',
    largeCap: 'Large Cap',

    shortName: 'Short Name',
    fundManager: 'Fund Manager',
    fundCompany: 'Fund Company',
    inceptionDate: 'Inception Date',
    fundSize: 'Fund Size',
    tradingMarket: 'Trading Market',
    restructuredFund: 'Restructured Fund',
    custodianName: 'Custodian',
    custodyFeeRate: 'Custody Fee',
    managementFeeRate: 'Management Fee',
    feeCalculationStandard: 'Fee Standard',
    duration: 'Duration',
    durationStartDate: 'Duration Start',
    durationEndDate: 'Duration End',
    rolloverMethod: 'Rollover Method',
    riskReturnProfile: 'Risk-Return Profile',
    investmentObjective: 'Investment Objective',
    investmentScope: 'Investment Scope',

    collapseMore: 'Collapse More <<',
    viewMore: 'View More >>',
    basicInfo: 'Basic Info',
    components: 'Components',
    tracking: 'Tracking',
    selectOverlayIndicator: 'Select Overlay Indicator',
    color: 'Color',
    logScale: 'Log',
    fundRating: 'Fund Score',
    market: 'Market',
    yes: 'Yes',
    no: 'No',

    lastOneWeek: '1W',
    lastOneMonth: '1M',
    lastThreeMonths: '3M',
    lastOneYear: '1Y',
    lastThreeYears: '3Y',
    recent3m: '(Last 3M)',
    performanceStageRanking: 'Performance Stage Ranking',
    rank: 'Rank',
    rankPercentile: 'Rank Percentile',
    fundCount: '({count} funds)'

  },

//
//   // BondView.vue
//   BondView: {
//     xx: '最多只能选择',
//     xx: '财富',
//     xx: '全价',
//     xx: '净价',
//     xx: '现券结算量(亿元)',
//     xx: '平均市值法-久期(年)',
//     xx: '平均现金流法-久期(年)',
//     xx: '平均市值法-凸性',
//     xx: '平均现金流法-凸性',
//     xx: '平均市值法-到期收益率(%)',
//     xx: '平均现金流法-到期收益率(%)',
//     xx: '平均基点价值(元)',
//     xx: '平均代偿期(年)',
//     xx: '平均派息率(%)',
//     xx: '指数上日总市值(亿元)',
//     xx: '财富指数涨跌幅(%)',
//     xx: '全价指数涨跌幅(%)',
//     xx: '净价指数涨跌幅(%)',
//     xx: '总值',
//     xx: '10年以上',
//     xx: '7-10年',
//     xx: '5-7年',
//     xx: '3-5年',
//     xx: '1-3年',
//     xx: '一年以下',
//     xx: '9-12个月',
//     xx: '6-9个月',
//     xx: '3-6个月',
//     xx: '0-3个月',
//     xx: '深交所',
//     xx: '银行间市场',
//     xx: '柜台',
//     xx: '离岸场外市场',
//     xx: '上交所',
//     xx: '单指数',
//     xx: '多指数对比',
//     xx: '债券指数：',
//     xx: '选择债券指数',
//     xx: '债券类型：',
//     xx: '请选择指数类型',
//     xx: '代偿期：',
//     xx: '请选择指数代偿期',
//     xx: '五年',
//     xx: '全部',
//     xx: '查询',
//     xx: '暂无所选数据',
//     xx: '利率走势',
//     xx: '暂无当日数据',
//
//   },
//
//   // commodityView.vue
//   commodityView: {
//     xx: '最多只能选择',
//     xx: '开',
//     xx: '高',
//     xx: '低',
//     xx: '收',
//     xx: '商品指数：',
//     xx: '选择债券指数',
//     xx: '五年',
//     xx: '全部',
//     xx: '查询',
//     xx: '暂无所选数据',
//   },
//
//
//   // HighChartStockTools.vue
//   HighChartStockTools: {
//     xx: '指标',
//     xx: '简单移动平均线',
//     xx: '指数移动平均线',
//     xx: '布林带',
//     xx: '周期',
//     xx: '添加',
//     xx: '颜色',
//     xx: '宽度',
//     xx: '保存',
//     xx: '指标',
//     xx: '形状',
//     xx: '标签',
//     xx: '圆形',
//     xx: '矩形',
//     xx: '椭圆',
//     xx: '线条',
//     xx: '线段',
//     xx: '箭头线段',
//     xx: '射线',
//     xx: '箭头射线',
//     xx: '直线',
//     xx: '箭头直线',
//     xx: '水平线',
//     xx: '垂直线',
//     xx: '曲线',
//     xx: '艾略特3',
//     xx: '艾略特5',
//     xx: '弯曲3',
//     xx: '弯曲5',
//     xx: '测量',
//     xx: '测量XY',
//     xx: '测量X',
//     xx: '测量Y',
//     xx: '高级',
//     xx: '斐波那契',
//     xx: '叉形线',
//     xx: '平行通道',
//     xx: '线类型',
//     xx: '线图',
//     xx: '蜡烛图',
//   },
//
//   // TickerValuation.vue
//   TickerValuation: {
//     Tips2: '### 估值 \n - 展示当前个股估值与所属一级行业和二级行业估值的对比 \n - 估值极值处理',
//     Tips3: '### 目标价 \n - 展示过去一年内评级机构给出的目标价区间与股价的对比 \n - 目标最低价、目标最高价、目标平均价，均为过去60个交易日的平均价',
//     xx: '亏损',
//     xx: '低',
//     xx: '25分位',
//     xx: '50分位',
//     xx: '75分位',
//     xx: '高',
//     xx: 'L2均值',
//     xx: '经营',
//     xx: '成长',
//     xx: '风险',
//     xx: 'L2估值',
//     xx: '能力详情',
//     xx: '运营',
//     xx: '成长',
//     xx: '投放金额',
//     xx: '还款金额',
//     xx: '风险',
//     xx: '估值',
//     xx: '(与所属行业比较)',
//     xx: '一级行业：',
//     xx: '二级行业：',
//     xx: '估值分析',
//     xx: '调整前',
//     xx: '(过去1年)',
//     xx: '(过去3个月)',
//     xx: '调整后',
//     xx: '企业价值',
//     xx: '估值分析2',
//     xx: '能力项',
//     xx: '能力',
//     xx: '能力趋势',
//     xx: '经营',
//     xx: '风险',
//     xx: '能力详情',
//   },
//
//   // selfSelected.vue
//   selfSelected: {
//     xx: '行业',
//     xx: '个股',
//     xx: '已经添加',
//     xx: '添加成功',
//     xx: '添加失败',
//     xx: '未分组',
//     xx: '删除成功',
//     xx: '删除失败',
//     xx: '修改成功',
//     xx: '添加失败',
//     xx: '排序已更新',
//     xx: '请先在表格左侧复选框添加股票',
//     xx: '全部',
//     xx: '添加自选：',
//     xx: '请输入股票名称或股票代码',
//     xx: '添加',
//     xx: '我的自选股',
//     xx: '编辑分组',
//     xx: '分时同屏',
//     xx: '全部',
//     xx: '编辑自选股分组',
//     xx: '分组名称',
//     xx: '操作',
//     xx: '修改名称',
//     xx: '确定删除吗？',
//     xx: '删除',
//     xx: '设置分组名称',
//     xx: '取消',
//     xx: '确认',
//
//   },
//
//   // SyncView.vue
//   SyncView: {
//     xx: '昨收',
//     xx: '价格',
//     xx: '开',
//     xx: '高',
//     xx: '低',
//     xx: '收',
//     xx: '成交额',
//   },
//
//   // sage: ProductPosition.vue
//   ProductPosition: {
//     xx: '金额',
//     xx: '元',
//     xx: '占比',
//     xx: '持仓比例',
//     xx: '股票',
//     xx: '债券',
//     xx: '逆回购',
//     xx: '基金',
//     xx: '现金',
//     xx: '持仓比例',
//     xx: '债券',
//     xx: '逆回购',
//     xx: '基金',
//     xx: '当前总持仓',
//     xx: '计划总持仓',
//     xx: '总持仓历史',
//     xx: '持仓比例',
//     xx: '持仓金额',
//     xx: '当前股票持仓行业分析',
//     xx: '持仓详情',
//     xx: '持仓数量',
//     xx: '持仓金额',
//     xx: '本金',
//     xx: '总盈亏',
//     xx: '当日盈亏',
//     xx: '总佣金',
//     xx: '总印花税',
//   },
//
//   // sage: ProductStrategy.vue
//   ProductStrategy:{
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '策略列表',
//     xx: '策略名称',
//     xx: '使用账户',
//     xx: '策略使用',
//     xx: '账户累计表现',
//     xx: '账户累计收益',
//     xx: '天',
//     xx: '元',
//     xx: '开始时间',
//     xx: '结束时间',
//     xx: '策略区间',
//     xx: '累计增长率',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标'
//
//   },
//
//   // ProductTrade.vue
//   ProductTrade: {
//     xx: '交易账户列表',
//     xx: '净值',
//     xx: '累计收益',
//     xx: '当前资产',
//     xx: '当前市值',
//     xx: '可用资金',
//     xx: '当日盈亏',
//     xx: '当日买入量',
//     xx: '当日卖出量',
//     xx: '当日交易量',
//     xx: '所属产品：',
//     xx: '创建时间：',
//     xx: '模拟盘',
//     xx: '实盘',
//   },
//
//   // SEAnalysis.vue
//   SEAnalysis: {
//     xx: '策略名称',
//     xx: '评估日期',
//     xx: '年化回报率',
//     xx: '年化波动率',
//     xx: '夏普比率',
//     xx: '最大回撤',
//     xx: '胜率',
//     xx: '盈亏比',
//     xx: '换手率',
//     xx: '策略容量',
//     xx: '平均持仓时间',
//     xx: '交易频率',
//     xx: '市场暴露度',
//     xx: '跟踪误差',
//     xx: '评价：',
//     xx: '评估历史',
//     xx: '评估日期',
//     xx: '年化回报率',
//     xx: '年化波动率',
//     xx: '夏普比率',
//     xx: '最大回撤',
//     xx: '胜率',
//     xx: '盈亏比',
//     xx: '换手率',
//     xx: '策略容量',
//     xx: '平均持仓时间',
//     xx: '交易频率',
//     xx: '次/年',
//     xx: '市场暴露度',
//     xx: '信息比率',
//     xx: '跟踪误差',
//     xx: '交易费用率',
//     xx: '评价',
//     xx: '仓位历史',
//     xx: '选择日期',
//     xx: '名称',
//     xx: '持仓数量',
//     xx: '持仓均价',
//     xx: '当前价格',
//     xx: '总市值',
//     xx: '可卖数量',
//     xx: '浮动盈亏',
//     xx: '累计盈亏',
//     xx: '当日盈亏',
//     xx: '当日买入数量',
//     xx: '当日卖出数量',
//     xx: '当日买入金额',
//     xx: '当日卖出金额',
//     xx: '当日佣金',
//     xx: '当日印花税',
//     xx: '当日过户费',
//     xx: '交易日期',
//     xx: '状态',
//     xx: '可用',
//     xx: '不可用',
//     xx: '元',
//   },
//
//   // SEBackTest.vue
//   SEBackTest: {
//     xx: '回测历史',
//     xx: '策略名称',
//     xx: '创建人',
//     xx: '开始时间',
//     xx: '结束时间',
//     xx: '操作',
//     xx: '查看',
//
//   },
//
//   // SEPosition.vue
//   SEPosition: {
//     xx: '策略名称',
//     xx: '评估日期',
//     xx: '年化回报率',
//     xx: '年化波动率',
//     xx: '夏普比率',
//     xx: '最大回撤',
//     xx: '胜率',
//     xx: '盈亏比',
//     xx: '换手率',
//     xx: '策略容量',
//     xx: '平均持仓时间',
//     xx: '交易频率',
//     xx: '市场暴露度',
//     xx: '跟踪误差',
//     xx: '评价：',
//     xx: '评估历史',
//     xx: '评估日期',
//     xx: '年化回报率',
//     xx: '年化波动率',
//     xx: '夏普比率',
//     xx: '最大回撤',
//     xx: '胜率',
//     xx: '盈亏比',
//     xx: '换手率',
//     xx: '策略容量',
//     xx: '平均持仓时间',
//     xx: '交易频率',
//     xx: '市场暴露度',
//     xx: '超额收益',
//     xx: '贝塔值',
//     xx: '信息比率',
//     xx: '跟踪误差',
//     xx: '交易费用率',
//     xx: '评价',
//   },
//
//   // tradeExecution.vue
//   tradeExecution: {
//     xx: '调仓进度',
//     xx: '已完成',
//     xx: '未完成',
//     xx: '仓位',
//     xx: '当前资产分布',
//     xx: '股票',
//     xx: '基金',
//     xx: '债券',
//     xx: '回购',
//     xx: '现金',
//     xx: '目标资产分布',
//     xx: '调仓概述',
//     xx: '计划调整',
//     xx: '实际调整',
//     xx: '总买金额',
//     xx: '总卖金额',
//     xx: '总调整金额',
//     xx: '总买仓位',
//     xx: '总卖仓位',
//     xx: '总调整仓位',
//     xx: '滑点概述',
//     xx: '预算值',
//     xx: '实际值',
//     xx: '类型',
//     xx: '买入滑点(基点)',
//     xx: '卖出滑点(基点)',
//     xx: '总滑点(基点)',
//     xx: '调仓总进度',
//     xx: '当前持仓详情',
//     xx: '名称',
//     xx: '持仓数量',
//     xx: '持仓均价',
//     xx: '总市值',
//     xx: '浮动盈亏',
//     xx: '当前价格',
//     xx: '可卖数量',
//     xx: '建仓金额',
//     xx: '本金',
//     xx: '累计佣金',
//     xx: '累计印花税',
//     xx: '累计过户税',
//     xx: '当日佣金',
//     xx: '当日印花税',
//     xx: '当日过户税',
//     xx: '当日买入额',
//     xx: '当日卖出额',
//     xx: '当日买入量',
//     xx: '当日卖出量',
//     xx: '元',
//     xx: '股',
//   },
//
//   // TradeHistory.vue
//   TradeHistory: {
//     xx: '获取逐笔成交数据失败',
//     xx: '逐笔成交历史',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '名称',
//     xx: '方向',
//     xx: '买入',
//     xx: '卖出',
//     xx: '委托数量',
//     xx: '委托价格',
//     xx: '成交数量',
//     xx: '成交均价',
//     xx: '成交金额',
//     xx: '订单状态',
//     xx: '成交时间'
//
//   },
//
//   // TradeOrder.vue
//   TradeOrder: {
//     xx: '获取交易订单数据失败',
//     xx: '交易订单',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '名称',
//     xx: '订单号',
//     xx: '交易号',
//     xx: '方向',
//     xx: '买入',
//     xx: '卖出',
//     xx: '撤单',
//     xx: '订单状态',
//     xx: '全部成交',
//     xx: '部分成交',
//     xx: '未成交',
//     xx: '成交数量',
//     xx: '成交均价',
//     xx: '成交金额',
//     xx: '成交时间',
//     xx: '交易日期',
//   },
//
//   // ProductFilter.vue
//   ProductFilter: {
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率:',
//     xx: '收益率:',
//     xx: '年化波动率',
//     xx: '年化收益率',
//     xx: '极态策略',
//     xx: '截距',
//     xx: '斜率',
//     xx: '全类型',
//     xx: '股票型',
//     xx: '混合型',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '产品列表',
//     xx: '净值',
//     xx: '累计收益',
//     xx: '年化收益',
//     xx: '年化波动',
//     xx: '初始资产',
//     xx: '当前资产',
//     xx: '初始份额',
//     xx: '当前份额',
//     xx: '产品成立：',
//     xx: '风险回报',
//   },
//
//   // ProductView.vue
//   ProductView: {
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '单位净值:',
//     xx: '累计净值:',
//     xx: '跟踪:',
//     xx: '成立日期',
//     xx: '规模',
//     xx: '总份额',
//     xx: '管理人',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '基本信息',
//     xx: '产品名称',
//     xx: '产品类型',
//     xx: '合作开始时间',
//     xx: '合作结束时间',
//     xx: '初始净值',
//     xx: '营业部名称',
//     xx: '资金账号',
//     xx: '币种',
//     xx: '托管费率',
//     xx: '管理费率',
//     xx: '运营服务费',
//     xx: '费率提取标准',
//     xx: '投资目标',
//     xx: '业绩比较基准',
//     xx: '产品托管人',
//     xx: '市场',
//     xx: '合同号',
//     xx: '状态',
//     xx: '可用',
//     xx: '不可用',
//     xx: '产品描述',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '业绩表现',
//     xx: '累计收益',
//     xx: '(基准)',
//     xx: '年化收益率',
//     xx: '年化收益率',
//     xx: '(基准)',
//     xx: '最大回撤',
//     xx: '最大回撤',
//     xx: '(基准)',
//     xx: '年化波动率',
//     xx: '(基准)',
//   },
//
  // sageIndex.vue
  sageIndex:{
    sageIndex1: 'General Strategy',
    sageIndex2: 'Custom Strategy',
    sageIndex3: 'Product Mgmt',
    sageIndex4: 'Trading Mgmt',
    sageIndex5: 'AI Strategy Lab',
  },
  sageProductFilter: {
    unnamedPoint: 'Unnamed Point',
    jitai: 'Jitai',
    volatilityLabel: 'Volatility',
    returnLabel: 'Return',
    annualizedVolatility: 'Annualized Volatility',
    annualizedReturn: 'Annualized Return',
    jitaiStrategy: 'Jitai Strategy',
    intercept: 'Intercept',
    slope: 'Slope',
    allTypes: 'All Types',
    equityType: 'Equity',
    bondType: 'Bond',
    mixedType: 'Mixed',
    all: 'All',
    past1Month: 'Past 1M',
    past3Months: 'Past 3M',
    past6Months: 'Past 6M',
    past2Months: 'Past 2M',
    past4Months: 'Past 4M',
    past1Year: 'Past 1Y',
    productList: 'Product List',
    nav: 'NAV',
    cumulativeReturn: 'Cumulative Return',
    annualizedReturnShort: 'Annualized Return',
    annualizedVolatilityShort: 'Annualized Volatility',
    initialAssets: 'Initial Assets',
    currentAssets: 'Current Assets',
    initialUnits: 'Initial Units',
    currentUnits: 'Current Units',
    manager: 'Manager',
    founded: 'Established',
    riskReturn: 'Risk Return',
  },
  sageProductView: {
    all: 'All',
    past1Month: 'Past 1M',
    past3Months: 'Past 3M',
    past6Months: 'Past 6M',
    past2Months: 'Past 2M',
    past4Months: 'Past 4M',
    past1Year: 'Past 1Y',
    performance: 'Performance',
    strategyAnalysis: 'Strategy Analysis',
    positionAnalysis: 'Position Analysis',
    tradeManagement: 'Trade Management',
    unitNav: 'Unit NAV:',
    totalNav: 'Total NAV:',
    predictionDay: 'Prediction Day',
    benchmarkTrack: 'Benchmark',
    establishmentDate: 'Establishment Date',
    scale: 'Scale',
    totalUnits: 'Total Units',
    manager: 'Manager',
    collapseMore: 'Collapse<<',
    viewMore: 'View More>>',
    basicInfo: 'Basic Information',
    productName: 'Product Name',
    productType: 'Product Type',
    cooperationStart: 'Cooperation Start',
    cooperationEnd: 'Cooperation End',
    initialNav: 'Initial NAV',
    cumulativeGrowthRate: 'Cumulative Growth Rate',
    to: 'to',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectOverlayIndicator: 'Select Overlay Indicator',
    performanceOverview: 'Performance Overview',
    cumulativeReturn: 'Cumulative Return',
    benchmark: 'Benchmark',
    annualizedReturn: 'Annualized Return',
    maxDrawdown: 'Max Drawdown',
    annualizedVolatility: 'Annualized Volatility',
    logarithm: 'Log',
    predictionDay: 'Prediction Day',
    branchName: 'Branch',
    financialAccount: 'Financial Account',
    currency: 'Currency',
    custodyFeeRate: 'Custody Fee Rate',
    managementFeeRate: 'Management Fee Rate',
    operationalFeeRate: 'Operational Service Fee',
    flatRateStandard: 'Fee Standard',
    investmentTarget: 'Investment Target',
    performanceBenchmark: 'Performance Benchmark',
    custodian: 'Custodian',
    market: 'Market',
    contractNo: 'Contract No.',
    status: 'Status',
    available: 'Available',
    unavailable: 'Unavailable',
    productDescription: 'Product Description',
    benchmarkSuffix: '(Benchmark)',
  },
  sageProductTrade: {
    accountList: 'Account List',
    nav: 'NAV',
    cumulativeReturn: 'Cumulative Return',
    currentAssets: 'Current Assets',
    currentMarketValue: 'Current Market Value',
    availableCash: 'Available Cash',
    dailyPnl: 'Daily P&L',
    dailyBuyQty: 'Daily Buy Qty',
    dailySellQty: 'Daily Sell Qty',
    dailyTradeQty: 'Daily Trade Qty',
    productBelonging: 'Product: ',
    createdAt: 'Created At',
    simulated: 'Simulated',
    live: 'Live',
  },
  sageProductPosition: {
    amount: 'Amount',
    ratio: 'Ratio',
    holdingRatio: 'Holding Ratio',
    stock: 'Stock',
    bond: 'Bond',
    reverseRepo: 'Reverse Repo',
    fund: 'Fund',
    cash: 'Cash',
    currentTotalHolding: 'Current Total Holding',
    targetTotalHolding: 'Target Total Holding',
    totalHoldingHistory: 'Total Holding History',
    currentStockIndustryAnalysis: 'Current Stock Industry Analysis',
    positionDetails: 'Position Details',
    name: 'Name',
    positionQty: 'Position Qty',
    positionAmount: 'Position Amount',
    principal: 'Principal',
    totalPnl: 'Total P&L',
    dailyPnl: 'Daily P&L',
    totalCommission: 'Total Commission',
    totalStampDuty: 'Total Stamp Duty',
  },
  sageProductStrategy: {
    unitNav: 'Unit NAV',
    totalNav: 'Total NAV',
    cumulativeGrowthRate: 'Cumulative Growth Rate',
    strategyAccountSeparator: ' / ',
    strategyList: 'Strategy List',
    strategyName: 'Strategy Name',
    accountName: 'Account',
    strategyDays: 'Strategy Duration',
    accountPerformance: 'Account Performance',
    accountReturn: 'Account Return',
    startTime: 'Start Time',
    endTime: 'End Time',
    days: 'days',
    strategyRange: 'Strategy Range',
    to: 'to',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectOverlayIndicator: 'Select Overlay Indicator',
  },
  productManual: {
    nav: {
      what: 'What Is Jitai AI Copilot',
      value: 'The Value of Jitai AI',
      principles: 'Principles and Advantages',
      modules: 'Product Modules',
      metrics: 'Core Metrics and History',
    },
    section1: {
      title: 'What Is Jitai AI Copilot?',
      intro: 'Jitai AI Copilot is an end-to-end AI research and decision-support platform built for professional investment institutions.',
      bullets: {
        fastMarketView: 'Helps users quickly understand key market trends, structural shifts, and likely future direction.',
        findOpportunities: 'Helps users discover sector, industry, and stock opportunities earlier and understand market rotation more clearly.',
        optimizeStrategy: 'Diagnoses the strengths and weaknesses of existing strategies and portfolios and suggests optimization paths.',
        xrayCompanies: 'Supports long-horizon analysis of listed companies and provides short-cycle trend forecasts.',
        explainRationale: 'Helps users understand the evidence and signals behind each trend more quickly.',
      },
    },
    section2: {
      title: 'What Value Does Jitai AI Provide?',
      p1: 'First, it materially reduces research time. The system can aggregate, clean, organize, read, and interpret macro, industry, company, trading, and sentiment data, then turn that into actionable forecasts and judgments.',
      p2: 'Second, it makes investment decisions more rational and more quantitative. Scores, rankings, and forecasts are generated by systematic models rather than subjective manual inputs or simple blends of third-party ratings.',
      p3: 'Third, it helps portfolios improve adaptability across cycles, sectors, and market regimes, giving users faster access to deeper structural insight.',
    },
    section3: {
      title: 'What Are the Principles and Unique Advantages of Jitai AI?',
      p1: 'First, Jitai AI Copilot is built on an in-house foundation model and then adapted into a complete product for institutional research workflows.',
      p2: 'Second, it does not rely on hand-crafted factor stacking and constant manual retuning. Instead, the model learns underlying economic and financial logic from multi-source, cross-temporal data.',
      p3: 'Third, many complex domains have already shown the ceiling and generalization advantage of deep learning approaches.',
      p4: 'The trend is already clear. Traditional methods are not entirely useless, but the marginal value of manual rule stacking is much lower in front of stronger foundation models.',
      p5: 'The real challenge is not building a demo. It is maintaining a full loop of first-principles architecture, data engineering, model training, and live validation over a long period.',
      examples: {
        stockfish: 'Chess: Stockfish',
        alphazero: 'Go: AlphaZero',
        midjourney: 'Image generation: Midjourney / Stable Diffusion',
        gpt: 'Language understanding and generation: GPT / Llama',
        whisper: 'Speech understanding: Whisper',
        alphafold: 'Protein structure prediction: AlphaFold',
        alphastar: 'Real-time strategy games: AlphaStar',
        tesla: 'Autonomous driving: Tesla FSD',
      },
    },
    section4: {
      title: 'Jitai AI Copilot Product Modules',
      intro: 'The current Copilot mainly covers market-wide, industry-level, and single-stock research and trend forecasting.',
      module1: {
        title: 'Market-wide (A-share) trend forecasting',
      },
      module2: {
        title: 'Industry analysis and trend forecasting',
        sub1: 'Industry forecast map and relationship view',
        sub2: 'Industry historical trend and price-volume view',
      },
      module3: {
        title: 'Single-stock analysis and trend forecasting',
      },
    },
    section5: {
      title: 'Core Copilot Metrics and Historical Performance',
      p1: 'The platform provides multiple AI metrics from different perspectives. The strength indicator is one of the most closely watched core signals. The charts below show representative historical live performance.',
      p2: 'Historically, the spread between high-score and low-score groups is meaningful. Whether the strategy is hedging, macro allocation, index enhancement, or absolute return, the strength indicator can provide additional alpha reference for execution.',
    },
  },
  versionHistory: {
    title: 'Product Updates',
    r3_1_0_1: {
      winRateOdds: 'Added win-rate and odds calculation metrics',
      tradeRecordAdjust: 'Adjusted the trade records module in Trade Management',
      closedPosition: 'Added a closed-position module with full lifecycle data for each fully exited stock',
      dataDownload: 'Added data download support',
      strategyLab: 'Added the Strategy Lab module',
    },
    r3_0_0: {
      customStrategy: 'Added the custom strategy module',
      financialProduct: 'Added the financial products module',
      tradeManagement: 'Added the trade management module',
      strategyLab: 'Added the Strategy Lab module',
    },
    r2_0_3: {
      indexEnhanceBacktest: 'Added backtests for 300/500/1000/2000 index enhancement strategies',
    },
    r2_0_2: {
      multiAssetBacktest: 'Added backtests for multiple stock-bond strategies',
      timeSelector: 'Added a time selector to stock K-line charts',
    },
    r2_0_1: {
      forex: 'Added the forex module',
    },
    r2_0_0: {
      sage: 'Added the Sage module',
    },
    r1_15_1: {
      commodityIndex: 'Added the commodity index module',
    },
    r1_15_0: {
      bondIndex: 'Added the bond index module',
    },
    r1_14_2: {
      multiStockIntraday: 'Added multi-stock intraday display for watchlists',
    },
    r1_14_1: {
      realtimePrice: 'Added real-time price display to watchlists',
    },
    r1_14_0: {
      permissionUpgrade: 'Upgraded the permission system',
      quote: 'Added quote functionality',
      searchHistory: 'Added search history support to the top search bar',
      top20: 'Expanded industry Top10 to Top20',
      industryFiveDays: 'Changed industry 3-day price change view to 5-day',
    },
    r1_13_2: {
      majorIndexes: 'Added real-time price and volume for major domestic indices',
      globalIndexes: 'Added major global indices',
    },
    r1_13_1: {
      industryRealtime: 'Added real-time price and volume for industries',
      industryIntraday: 'Added real-time intraday K-line charts for industries',
    },
    r1_13_0: {
      tickerRealtime: 'Added real-time price and volume for stocks',
      tickerIntraday: 'Added real-time intraday K-line charts for stocks',
    },
    r1_12_2: {
      uiAndBugfix: 'Partial UI optimization and bug fixes including trial application issues',
    },
    r1_12_1: {
      managerPerformance: 'Upgraded fund manager performance analysis',
    },
    r1_12_0: {
      managerDeepAnalysis: 'Deepened fund manager analysis',
    },
    r1_11_0: {
      managerFilter: 'Added the fund manager filter page',
      companyFilter: 'Added the fund company filter page',
      managerDetail: 'Added the fund manager detail page',
      companyDetail: 'Added the fund company detail page',
      companyFundList: 'Added the fund list under each fund company',
      companyManagerList: 'Added the manager list under each fund company',
    },
    r1_10_0: {
      tickerFilter: 'Added the stock filter page',
      speed: 'Improved page response speed',
    },
    r1_9_0: {
      uiAndFundFilter: 'Overall UI optimization and added the fund filter page',
    },
    r1_8_0: {
      fundAnalysis: 'Added the fund analysis module',
    },
    r1_7_1: {
      balanceSheet: 'Added deep balance sheet analysis to stock financial reports',
    },
    r1_7_0: {
      financialStatements: 'Added the stock financial report module, including deep income statement and cash flow analysis',
    },
    r1_6_2: {
      historyReview: 'Added the history review feature, available by permission',
      sortino: 'Added Sortino performance to global and industry performance pages',
    },
    r1_6_1: {
      eventRevamp: 'Revamped the stock events module with more event types and categories, now 30+ event types',
      ratingDetail: 'Added institution rating details to the ratings module',
      shareholderDistribution: 'Added a shareholder distribution chart to the shareholder module',
      scoreDelta: 'Added day-over-day change values for forecast scores',
    },
    r1_6_0: {
      announcement: 'Added the stock announcement events module',
      shareholderChange: 'Added the stock shareholder change module',
    },
    r1_5_0: {
      valuation: 'Added the stock valuation analysis module',
      institutionRating: 'Added the stock institution rating analysis module',
      valuationMetric: 'Added stock valuation metrics',
    },
    r1_4_0: {
      globalPerformance: 'Added the global market performance module',
    },
    r1_3_0: {
      industryPerformance: 'Added the industry market performance module',
    },
    r1_2_1: {
      tickerOverlay: 'Added stock overlays for related industry indices and major market indices',
      indexColor: 'Added color indicators to the major index overlay list',
      adjustedPrice: 'Added adjusted price support for stocks',
      industryOverlay: 'Added industry overlays for related industry indices and major market indices',
      industryL2: 'Added L2 related-list viewing from industry L1 forecasts',
      chartResponsive: 'Improved chart display area with automatic adjustment support',
      breadcrumbBugfix: 'Fixed residual industry breadcrumb display and other bugs',
    },
    r1_2_0: {
      watchlist: 'Added the watchlist module',
      bugfix: 'Fixed various bugs',
    },
    r1_1_1: {
      hover: 'Updated hover content on the industry map',
      mfBugfix: 'Fixed residual stock mf data and other bugs',
    },
    r1_1_0: {
      industryMap: 'Updated the industry map',
      marketOverlay: 'Added a global market overlay area toggle',
      bugfix: 'Fixed various bugs',
    },
    r1_0_4: {
      helpMenu: 'Added a Help menu to the top navigation',
      trialEnd: 'Added trial end time to personal information',
      buttonStyle: 'Adjusted some button styles',
      bugfix: 'Fixed various bugs',
    },
    r1_0_3: {
      keyboard: 'Added Enter key support to login, registration, and related modules',
      color: 'Adjusted colors',
      bugfix: 'Fixed various bugs',
    },
    r1_0_2: {
      versionHistory: 'Added the version history page',
      industryStrength: 'Added strength and crowding ranking charts to industry trend forecasts',
    },
    r1_0_1: {
      release: 'Jitai AI Copilot released',
    },
  },
  sageSeFilter: {
    unnamedPoint: 'Unnamed Point',
    jitai: 'Jitai',
    benchmarkSuffix: '(Benchmark)',
    intervalGrowthRate: 'Interval Growth Rate',
    volatilityLabel: 'Volatility',
    returnLabel: 'Return',
    annualizedVolatility: 'Annualized Volatility',
    annualizedReturn: 'Annualized Return',
    jitaiStrategy: 'Jitai Strategy',
    intercept: 'Intercept',
    slope: 'Slope',
    allTypes: 'All Types',
    equityType: 'Equity',
    mixedType: 'Mixed',
    all: 'All',
    past1Month: 'Past 1M',
    past3Months: 'Past 3M',
    past6Months: 'Past 6M',
    past1Year: 'Past 1Y',
    customStrategyList: 'Custom Strategy List',
    nav: 'NAV',
    cumulativeReturn: 'Cumulative Return',
    annualizedReturnShort: 'Annualized Return',
    annualizedVolatilityShort: 'Annualized Volatility',
    creator: 'Creator',
    createdAt: 'Created At',
    riskReturn: 'Risk Return',
  },
  sageSeView: {
    performance: 'Performance',
    backtest: 'Backtest',
    strategyMonitoring: 'Strategy Monitoring',
    unitNav: 'Unit NAV:',
    totalNav: 'Total NAV:',
    unitNavShort: 'Unit NAV',
    totalNavShort: 'Total NAV',
    cumulativeGrowthRate: 'Cumulative Growth Rate',
    benchmarkTrack: 'Benchmark',
    predictionDay: 'Prediction Day',
    strategyName: 'Strategy Name',
    creator: 'Creator',
    createdDate: 'Created Date',
    establishmentDate: 'Establishment Date',
    scale: 'Scale',
    jitaiStrategy: 'Jitai Strategy',
    manager: 'Manager',
    collapseMore: 'Collapse<<',
    viewMore: 'View More>>',
    basicInfo: 'Basic Information',
    name: 'Name',
    productType: 'Product Type',
    cooperationStart: 'Cooperation Start',
    cooperationEnd: 'Cooperation End',
    custodyFeeRate: 'Custody Fee Rate',
    managementFeeRate: 'Management Fee Rate',
    currency: 'Currency',
    investmentTarget: 'Investment Target',
    market: 'Market',
    custodian: 'Custodian',
    strategyBoundaryConditions: 'Strategy Boundary Conditions',
    strategyOptimizationObjectives: 'Strategy Optimization Objectives',
    strategyOptimizerAttributes: 'Strategy Optimizer Attributes',
    to: 'to',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectOverlayIndicator: 'Select Overlay Indicator',
    strategyTradingInfo: 'Strategy Trading Info',
    latestNav: 'Latest NAV',
    dailyChangePct: 'Daily Change %',
    dailyPnl: 'Daily P&L',
    totalAssets: 'Total Assets',
    availableCash: 'Available Cash',
    positionMarketValue: 'Position Market Value',
    dailyTurnoverAmount: 'Daily Turnover Amount',
    dailyTurnoverVolume: 'Daily Turnover Volume',
    turnoverRate: 'Turnover Rate',
    totalPnl: 'Total P&L',
    totalPnlRatio: 'Total P&L Ratio',
    totalCommission: 'Total Commission',
    totalStampDuty: 'Total Stamp Duty',
    totalTransferFee: 'Total Transfer Fee',
    totalEquity: 'Total Equity',
    totalFixedIncome: 'Total Fixed Income',
    totalManagementFee: 'Total Management Fee',
    totalCustodyFee: 'Total Custody Fee',
    totalPerformanceReward: 'Total Performance Reward',
    stagePerformanceRanking: 'Stage Performance Ranking',
    cumulativeReturn: 'Cumulative Return',
    annualizedReturn: 'Annualized Return',
    maxDrawdown: 'Max Drawdown',
    annualizedVolatility: 'Annualized Volatility',
    benchmarkSuffix: '(Benchmark)',
    oneWeek: '1W',
    oneMonth: '1M',
    threeMonths: '3M',
    oneYear: '1Y',
    threeYears: '3Y',
    intervalGrowthRate: 'Interval Growth Rate',
    rank: 'Rank',
    rankPercentile: 'Rank Percentile',
    fundStyle: 'Fund Style',
    totalOpenSlip: 'Total Slippage (Open)',
    totalLastCloseSlip: 'Total Slippage (Prev Close)',
    dailyOpenSlip: 'Daily Slippage (Open)',
    dailyLastCloseSlip: 'Daily Slippage (Prev Close)',
    underlyingReturn: 'Underlying Return',
    excessReturn: 'Excess Return',
    noData: 'No Data',
  },
  sageStrategyFilter: {
    investmentPolicyList: 'Investment Policy List',
    policyAnalytics: 'Policy Analytics',
    policyNames: 'Policy Names',
    noPerformanceData: 'No historical performance data',
    backtestList: 'Investment Policy List',
    performanceTrend: 'Historical Performance',
    strategyDetails: 'Policy Analytics',
    strategyCooperation: 'Strategy Cooperation',
    strategyCapacity: 'Policy Capacity (est.)',
    riskReturn: 'Risk Return',
    capacityTip: '### Policy Capacity (est.)\n- Estimates Jitai strategy capacity based on strategy characteristics and market liquidity.\n- Helps assess whether a strategy can be implemented and scaled.\n<br>',
    riskReturnTip: '### Risk Return\n- Compares Jitai strategy risk and return with those of different types of public fund managers.\n- Shows risk-adjusted performance through quantitative analysis.\n<br>',
    periodOneYearShort: '1Yr',
    scaleVsAlpha: 'Scale VS Alpha',
    indexEnhance: 'Index Enhance',
    industryRotation: 'Industry Rotation',
    selectTopAndCancel: 'Select Top {count} / Cancel',
    totalCount: '(Total {count})',
    searchByName: 'Search by Name',
    benchmarkPrefix: 'Benchmark: ',
    cumulativeReturn: 'Cumulative Return',
    annualizedReturnShort: 'Annualized Return',
    annualizedGrowthRate: 'Annualized Growth Rate',
    annualizedAlpha: 'Annualized Alpha',
    sharpeRatio: 'Sharpe Ratio',
    maxDrawdown: 'Max Drawdown',
    winRate: 'Win Rate',
    payoffRatio: 'Payoff Ratio',
    past3Months: 'Past 3M',
    past6Months: 'Past 6M',
    past1Year: 'Past 1Y',
    all: 'All',
    past1Month: 'Past 1M',
    past2Months: 'Past 2M',
    past4Months: 'Past 4M',
    unitYi: 'B',
  },
  sageStrategyView: {
    intro: 'Overview',
    strategyManager: 'Strategy Manager',
    strategyTarget: 'Strategy Target',
    strategyIntroduction: 'Strategy Introduction',
    performanceTrend: 'Performance Trend',
    performanceOverview: 'Performance Overview',
    performanceOverviewTip: 'A complete view of strategy performance across time windows, with multi-dimensional benchmark comparison.',
    antiFragilityStrategyAnalysis: 'Industry Anti-fragility Strategy Analysis',
    antiFragilityExAllAAnalysis: 'Anti-fragility Analysis Excluding All-A Impact',
    benchmarkPrefix: 'Benchmark: ',
    mean: 'Mean',
    unitNav: 'Unit NAV',
    accumulatedNav: 'Accumulated NAV',
    cumulativeExcess: 'Cumulative Excess',
    industryGrowthRate: 'Industry Growth Rate',
    industryAntiFragilityGrowthRate: 'Industry Anti-fragility Growth Rate',
    industryExMarketGrowthRate: 'Industry Growth Rate Excluding Market',
    industryExMarketAntiFragilityGrowthRate: 'Industry Anti-fragility Growth Rate Excluding Market Impact',
    industryIndexGrowth: 'Industry Index Growth',
    industryIndexExAllA: 'Industry Index Excluding All-A Impact',
    industryAntiFragilityExAllA: 'Industry Anti-fragility Excluding All-A Impact',
    industryAntiFragilityEnhancedExAllA: 'Enhanced Industry Anti-fragility Excluding All-A Impact',
    industryAntiFragility: 'Industry Anti-fragility',
    industryAntiFragilityEnhanced: 'Enhanced Industry Anti-fragility',
    unnamedPoint: 'Unnamed Point',
    extremeStateKeyword: 'Extreme State',
    volatility: 'Volatility',
    returnRate: 'Return',
    intercept: 'Intercept',
    slope: 'Slope',
    all: 'All',
    past1Month: 'Past 1M',
    past3Months: 'Past 3M',
    past6Months: 'Past 6M',
    past1Year: 'Past 1Y',
  },
//
//   // SEBackTestView.vue
//   SEBackTestView: {
//     xx: '预测日',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '单位净值:',
//     xx: '成立日期',
//     xx: '规模',
//     xx: '极态策略',
//     xx: '管理人',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '基本信息',
//     xx: '名称',
//     xx: '产品类型',
//     xx: '合作开始时间',
//     xx: '合作结束时间',
//     xx: '托管费率',
//     xx: '管理费率',
//     xx: '币种',
//     xx: '投资目标',
//     xx: '市场',
//     xx: '产品托管人',
//     xx: '累计增长率',
//     xx: '累计净值',
//     xx: '单位净值',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '交易信息',
//     xx: '成交额',
//     xx: '换手率',
//     xx: '最新净值',
//     xx: '当日涨跌幅',
//     xx: '当日涨跌金额',
//     xx: '累计净值',
//     xx: '累计权益类总计',
//     xx: '累计固收类总计',
//     xx: '持有市值',
//     xx: '可用余额',
//     xx: '盈利总额',
//     xx: '盈利总额比例',
//     xx: '总交易佣金',
//     xx: '总印花税',
//     xx: '总管理费',
//     xx: '总托管费',
//     xx: '总业绩报酬',
//     xx: '累计滑点(今开)',
//     xx: '累计滑点(昨收)',
//     xx: '当日滑点(今开)',
//     xx: '当日滑点(昨收)',
//     xx: '标的收益',
//     xx: '超额收益',
//     xx: '无数据',
//     xx: '业绩阶段排名',
//     xx: '近1周',
//     xx: '近1月',
//     xx: '近3月',
//     xx: '近1年',
//     xx: '近3年',
//     xx: '年化收益率',
//     xx: '区间增长率',
//     xx: '排名',
//     xx: '排名百分位',
//     xx: '基金风格',
//
//   },
//
//
//   // SEFilter.vue
//   SEFilter: {
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '年化波动率',
//     xx: '年化收益率',
//     xx: '极态策略',
//     xx: '截距',
//     xx: '斜率',
//     xx: '全类型',
//     xx: '股票型',
//     xx: '混合型',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '定制策略列表',
//     xx: '净值',
//     xx: '累计收益',
//     xx: '年化收益',
//     xx: '最大波动',
//     xx: '创建人',
//     xx: '创建时间',
//     xx: '风险回报'
//   },
//
//   // SEView.vue
//   SEView: {
//     xx: '预测日',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '业绩',
//     xx: '策略监控',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '跟踪',
//     xx: '策略名称',
//     xx: '创建人',
//     xx: '创建日期',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '策略边际条件',
//     xx: '策略优化目标',
//     xx: '策略优化器属性',
//     xx: '累计增长率',
//     xx: '累计净值',
//     xx: '单位净值',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '策略交易信息',
//     xx: '最新净值',
//     xx: '累计净值',
//     xx: '当日涨跌幅',
//     xx: '当日盈亏',
//     xx: '总资产',
//     xx: '可用资金',
//     xx: '持仓市值',
//     xx: '当日成交额',
//     xx: '当日成交量',
//     xx: '换手率',
//     xx: '总盈亏',
//     xx: '总佣金',
//     xx: '总印花税',
//     xx: '总过户费',
//     xx: '业绩阶段排名',
//     xx: '累计收益',
//     xx: '累计收益',
//     xx: '(基准)',
//     xx: '年化收益率',
//     xx: '年化收益率',
//     xx: '(基准)',
//     xx: '最大回撤',
//     xx: '最大回撤',
//     xx: '(基准)',
//     xx: '(基准)',
//     xx: '年化波动率',
//     xx: '年化波动率',
//     xx: '(基准)'
//   },
//
//   // StrategyFilter.vue
//   StrategyFilter: {
//     tips1: '### 回测列表 \n - 按资产大类对回测结果进行分组，方便分类查看。\n - 提供不同预测时间窗口的切换功能，用以观察在不同时间窗口内的回测表现。 \n - 展示策略累计业绩表现，支持与基准的多维度对比。',
//     tips2: '### 回测走势 \n - 支持叠加不同指数进行对比，直观了解策略回测的相对表现。\n - 可视化展现回测期间的策略回报走势，便于分析趋势与波动。',
//     tips3: '### 策略详情 \n - 提供不同时间段内策略的收益和风险指标的详细信息。\n - 便于了解策略在各种市场环境下的表现特性。',
//     tips4: '### 策略容量 \n - 基于策略特性和市场流动性，测算极态策略的容量。 \n - 协助评估策略可执行性和扩展性。',
//     tips5: '### 风险回报 \n - 对比极态策略的风险回报指标与不同类型公募基金经理的表现 \n - 通过定量化分析，展现策略在风险调整后的收益水平。',
//     xx: '天',
//     xx: '累计增长率',
//     xx: '亿',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '极态',
//     xx: '未命名点',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '年化波动率',
//     xx: '年化收益率',
//     xx: '极态策略',
//     xx: '截距',
//     xx: '斜率',
//     xx: '出错',
//     xx: '全类型',
//     xx: '股票型',
//     xx: '混合型',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '回测列表',
//     xx: '股债平衡',
//     xx: '行业轮动',
//     xx: '指数增强',
//     xx: '选前',
//     xx: '个 / 取消',
//     xx: '共',
//     xx: '只',
//     xx: '输入名称快速定位',
//     xx: '基准',
//     xx: '累计收益',
//     xx: '年化收益',
//     xx: '最大回撤',
//     xx: '累计收益',
//     xx: '(基准)',
//     xx: '年化收益',
//     xx: '最大回撤',
//     xx: '策略合作',
//     xx: '业绩走势',
//     xx: '累计增长率',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '策略表现详情',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '策略名称',
//     xx: '基准：',
//     xx: '区间增长率',
//     xx: '年化增长率',
//     xx: '年化alpha',
//     xx: '夏普比率',
//     xx: '年化波动率',
//     xx: '最大回撤',
//     xx: '策略容量',
//     xx: '风险回报',
//     xx: '(近一年)',
//
//   },
//
//   // StrategyPFilter.vue
//   StrategyPFilter: {
//     tips1: '### 回测列表 \n - 按资产大类对回测结果进行分组，方便分类查看。\n - 提供不同预测时间窗口的切换功能，用以观察在不同时间窗口内的回测表现。\n - 展示策略累计业绩表现，支持与基准的多维度对比。',
//     tips2: '### 回测走势 \n - 支持叠加不同指数进行对比，直观了解策略回测的相对表现。 \n - 可视化展现回测期间的策略回报走势，便于分析趋势与波动。',
//     tips3: '### 策略详情 \n - 提供不同时间段内策略的收益和风险指标的详细信息。 \n - 便于了解策略在各种市场环境下的表现特性。',
//     tips4: '### 策略容量 \n - 基于策略特性和市场流动性，测算极态策略的容量。\n - 协助评估策略可执行性和扩展性。',
//     tips5: '### 风险回报 \n - 对比极态策略的风险回报指标与不同类型公募基金经理的表现 \n - 通过定量化分析，展现策略在风险调整后的收益水平。',
//     xx: '累计增长率',
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '年化波动率',
//     xx: '年化收益率',
//     xx: '极态策略',
//     xx: '截距',
//     xx: '斜率',
//     xx: '出错',
//     xx: '全类型',
//     xx: '股票型',
//     xx: '混合型',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '回测列表',
//     xx: '选前',
//     xx: '个 / 取消',
//     xx: '共',
//     xx: '只',
//     xx: '输入名称快速定位',
//     xx: '基准',
//     xx: '累计收益',
//     xx: '年化收益',
//     xx: '最大回撤',
//     xx: '累计收益',
//     xx: '(基准)',
//     xx: '年化收益',
//     xx: '最大回撤',
//     xx: '策略合作',
//     xx: '业绩走势',
//     xx: '累计增长率',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '策略表现详情',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '策略名称',
//     xx: '基准',
//     xx: '区间增长率',
//     xx: '年化增长率',
//     xx: '年化alpha',
//     xx: '夏普比率',
//     xx: '年化波动率',
//     xx: '最大回撤',
//     xx: '策略容量',
//     xx: '风险回报',
//     xx: '(近一年)',
//   },
//
//   // strategyPView.vue
//   strategyPView: {
//     xx: '### 业绩表现 \n - 全面展示策略在不同时间段的业绩表现，支持与基准的多维度对比。',
//     xx: '均值',
//     xx: '换手率',
//     xx: '累计超额',
//     xx: '行业指数增长',
//     xx: '行业指数-去除全A影响',
//     xx: '行业反脆弱-去除全A影响',
//     xx: '行业反脆弱-增强-去除全A影响',
//     xx: '行业反脆弱',
//     xx: '行业反脆弱-增强',
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '截距',
//     xx: '斜率',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '简介',
//     xx: '策略名称',
//     xx: '策略管理人',
//     xx: '策略简介',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '业绩走势',
//     xx: '累计增长率',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '基准',
//     xx: '交易信息',
//     xx: '成交额',
//     xx: '换手率',
//     xx: '最新净值',
//     xx: '当日涨跌幅',
//     xx: '当日涨跌金额',
//     xx: '累计净值',
//     xx: '累计权益类总计',
//     xx: '累计固收类总计',
//     xx: '持有市值',
//     xx: '可用余额',
//     xx: '盈利总额',
//     xx: '盈利总额比例',
//     xx: '总交易佣金',
//     xx: '总印花税',
//     xx: '总管理费',
//     xx: '总托管费',
//     xx: '总业绩报酬',
//     xx: '累计滑点(今开)',
//     xx: '累计滑点(昨收)',
//     xx: '当日滑点(今开)',
//     xx: '当日滑点(昨收)',
//     xx: '标的收益',
//     xx: '超额收益',
//     xx: '无数据',
//     xx: '业绩表现',
//     xx: '累计收益',
//     xx: '年化收益率',
//     xx: '(基准)',
//     xx: '最大回撤',
//     xx: '年化波动率',
//     xx: '行业反脆弱策略分析',
//     xx: '行业去除全A影响的反脆弱分析',
//
//   },
//
//   // strategyView.vue
//   strategyView:{
//     tips6: '### 业绩表现 \n - 全面展示策略在不同时间段的业绩表现，支持与基准的多维度对比。',
//     xx: '均值',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '换手率',
//     xx: '累计超额',
//     xx: '行业增长率',
//     xx: '行业反脆弱增长率',
//     xx: '行业去除市场的增长率',
//     xx: '行业去除市场影响的反脆弱的增长率',
//     xx: '行业指数增长',
//     xx: '行业指数-去除全A影响',
//     xx: '行业反脆弱-去除全A影响',
//     xx: '行业反脆弱-增强-去除全A影响',
//     xx: '行业反脆弱',
//     xx: '行业反脆弱-增强',
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '截距',
//     xx: '斜率',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '业绩',
//     xx: '简介',
//     xx: '策略名称',
//     xx: '策略管理人',
//     xx: '策略简介',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '业绩走势',
//     xx: '累计增长率',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '交易信息',
//     xx: '成交额',
//     xx: '换手率',
//     xx: '最新净值',
//     xx: '当日涨跌幅',
//     xx: '当日涨跌金额',
//     xx: '累计净值',
//     xx: '累计权益类总计',
//     xx: '累计固收类总计',
//     xx: '持有市值',
//     xx: '可用余额',
//     xx: '盈利总额',
//     xx: '盈利总额比例',
//     xx: '总交易佣金',
//     xx: '总印花税',
//     xx: '总管理费',
//     xx: '总托管费',
//     xx: '总业绩报酬',
//     xx: '累计滑点(今开)',
//     xx: '累计滑点(昨收)',
//     xx: '当日滑点(今开)',
//     xx: '当日滑点(昨收)',
//     xx: '标的收益',
//     xx: '超额收益',
//     xx: '业绩表现',
//     xx: '累计收益',
//     xx: '累计收益',
//     xx: '年化收益率',
//     xx: '最大回撤',
//     xx: '(基准)',
//     xx: '年化波动率',
//     xx: '行业反脆弱策略分析',
//     xx: '行业去除全A影响的反脆弱分析',
//   },
//
//   // TradeFilter.vue
//   TradeFilter: {
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '年化波动率',
//     xx: '年化收益率',
//     xx: '极态策略',
//     xx: '全类型',
//     xx: '股票型',
//     xx: '混合型',
//     xx: '账户列表',
//     xx: '净值',
//     xx: '累计收益',
//     xx: '年化收益',
//     xx: '最大波动',
//     xx: '当前资产',
//     xx: '当前市值',
//     xx: '可用资金',
//     xx: '当日盈亏',
//     xx: '当日买入量',
//     xx: '当日卖出量',
//     xx: '当日交易量',
//     xx: '所属产品：',
//     xx: '创建时间：',
//     xx: '模拟盘',
//     xx: '实盘',
//     xx: '风险回报'
//   },
//
//   // TradeView.vue
//   TradeView: {
//     xx: '预测日',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '跟踪',
//     xx: '成立日期',
//     xx: '规模',
//     xx: '券商名称',
//     xx: '策略名称',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '基本信息',
//     xx: '账户名称',
//     xx: '账户类型',
//     xx: '模拟',
//     xx: '实盘',
//     xx: '所属产品',
//     xx: '市场类型',
//     xx: '币种',
//     xx: '佣金税率',
//     xx: '印花税率',
//     xx: '过户税率',
//     xx: '账户状态',
//     xx: '可用',
//     xx: '不可用',
//     xx: '累计增长率',
//     xx: '累计净值',
//     xx: '单位净值',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '账户交易信息',
//     xx: '总资产',
//     xx: '当前市值',
//     xx: '可用现金',
//     xx: '当日买入量',
//     xx: '当日卖出量',
//     xx: '当日交易额',
//     xx: '当日盈亏',
//     xx: '总盈亏',
//     xx: '总佣金',
//     xx: '总印花税',
//     xx: '最新净值',
//     xx: '累计净值',
//     xx: '业绩表现',
//     xx: '累计收益',
//     xx: '累计收益',
//     xx: '年化收益率',
//     xx: '(基准)',
//     xx: '最大回撤',
//     xx: '年化波动率',
//
//   },
//
//   // mainHeader.vue
//   mainHeader: {
//     xx: '请输入股票、行业、基金名称或代码',
//     xx: '搜索历史',
//     xx: '历史',
//     xx: '选择时间',
//     xx: '更新时间',
//     xx: '官网',
//     xx: '帮助',
//     xx: '报价',
//     xx: '',
//   },
//
//
//   // registerRaw.vue
//   registerRaw: {
//     tip1: `
// ## 北京极态科技有限公司风险提示和法律声明
// **风险提示：** 用户应充分了解金融投资风险，并认识到所有投资决策均需独立作出。我们的服务旨在提供参考信息，不构成任何形式的投资建议、买卖邀约或招揽。我们不负责审查或确认用户的具体投资目的、财务状况或需求。投资者应独立评估我们服务中的信息和建议，并根据自身情况作出投资决策。对于依据我们服务内容所做的任何投资决策及其产生的后果，公司不承担任何责任。
// **法律声明：** 北京极态科技有限公司（以下简称“我们”）为用户提供的软件产品或服务，是基于公开大数据并结合自身模型进行综合技术处理，从而进行系统的整理、加工、创新、运算和集成构建而成的模型、方法、推演或分析。旨在为投资者提供由行情数据、趋势分析、热点研判、选股模型、资讯解读或研报整理等具有高附加值的投资辅助系统产品或服务，以帮助用户在投资过程中进行理性投资、自主决策与风险控制。
// 我们通过认为可靠的公开资料获取信息，并基于现有技术进行数据加工和分析。尽管我们致力于提供准确和完整的信息，但我们不对所提供信息的准确性、时效性或完整性作出任何形式的保证或承诺。用户应明白所有预测和推荐均存在不确定性，过往表现不预示未来结果。服务可能因技术限制、数据源偏差、计算误差或市场极端情况等因素而受限。我们鼓励用户在使用我们的服务时保持谨慎，并自主进行决策且独立承担风险。
// 对于使用或依赖我们服务所造成的直接或间接损失，我们不承担任何法律责任。
// 请注意，使用我们的服务即表示您已阅读、理解并同意本免责声明的所有条款！本声明的解释权归北京极态科技有限公司所有。
// **联系方式：** 如有任何疑问或需要进一步信息，请通过inquiry@jitai.ai与我们联系。若发现任何个人或机构冒用我们名义提供服务，敬请向我们报告。
//     `,
//     tip2:  `
// ## 《北京极态科技隐私保护指引》
// 我们希望我们的AI模型了解的是整个世界，而不是个人隐私。我们不会积极寻找个人信息来训练我们的模型，也不会使用互联网上的公共信息来建立个人资料，更不会出售用户数据。我们努力做到减少我们训练数据集中的个人信息量；训练模型拒绝请求个人隐私信息的要求；最小化我们的模型可能生成包含私人个人信息的响应/报告的可能性。
//
// 引言
// 本隐私政策适用于北京极态科技（以下称“极态科技”或“我们”）平台各产品和服务及公司旗下所有产品和服务。如某款极态科技产品有单独的隐私政策则该产品的隐私政策将优先适用。该产品隐私政策未涵盖的内容，以本隐私政策内容为准，该产品隐私政策与本隐私政策有冲突的内容，以产品隐私政策为准。
//
// 本隐私政策旨在帮助您了解我们会收集哪些数据、为什么收集这些数据，会利用这些数据做些什么及如何保护这些数据。除非法律、行政法规另有规定，针对我们如何处理您的个人信息，您享有知情权和决定权，有权限制或者拒绝我们或其他方对您的个人信息进行处理；同时，您有权要求我们对我们向您提供的个人信息处理规则进行解释说明。
//
// 本隐私政策将帮助您了解以下内容：
// 一、 我们如何收集和使用您的个人信息
// 二、 我们如何使用 Cookie 和同类技术
// 三、 我们如何共享、转让、公开披露您的个人信息
// 四、 我们如何保存及保护您的个人信息
// 五、 您的权利
// 六、 第三方服务
// 七、 您的个人信息如何跨境转移
// 八、 国际用户
// 九、 本隐私政策的修订
// 十、 如何联系我们
//
//
// 一、我们如何收集和使用您的个人信息
// 我们会严格按照法律法规要求和我们向您提供的个人信息处理规则来处理您的个人信息。我们一般会基于以下目的收集和使用您的个人信息：
//
// 1. 为用户注册/登录所需的个人信息处理活动
// 极态科技平台产品和服务适用统一的账号体系，您注册账号时须至少向我们提供手机号。如果您仅需使用浏览、搜索等非登录状态可使用的基本服务，您有权选择不予注册成为我们的用户并不提供上述信息。
//
// 为符合现行法律法规的强制性要求或使用特定产品功能所必需，当您在使用某些我们特定的产品且需要填写手机号等账号注册时已经提供的信息时，为了方便您的使用，我们可能会默认显示您极态科技账号绑定的手机号等相关信息，您可以根据相应产品功能进行修改。为了您可基于同一账号在极态科技产品中享有一致性的体验，您在极态科技某一产品中账号关注及被关注记录可能会被记录在极态科技账号下，并在您登录其他相关产品时进行展示，此项服务基于“汇聚融合”条款实现，但并不视为极态科技公司的必然义务。
//
// 注册信息除了用于识别您的身份之外，我们也会将其用于其他与服务相关的功能场景中，例如我们会利用收集的信息（例如您的手机号码、电子邮件地址）直接与您沟通或互动；如果我们或使用极态科技账号体系的公司检测到可疑活动（例如尝试从不同于平常的位置登录您的极态科技账号）时，可能会向您发送通知；或者，我们或使用极态科技账号体系的公司可能会与您联系，让您了解为您提供的服务即将发生的变化或改进，邀请您参加新产品的体验等。
//
// 为了确保您的账号及财产安全，进行风险控制和防御，当您注册/登录账号时，我们会收集您的设备信息以及与注册/登录环境相关的信息(包括国际移动设备身份码IMEI、广告标识符IDFA、集成电路卡识别码ICCID、设备名称、设备型号、操作系统版本、WIFI信息BSSID、SSID、IP地址信息)。
// 通信信息：如果您与我们进行通信，我们将收集您的姓名、联系信息和您发送的任何消息的内容（“通信信息”）。 社交媒体信息：我们在社交媒体网站上拥有页面，如微信公众号或其他社交媒体。当您与我们的社交媒体页面互动时，我们将收集您选择向我们提供的个人信息，例如您的联系方式（统称为“社交信息”）。此外，托管我们社交媒体页面的公司可能会向我们提供有关我们社交媒体活动的汇总信息和分析信息。 您提供的其他信息：我们收集您可能向我们提供的其他信息，例如当您参加我们的活动或调查，或向我们提供信息以建立您的身份时（统称为“您提供的其他信息”）。从您使用服务中自动收到的个人信息：当您访问、使用或与服务进行交互时，我们将收到以下关于您的访问、使用或交互的信息（“技术信息”）。
//
// 为了满足法律法规的强制性要求、出于提供产品或服务所必需或者基于您对增强账号保护级别的需求，在您使用某些服务时或您有进一步需求时，您需提供您的真实姓名、身份证号、人脸信息完成账号实名认证。如您不进行实名认证，可能会影响到您使用需要经过实名认证才能使用的业务功能。为了验证您提供信息的准确性和完整性，或保障您的账号安全，我们可能会将您向极态科技提供的实名信息与法律法规允许的机构或政府机关授权的机构所保存的您的对应信息进行比对核验。为了保障您的账号安全，确保账号实名一致性同时为您提供便捷的服务，您在极态科技账号完成实名认证后，上述实名信息将作为该账号在所有接入极态科技账号服务的产品中的通用认证信息，为了保障您的个人信息安全，请勿将您的账号转让、租借他人使用。如果超出上述处理范围，除法律法规另有规定外，个人信息处理者将按照法律法规的要求另行征得您的同意。
//
// 2. 为提供服务所需的个人信息处理活动
// 基于您选择的不同服务内容，在提供服务过程中，我们可能会收集关于您使用产品和/或服务（包括使用方式）过程中的相关个人信息以达到服务目的。其中，当部分服务为极态科技及第三方共同为您提供时，出于为您提供服务所必需，我们和第三方可能会共同处理您的个人信息。为提供服务所需的个人信息的类别和内容具体以您所启用的服务内容和功能为准，一般包括：
//
// 产品使用信息
// 我们可能会记录您在使用我们的产品和/或服务时主动提供、留存的信息。例如您主动发布、反馈、评论、上传的文字图片、音视频、金融账户信息、持仓信息、投资策略信息等，您参与其他产品运营活动时提交的联系方式信息。
//
// 设备信息
// 可能包括您终端设备的设备属性信息（例如最终用户的硬件型号，操作系统版本，设备配置，国际移动设备身份码IMEI、国际移动用户识别码IMSI、网络设备硬件地址MAC、广告标识符IDFA、供应商标识符IDFV、移动设备识别码MEID、匿名设备标识符OAID 、集成电路卡识别码ICCID 、Android ID、硬件序列号等设备标识符）、设备连接信息（例如浏览器的类型、电信运营商、使用的语言、WIFI信息）以及设备状态信息（例如设备应用安装列表、设备传感器信息）。
//
// 日志信息
// 当您使用极态科技平台产品和服务时，我们的服务器会自动记录一些信息，例如您对我们的产品和/或服务的使用情况、IP地址、所访问服务的URL、浏览器的类型和使用的语言、下载、安装或使用移动应用和软件的信息、与通讯软件通讯的信息以及访问服务的日期、时间、时长等。
//
// 3. 为了实现自动化决策和个性化推荐所需的个人信息处理活动
//
// 汇聚融合
// 在极态科技平台产品和服务中，在确保个人信息均处于同一业务实体的控制之下且不改变数据安全保障能力和管理水平的情况下，您同意我们将通过我们自身或受托方技术对您在极态科技平台产品和服务中主动或被动提供的个人信息进行汇聚融合、识别分析、数据画像或进一步加工，并形成能够反映您的投资行为习惯、经济状况、信用状况、投资偏好等身份特征的标签信息（以下简称“标签信息”），我们会将标签信息用于具体的场景和目的中进行自动化决策，向您推送个性化展示的信息和/或商业营销信息，我们会保障信息在汇聚融合后的安全处理。为了能给您提供一致的服务，我们可能会在取得您的授权后将您的设备信息或电话号码与您的极态科技账号相关联，对于同一账号在不同设备上主动或被动提供的个人信息进行关联和汇聚。
//
// 个性化推荐
// 我们可能基于设备信息、日志信息、标签信息、位置信息等要素通过计算机算法模型自动计算、综合分析、预测您可能感兴趣的信息内容或功能服务，以进行个性化推荐活动。在个性化推荐服务中，我们将同时向您提供便捷的拒绝方式等以便您进行控制。不同产品或服务的个性化推荐服务应用场景、运行机制以及实现控制的方式可能不同，具体请见具体产品或服务的隐私政策相关描述。
//
// 自动化决策
// 自动化决策活动同样依赖于我们对标签信息的处理。自动化决策可能用于不同的具体场景，部分以自动化决策方式作出的决定可能对您的权益产生显著影响；在此情况下，您有权通过具体产品或服务的隐私政策描述的联系方式要求我们做出说明，您也有权拒绝仅以自动化决策的方式作出的决定。我们将提供适当的救济方式保障您的合法权利，例如向您说明自动化决策的逻辑及对您产生的相关影响，或引入人工审核复核自动化决策结果的正确性。
//
// 信息搜索
// 为了持续优化提升信息搜索结果及效果以满足您的搜索需求，当您输入搜索词后，我们会从相关性、时效性、权威性、过往搜索历史、现有资产配置、策略信息和质量等维度寻找更匹配您需求的搜索结果集合，并在搜索结果页向您进行排序展示。
//
// 4. 为您提供安全保障
// 为提高您使用我们与极态科技关联方、合作方提供的产品和服务的安全性，我们可能使用您的信息用于身份验证、客户服务、安全防范、诈骗监测等，以预防、发现和/或调查欺诈、危害安全及其它非法或违反与我们的协议、政策或规则的行为，以保护您、我们的其他用户、我们或极态科技关联方、合作方及社会公众的合法权益。为了防范和抵制违法信息及不良信息的发布及传播，保障您使用我们的产品和服务时的内容安全，我们通过计算机算法模型自动计算、综合分析网络信息内容，如发现网络信息内容包含违法信息及不良信息，则立即停止传输并采取处置措施。
//
// 5. 改善我们的产品和服务，并开展内部审计、数据分析和研究
// 我们可能会使用收集的信息来改进我们的产品和服务，并进行必要的业务运营和分析研究，例如运营产品或提供服务，评估、维护和改进产品和服务的性能，开发新的产品和服务、提供客户支持等。
//
// 为改进我们及极态科技关联方、合作方的产品和服务，我们也可能会对产品使用情况进行统计和分析。同时，极态科技可能会与公众共享这些统计信息，以展示我们服务的整体使用趋势，但这些统计信息将不会包含您的任何身份识别信息。
//
// 6. 改进产品服务安全性和个性化程度
// 为改进产品服务的安全性和个性化程度等合理需要，我们可能按照法律法规的规定或基于您的有效授权从极态科技平台各产品和服务提供方、极态科技关联方、合作方、合作伙伴、其他受信任的第三方供应商处接收您的个人信息及其他信息，并可能对相关信息进行加工使用。我们将事先要求个人信息提供方说明个人信息来源，并对其个人信息来源的合法性进行确认，并确保我们处理您的个人信息有足够的合法性基础，例如，如果我们基于同意处理您的个人信息，而开展业务所需进行的个人信息处理活动超出已获得的授权同意范围的，我们将在获取个人信息后的合理期限内或处理个人信息前，征得您的同意，或通过个人信息提供方征得您的同意。
//
// 7. 极态科技深度学习大模型的训练和研发
// 为了更好的向您提供服务和精准的预测结果，我们将对于您在使用产品过程中产生的大数据做个人信息脱敏处理，并在脱敏后统一用于训练极态科技一个或多个大模型。除非获得您的单独授权之外，您的个人隐私信息（例如手机号码、姓名、住所等标识类信息）将通过技术手段脱敏，确保在训练过程中您的个人隐私信息不会被模型“明码学习”。为确保我们的产品可以更好的服务最多的用户，极态科技大模型在训练过程中不会针对特定对象、个人或组织进行针对性的策略训练，并尽可能减少训练中的歧视和偏差问题。
//
// 8. 其他处理目的
// 我们可能出于提供不同产品或服务所需，为实现其他特定处理目的而开展个人信息处理活动，您可以参考具体极态科技产品的隐私政策，或者联系我们为您说明。
//
// 二、我们如何使用 Cookie 和同类技术
// 为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。Cookie主要的功能是便于您使用网站产品和服务，以及帮助网站统计独立访客数量等。运用Cookie技术，我们能够为您提供更加周到的个性化服务，并允许您设定您特定的服务选项。
//
// 当您使用极态科技的产品和服务时，我们会向您的设备发送一个或多个Cookie或匿名标识符。当您与我们提供给合作伙伴的服务（例如广告和/或推广服务，以及可能显示在其他网站上的由极态科技提供的服务功能）进行交互时，我们允许Cookie（或者其他匿名标识符）将您访问、使用产品或服务的相关信息发送给极态科技的服务器。
//
// 我们不会将 Cookie 用于本隐私政策或具体产品隐私政策所述目的之外的用途。您可根据自己的偏好管理或删除 Cookie。您可以通过根据具体产品隐私政策的说明限制极态科技公司对Cookie的使用。
//
// 我们可能会出于以下目的使用个人信息
// 提供、管理、维护和/或分析服务； 改进我们的服务并进行研究； 与您沟通；包括向您发送有关我们的服务和活动的信息； 开发新的计划和服务； 防止欺诈、犯罪活动或滥用我们的服务，并保护我们的IT系统、架构和网络的安全； 进行业务转让； 遵守法律义务和法律程序，并保护我们的权利、隐私、安全或财产，以及我们的关联公司、您或其他第三方的权利、隐私、安全或财产。
//
// 聚合或去标识化信息。我们可能会聚合或去标识化个人信息，以使其不再用于识别您，并使用此类信息来分析我们服务的有效性，改进和增加我们服务的功能，进行研究和进行其他类似的目的。此外，我们可能会不时分析我们服务的用户的一般行为和特征，并与第三方分享一般用户统计信息，发布此类聚合信息或使此类聚合信息普遍可用。我们可能会通过服务、通过cookie以及通过本隐私政策中描述的其他方式收集聚合信息。我们将以匿名或去标识化形式维护和使用去标识化信息，并不会试图重新识别信息，除非法律要求。
//
// 如上所述，我们可能会使用您提供给我们的内容来改进我们的服务，例如训练支持极态科技的大经济模型。
//
// 三、我们如何共享、转让、公开披露您的个人信息
// 1. 共享
// 我们会以高度的勤勉义务对待您的信息。除法律法规明确规定的其他情形外，未经您单独同意，我们不会向除极态科技外的任何公司、组织和个人共享您的信息。我们的某些服务由授权合作伙伴提供，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享与第三方提供服务相关的个人信息。除另行获得您的授权或法律法规另有规定，我们的合作伙伴无权将共享的个人信息用于任何其他用途。对我们与之共享个人信息的公司、组织和个人，我们会签署严格的协议，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理共享的个人信息。
//
// 在某些情况下，除非法律要求，否则我们可能会向第三方提供您的个人信息，而无需进一步通知您。
//
// 供应商和服务提供商
// 为了帮助我们满足业务运营需求并执行某些服务和功能，我们可能会向供应商和服务提供商提供个人信息，包括提供托管服务、客户服务供应商、云服务、电子邮件通信软件、网络分析服务和其他信息技术提供商等。根据我们的指示，这些方将仅在履行其对我们的职责过程中访问、处理或存储个人信息。
//
// 关联方或同一账号体系使用方
// 我们与我们的关联方或同一账号体系使用方之间具备高度一致的数据安全保障措施和管理水平。为提高您使用产品的安全性和便利性，并具备一致性的服务体验，在遵循法律要求的前提下，我们会在关联方或同一账号体系使用方之间共享您的个人信息。
//
// 关联公司
// 我们可能会向我们的关联公司披露个人信息，即控制极态科技的实体、受极态科技控制的实体，或与极态科技共同受控制的实体。我们的关联公司可能会以与本隐私政策一致的方式使用我们分享的个人信息。
//
// 2. 委托处理与共同处理
// 为了更好地为您提供服务，我们可能委托第三方合作伙伴处理您的个人信息。我们仅会出于合法、正当、必要、特定、明确的目的委托第三方合作伙伴处理您的信息。我们会严格限制受托方的信息处理目的并要求受托方采取充分的数据安全保障手段。如果第三方合作伙伴将您的信息用于我们未委托的用途，其将另行征得您的同意。未经您有效授权，我们不会将可以直接识别您个人身份的信息委托第三方合作伙伴处理。如您主动为特定第三方合作伙伴留下您的联系方式、地址信息等个人信息以供其与您取得联系，其将直接处理您的个人信息。
// 在共同处理场景下，我们同样会按照法律法规要求与合作方签署符合法律法规要求的相关协议，并履行相关个人信息保护义务。
//
// 3. 转让
// 我们不会将您的个人信息转让给除极态科技及其关联公司外的任何公司、组织和个人，但以下情形除外：
// （1）事先获得您的明确授权或同意；
// （2）满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；
// （3）如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性、向您告知接收方的名称或姓名和联系方式，并要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
//
// 4. 公开披露
// 我们仅会在以下情形下，公开披露您的个人信息：
// （1） 获得您的单独同意；
// （2） 基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。
//
// 5. 共享、转让、公开披露个人信息时事先征得授权同意的例外
// 在以下情形中，我们共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
// （1） 为履行法定职责或者法定义务所必需（例如与国家安全、国防安全、刑事侦查、起诉、审判和判决执行等直接相关的法定义务）；
// （2） 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
// （3） 在合理的范围内处理您自行公开或者其他已经合法公开的您的个人信息（如合法的新闻报道、政府信息公开等渠道）；
// （4） 根据个人信息主体要求签订和履行合同所必需的；
// （5） 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
// （6） 法律法规及国家标准规定的其他情形。
//
// 根据法律规定，共享、转让经匿名化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
//
// 6.业务转让
// 如果我们涉及战略交易、重组、破产、接管或将服务转移到另一提供商（统称为“交易”），则您的个人信息和其他信息可能会在与交易有关的尽职调查过程中向交易对方和协助交易的其他人员披露，并作为交易的一部分与其他资产一起转移到继任者或关联公司。
//
// 7.法律要求
// 我们可能会与政府机关、行业同行或其他第三方分享您的个人信息，包括您与我们服务的互动信息，（i）如果法律要求我们这样做，或者在诚信相信这样的行动是必要的，以遵守法律义务，（ii）为了保护和捍卫我们的权利或财产，（iii）如果我们确定，凭我们的唯一判断，存在违反我们的条款、政策或法律的行为；（iv）检测或预防欺诈或其他非法活动；（v）保护我们产品、员工或用户，或公众的安全、安全性和完整性，或（vi）保护免受法律责任。
//
// 8.业务帐户管理员
// 当您申请加入极态科技商业帐户时，该帐户的管理员可能会访问和管理您的极态科技帐户。此外，如果您使用属于您的雇主或其他组织的电子邮件地址创建帐户，我们可能会与您的雇主或组织共享您拥有极态科技帐户的事实以及某些帐户信息，例如您的电子邮件地址，以便使您能够添加到他们的商业帐户。
//
// 四、我们如何保存及保护您的个人信息
// 1. 保存期限
// 我们将在提供服务所需的期限内保存您的个人信息，但法律法规对保存期限另有规定、您同意留存更长的期限、保证服务的安全与质量、实现争议解决目的、技术上难以实现等情况下，在前述保存期限到期后，我们将依法、依约或在合理范围内延长保存期限。在超出保存期限后，我们将根据法律规定删除您的个人信息或进行匿名化处理。
//
// 2. 保存地域
// 您的个人信息一般储存于中华人民共和国境内。如因部分产品或服务涉及跨境等原因，我们需要向境外提供您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。
//
// 3. 安全措施
// （1） 我们会以业界成熟的安全标准和规范收集、使用、存储和传输用户信息，并通过用户协议和隐私政策告知您相关信息的使用目的和范围。
// （2） 我们非常重视信息安全。我们成立了专责团队负责研发和应用多种安全技术和程序等，我们会对安全管理负责人和关键安全岗位的人员进行安全背景审查，我们建立了完善的信息安全管理制度和内部安全事件处置机制等。我们会采取符合业界标准的合理可行的安全措施和技术手段存储和保护您的个人信息，以防止您的信息丢失、遭到被未经授权的访问、公开披露、使用、修改、毁损、丢失或泄漏。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。
// （3） 我们会对员工进行数据安全的意识培养和安全能力的培训和考核，加强员工对于保护个人信息重要性的认识。我们部署了访问控制机制，对处理个人信息的员工进行身份认证及权限控制，并会与接触您个人信息的员工、合作伙伴签署保密协议，明确岗位职责及行为准则，确保只有授权人员才可访问个人信息。若有违反保密协议的行为，会被追究相关责任。
// （4） 我们提醒您注意，互联网并非绝对安全的环境，当您通过电子邮件、短信等与其他用户交互信息时，不确定第三方软件对信息的传递是否完全加密，请注意确保您个人信息的安全，我们建议您不要通过此类方式发送个人信息，以免个人信息泄露。请您使用复杂密码，并不要随意将您的极态科技账号和密码提供给他人，以协助我们保证您的账号以及个人信息安全。
//
// 4. 安全事件通知
// （1） 我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。
// （2） 个人信息泄露、毁损、丢失属于公司级特大安全事件，我们会负责定期组织工作组成员进行安全预案演练，防止此类安全事件发生。若一旦不幸发生，我们将按照最高优先级启动应急预案，由安全部、政府关系部、法务部等多个部门组成应急响应小组，在最短时间内追溯原因并减少损失。
// （3） 在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们将及时将事件相关情况以站内通知、短信通知、电话、邮件等您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
//
// 五、您的权利
// 按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
//
// 1. 查阅和复制您的个人信息
//
// 您有权访问和复制您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问和复制您的个人信息：
//
// 账号信息：您可以随时登录www.jitai.info ，访问或编辑您的账户中的个人资料信息、更改您的密码、进行账号关联或身份认证等。如果您无法通过上述链接访问该等个人信息，您可以通过个人信息保护问题反馈，随时与我们联系。
//
// 对于您在使用我们的产品和服务过程中产生的其他个人信息，如果您想行使查阅权、复制权，可参考具体产品隐私政策或通过个人信息保护问题反馈与我们联系。为保障安全，我们可能在您行使查阅权、复制权前对您的身份进行验证。
//
// 2. 更正或补充您的个人信息
// 您发现我们处理的关于您的个人信息有不准确或不完整时，您有权对不准确或不完整的信息作出更正或补充，您可以参考具体产品隐私政策或通过个人信息保护问题反馈随时与我们联系。为保障安全，我们可能在您行使更正权、补充权前对您的身份进行验证。
//
// 3. 删除您的个人信息
// 在以下情形中，您可以通过具体产品隐私政策的说明或通过个人信息保护问题反馈随时与我们联系，向我们提出删除个人信息的请求：
// （1） 处理目的已实现、无法实现或者为实现处理目的不再必要；
// （2） 我们停止提供产品或者服务，或者保存期限已届满；
// （3） 您撤回同意；
// （4） 我们违反法律、行政法规或者违反约定处理个人信息；
// （5） 法律、行政法规规定的其他情形。
// 当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
//
// 我们在产品设计的过程中及最终的呈现和用户体验环节，将尽可能地为您控制个人信息提供更为便捷的方式。由于不同产品的功能服务不同，因此为您提供的个人信息控制方式及设计可能不同，请您在使用具体产品时阅读相关产品隐私政策进一步了解。
//
// 4. 撤回同意
// 每个业务功能需要一些基本的个人信息才能得以完成。对于我们基于您的同意处理的个人信息，您可以随时给予或收回您的授权同意。当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。
//
// 5. 注销您的账号
// 您随时可注销此前注册的账号。您可以通过联系inquiry@jitai.ai申请注销您的极态科技账号。一旦您注销极态科技账号，将无法使用极态科技全线用户产品和服务（部分无需注册/登录机台账号即可使用的服务功能除外），因此请您谨慎操作。我们为了保护您或他人的合法权益会结合您对极态科技各产品和服务的使用情况判断是否支持您的注销请求。例如您的网盘中还存有资料，则我们不会立即支持您的请求。
//
// 6. 提前获知产品和服务停止运营
// 极态科技愿一直陪伴您，若因特殊原因导致极态科技平台产品和服务被迫停止运营，我们将按照法律法规要求在产品和/或服务的主页面或站内信或向您发送电子邮件或其他合适的能触达您的方式通知您，并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理等。
//
// 7. 个人信息可携权
// 在符合国家相关法律法规及网信部门规定的条件下，如您请求将个人信息转移至其指定的个人信息处理者，我们将按照相关规定的要求提供转移的途径。
//
// 8. 响应您的上述请求
// 为保障安全，您行使您的上述权利需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
//
// 对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
// 在以下情形中，按照法律法规要求，我们将无法响应您的上述请求：
// （1） 与国家安全、国防安全直接相关的；
// （2） 与公共安全、公共卫生、重大公共利益直接相关的；
// （3） 与刑事侦查、起诉、审判和执行判决等直接相关的；
// （4） 我们有充分证据表明您存在主观恶意或滥用权利的（如您的请求将危害公共安全和其他人合法权益，或您的请求超出了一般技术手段和商业成本可覆盖的范围）；
// （5） 响应个人信息主体的请求将导致您或其他个人、组织的合法权益受到严重损害的；
// （6） 涉及商业秘密的；
// （7） 与我们履行法律法规规定的义务相关的；
// （8） 法律法规规定的其他情形。
//
// 我们采取商业上合理的技术、管理和组织措施，保护个人信息在在线和离线环境中免受丢失、滥用和未经授权的访问、披露、更改或销毁。然而，没有任何互联网或电子邮件传输是完全安全或无误的。特别是，发送给我们或由我们发送的电子邮件可能不安全。因此，您在决定通过服务或电子邮件向我们发送什么信息时应特别小心。此外，我们不对绕过服务或第三方网站上包含的任何隐私设置或安全措施负责。
//
// 我们将仅保留您的个人信息，以满足向您提供我们的服务的需要，或出于其他合法的业务目的，例如解决争端、安全和保障原因，或遵守我们的法律义务。我们保留个人信息的时间将取决于多种因素，例如信息的数量、性质和敏感性，未经授权使用或披露可能导致的潜在风险，我们处理信息的目的，以及任何法律要求。
//
// 六、第三方服务
// 极态科技服务可能接入或链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：
// 2. 这些功能可能会收集您的信息（包括您的日志信息），并可能在您的设备内装置COOKIES，从而正常运行上述功能；
//
// 3. 我们通过广告或我们服务的其他方式向您提供链接，使您可以链接至第三方的服务或网站；
//
// 3、其他接入第三方服务的情形。例如，为实现本政策中声明的目的，我们可能会接入第三方服务商提供的SDK或其他类似的应用程序（如以嵌入代码、插件等形式），以便向您提供更好的客户服务和用户体验。目前，我们接入的第三方服务商主要包括以下几种类型：
// （1）用于广告相关服务，包括广告展示、广告数据监测/统计等；
// （2）用于消息推送功能，包括手机厂商Push推送、特定事件提醒、个性化内容推荐等；
// （3）用于支付相关服务，包括订单支付、交易行为核验、收入结算、支付信息汇总统计等；
// （4）用于在您同意的情况下获取设备位置权限、搜集设备信息和日志信息等；
// （5）用于第三方授权服务，包括第三方账号登陆、将有关内容分享至第三方产品等；
// （6）用于支持产品功能模块，包括在线直播、视频播放、语音识别、AR、智能客服、弹幕播放、内容存储等；
// （7）用于优化产品性能，包括提高硬件配网能力、降低服务器成本、功能热修复等；
// （8）用于账号安全、产品加固相关服务，包括网络监测、域名解析、防劫持、反垃圾反作弊、加解密服务等。
//
// 我们接入的部分第三方SDK或类似应用程序可能会收集您的个人信息，如您在我们的服务中使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。我们会评估这类第三方服务收集个人信息的合法性、正当性、必要性，要求该等第三方对您的个人信息采取保护措施，并严格遵守相关法律法规与监管要求。您也可以选择通过本政策“如何联系我们”章节所列的反馈渠道联系我们，我们会尽快为您作出解答。
//
// 以上第三方社交媒体或其他服务由相关的第三方负责运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本政策）约束，您需要仔细阅读其条款。本政策仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。如您发现这些第三方社交媒体或其他服务存在风险时，建议您终止相关操作以保护您的合法权益并及时与我们取得联系。
//
// 我们可能向您发送的信息
//  信息通知
// 您在使用我们的服务时，我们可能向您发送电子邮件、短信、资讯或推送通知。您可以按照我们的相关提示，在设备上选择取消订阅。如特定的产品和服务存在个性化推送的信息，请您查阅该产品和服务具体的隐私保护指引获取更能多的信息、或关闭个性化推荐。
//
//  与服务有关的公告
// 我们可能在必要时（例如，因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于广告的公告。
//
// 信息安全
// 我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露。
// 我们严格遵守法律法规保护用户的通信秘密。
// 我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们使用加密技术、匿名化处理等手段来保护您的个人信息。
// 我们建立专门的管理制度、流程和组织确保信息安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。
// 若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。
//
// 七、您的个人信息如何进行跨境转移
// 原则上，我们在中国境内收集和产生的个人信息，将存储在中国境内。如因部分产品或服务涉及跨境等原因，我们需要向境外提供您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。
//
// 八.   国际用户
// 通过使用我们的服务，您理解并承认您的个人信息将在我们位于中国的设施和服务器中进行处理和存储，并可能披露给我们在其他司法管辖区的服务提供商和关联公司。
//
// 处理的法律依据。我们处理您的个人信息的法律依据包括：
// 与您签订的合同的履行，当我们提供和维护我们的服务时。当我们仅为了向您提供我们的服务而处理帐户信息、内容和技术信息时，这些信息是必要的以便能够向您提供我们的服务。如果您不提供这些信息，我们可能无法向您提供我们的服务。我们的合法利益在于保护我们的服务免受滥用、欺诈或安全风险的侵害，包括在开发、改进、推广我们的服务和训练我们的大经济模型时。这可能包括处理帐户信息、内容、社交信息和技术信息。在我们要求您同意为我们向您传达的特定目的处理您的个人信息时的您的同意。您有权随时撤回您的同意。 遵守我们的法律义务，当我们使用您的个人信息遵守适用法律或保护我们或我们的关联公司、用户或第三方的权利、安全和财产时。
//
// 数据传输：在必要时，我们将使用适当的保障措施将个人信息转移至某些国家之外。我们只会根据法律有效的转移机制转移个人信息。
//
// 九、隐私政策的修订
// 我们可能适时修订本隐私政策内容。如该等变更会导致您在本隐私政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。我们会在本页面上发布对本隐私政策所做的任何变更。
//
// 若您不同意该等变更可以停止使用极态科技平台产品和服务。
//
// 本隐私政策所指的重大变更包括但不限于：
// （1） 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
// （2） 个人信息共享、转让或公开披露的主要对象发生变化；
// （3） 您参与个人信息处理方面的权利及其行使方式发生重大变化；
// （4） 其他可能对您的个人信息权益产生重大影响的变化时。
//
// 十、如何联系我们
// 如您对本隐私政策有任何意见或建议，可通过inquiry@jitai.ai联系我们。为保障我们高效处理您的问题并及时向您反馈，需要您提交身份证明、有效联系方式和书面请求及相关证据，我们会在验证您的身份后处理您的请求。一般情况下，我们将在15个工作日内回复。
//
// 如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：向北京极态科技有限公司住所地有管辖权的法院提起诉讼。
//
//
// 附录1：定义
// 本隐私政策中使用的特定词语，具有如下含义：
// 1. “我们”或“极态科技”，指北京极态科技有限公司。
// 2. “您”，指使用我们的产品和服务的用户以及收费服务的购买方。
// 3. “极态科技关联方、合作方”，指我们的关联公司、投资公司、联盟成员、合作伙伴及其他受信任的第三方供应商、服务商及代理商。
// 4. “我们的产品和服务”或“极态科技平台产品和服务”，指极态科技旗下各项服务（包括但不限于极态AI Copilot、极态AI组合优化器、极态AI策略实验室、极态AI全域风险管理、极态AI投顾、极态科技手机助手等网站、程序、服务、工具及客户端；具体可参考www.jitai.info）。
// 5. “个人信息”，指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。个人信息包括个人基本信息、个人身份信息、个人生物识别信息、网络身份标识信息、个人健康生理信息、个人教育工作信息、个人财产信息、个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息等。为免疑义，个人信息包括但不限于敏感个人信息。
// 6. “个人信息主体”，指个人信息所标识的自然人。
// 7. “敏感个人信息”，指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
// 8. “去标识化”，指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。
// 9. “匿名化”，指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。
//     `,
//     tip3:  `
// ## 北京极态科技用户服务协议
// 欢迎您使用北京极态科技提供的服务！
// 一、服务条款的确认和接纳
// 1. 《北京极态科技用户服务协议》（以下简称“本协议”）是用户（以下或称“您”）与北京极态科技有限公司（以下称“极态科技”或“我们”）之间签署的具有法律约束力的协议。本协议适用于极态科技移动客户端（“APP”）、 PC端、WEB端、WAP端等产品及软件著作权归属于极态科技的产品（以下可称“本产品”），如极态AI Copilot、极态AI组合优化器、极态AI策略实验室、极态AI全域风险管理、极态AI投顾等。您注册极态科技账号和/或使用极态科技提供的任何服务均受本协议之约束。
// 2. 除非您已经充分阅读、完全理解并接受本协议的各项条款，否则您无法使用极态科技提供的产品和服务。如果您在产品相关页面点击接受本协议、或在注册、登录的过程中作出同意本协议的意思表示、或在极态科技向您展示、推送本协议或本协议的更新版本后仍继续使用极态科技提供的服务、或您以其他方式作出同意本协议的意思表示，均代表您完全理解并同意本协议的全部条款。
// 二、协议的范围
// 1. 本协议除正文外，还包含《北京极态科技隐私保护指引》和《北京极态科技风险提示和法律声明》。
// 2. 您在使用极态科技提供的特定服务时，相关特定服务可能涉及单独适用的协议、政策、规则、规范或指引，该等涉及相关特定服务的协议等文件将构成本协议的有效补充，与本协议有同等的法律效力。
// 三、服务内容
// 1. 极态科技向用户提供的服务（以下可称“本服务”）包括但不限于：（1）极态AI Copilot：提供全市场、行业、概念，以及多维度个股的AI分析、推演和预测；（2）极态AI组合优化器：深度分析现有仓位风险暴露、合规隐患，当下优化程度，和AI建议组合优化方案；（3）极态AI策略实验室：提供高仿真的历史回溯实验室，深度分析和对比不同策略的历史表现；（4）极态AI全域风险管理：捕捉市场风险因子，结合市场动态分析和预判，降低事前风险暴露水平，提升事中管控能力，事后深度总结；（5）极态AI投顾：根据客户核心投资需求，利用AI技术匹配多个可选资产配置方案，深度分析不同方案的相对优劣条件，自动完成客户选择方案。定期提供最新配置分析和资产配置方案更新。
// 2. 极态科技的服务是以收费的方式提供的，您可以自行决定付费购买极态科技提供的决策工具权益，具体收费标准可以参考 [www.jitai.info](http://www.jitai.info) 官网上的产品服务模块。“7天无理由退货”不适用于本服务协议。
// 3. 您应当理解，您使用极态科技提供的服务时需自备设备（包括电脑、移动终端等），并承担所需的费用（如上网费等费用），同时，您使用本服务时需耗用终端设备和宽带等资源。
// 4. 您同意极态科技保留在任何时候对本产品进行升级或修改的权利，以及保留针对修改或升级的产品收取费用的权利。
// 5. 您理解并同意，极态科技基于经营策略调整等方面的需要，可能会对服务内容进行变更，也可能中断、中止或终止服务，上述操作均无需经过您的同意或向您发送通知。
// 6. 如果您在使用极态科技的服务时存在以下任意一种情形（或极态科技有合理的理由认为您存在或者可能存在下列任意一种情形），极态科技有权在不经通知且不征求您的同意的情况下，随时中断或终止向您提供部分或全部的服务（包括收费服务和免费服务），而无需对您或任何第三方承担任何责任，由此造成的损失完全由您自行承担：
//   - （1）您向极态科技提供的个人信息或资料不真实；
//   - （2）您违反法律法规、监管要求、公序良俗或本协议的规定；
//   - （3）您在使用极态科技提供的收费服务时未按规定支付相应的服务费用；
//   - （4）您侵犯或涉嫌侵权他人的知识产权、姓名权、名称权、名誉权、荣誉权、肖像权、隐私权、商业秘密等合法权益的；
//   - （5）极态科技按照法律法规的规定，或按照司法机关或监管机构的要求采取中断或终止服务的措施的；
//   - （6）极态科技有其他合理理由认为需要中断或终止向您提供服务的。
// 7. 极态科技提醒您，您有责任自行备份存储在本服务中的与您相关的信息和数据。如果您的服务被终止，极态科技有权从服务器上永久地删除您的信息和数据，法律法规另有规定的除外，极态科技没有义务向您提供或返还任何信息或数据。
// 8. 如您对本指引存在任何疑问，或对于您的个人信息处理存在任何投诉、意见，请通过客服电子邮箱inquiry@jitai.ai联系我们，客服部门将会同相关部门及时答复您。为保障您的信息安全，我们需要先验证您的身份和凭证资料。我们已经建立客户投诉管理机制，包括跟踪流程。一般来说，我们将在验证通过后的5个工作日内处理完成，特殊情形下最长将在不超过15天或法律法规规定期限内作出答复。如您不满意我们的答复，您还可以向消费者权益保护部门投诉或向有管辖权的法院提起诉讼。
// 四、账户注册和认证
// 1. 您在使用极态科技提供的服务前需要注册一个用户账户（以下或称“账户”）。根据《中华人民共和国网络安全法》及《移动互联网应用程序信息服务管理规定》等的实名制的要求，您在注册账户时需要提供您的手机号码，以便完成账户注册并正常使用我们的相关服务。
// 2. 您应保证您在注册账户时所提供的个人信息和资料的真实性、完整性和准确性。您在完善和设置信息时应当确保相关信息的内容和形式符合法律法规、监管要求、本协议的约定以及社会公序良俗，不得侵犯任何主体的合法权益。
// 3. 账户可以用于极态科技旗下的各项产品，包括极态极态AI Copilot、极态AI组合优化器、极态AI策略实验室、极态AI全域风险管理、极态AI投顾等互联网账户的登录。另外，部分数据有区域使用限制、产品使用限制或禁止多终端同时登录使用等限制。
// 4. 极态科技特别提醒您妥善保管您的账户和密码。当您使用完毕后，您应当及时安全退出。因您保管不善导致您的账户被盗用或者密码失窃，相关责任由您自行承担。极态科技明确表示不提供任何类型的担保，不论是明确的或隐含的。账户的使用权不得馈赠、出借、租用、转让或售卖。用户同意保障和维护极态科技全体成员的利益，负责支付由用户使用超出服务范围引起的律师费用，违反服务条款的损害补偿费用，其它人使用用户的电脑、帐号和其它知识产权的追索费。
// 5. 极态科技会采取并不断更新技术措施，努力保护您的账户安全。当您发现账号疑似被盗，建议您尽快修改密码保证账号的安全性。若您遗忘密码，您可以通过手机号验证方式找回密码。若仍无法解决，您可通过客服电子邮箱inquiry@jitai.ai提供证明材料后处理。
// 6. 极态科技分配给您的账户属于极态科技的财产。您的账户被终止或停用后，极态科技可以收回该账户。
// 7. 您有权注销您的账户。您可以通过inquiry@jitai.ai与极态科技的客服取得联系。在您注销账号之后，极态科技将停止为您提供服务，并根据法律法规的规定删除您的个人信息，法律法规另有规定的除外。请您知悉，注销账号是不可逆的行为，一旦您注销账户，您使用极态科技服务的权利马上中止。从那时起，极态科技不再对用户承担任何义务。我们建议您审慎考虑，并在申请注销账户前自行备份与账户相关的个人、自选股、组合、策略等其他信息和数据。
// 五、个人信息的保护
// 1. 极态科技将按照《北京极态科技隐私保护指引》（下称“隐私指引”）收集、使用、存储和分享用户的个人信息。我们非常重视您的隐私保护，在您使用极态科技的服务时，我们将通过隐私指引告知您我们如何收集、使用、存储和共享您的个人信息，以及您如何访问、更新、控制和保护您的个人信息，并说明您享有的权利。
// 2. 用户主动填写的注册信息为北京极态科技有限公司及其子公司所有，北京极态科技有限公司及其子公司可据此为用户提供服务。极态科技一定不会公开、编辑或透露用户的注册资料及保存在极态科技各项服务中的非公开内容，除非极态科技在诚信的基础上认为透露这些信息在以下几种情况是必要的：
//   - （1）遵守有关法律规定，包括在国家有关机关查询时，提供用户在极态科技的网页上发布的信息内容及其发布时间、互联网地址或者域名。
//   - （2）遵从极态科技产品服务程序。
//   - （3）保持维护极态科技的商标所有权。
//   - （4）在紧急情况下竭力维护用户个人和社会大众的隐私安全。
//   - （5）根据第七条的规定或者极态科技认为必要的其他情况下。
// 3. 用户在此授权极态科技可以向其电子邮箱发送商业信息并同意向其预留的电话号码拨打回访电话。用户在享用极态科技各项服务的同时，同意接收极态科技发出的各类信息。
// 4. 我们的业务面向十八周岁以上公民和具有独立法律人格的公司。
// 六、知识产权条款
// 1. 极态科技在产品和服务中所提供的内容（包括但不限于网页、界面设计、设计要素、产品流程设计、版面框架、文字、图片、视频、音频等）所涉及的知识产权归极态科技或相关权利人所有。未经极态科技或相关权利人事先书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
// 2. 极态科技在产品中提供的行情展示、行情分析报告、行情统计、舆情分析、AI模型预测、AI资产评分、AI研报、资产相关性分析、AI组合评分及优化建议、AI投资策略分析、AI生成的投资策略组合等相关数据均为极态科技数据资产。未经事先书面同意，您不得对以上数据进行复制或向任何机构或个人提供全部或部分数据，不得将全部或部分数据用于开发衍生品。您不得以任何方式将全部或部分行情数据用于任何非法目的。
// 七、用户行为规范及法律责任
// 1. 您在使用极态科技提供的服务时必须遵守法律法规、监管要求及社会公共秩序和道德风尚，不得制作、复制、发表、传播、储存存在下列任何一项情形的内容或信息：
//   - （1）违反宪法基本原则的；
//   - （2）违反法律、行政法规、监管要求的；
//   - （3）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
//   - （4）煽动民族仇恨、民族歧视，破坏民族团结的；
//   - （5）破坏国家宗教政策、宣扬邪教和封建迷信的；
//   - （6）散布谣言或虚假信息，扰乱社会秩序，破坏社会稳定的；
//   - （7）有损社会主义道德风尚或违背社会公序良俗的；
//   - （8）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；
//   - （9）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
//   - （10）侵害他人知识产权、姓名权、名誉权、荣誉权、肖像权、隐私权、商业秘密等合法权益的；
//   - （11）涉及他人隐私、个人信息或资料，或涉及他人商业秘密的；
//   - （12）包含骚扰信息、垃圾信息、广告信息的；
//   - （13）侮辱或者诽谤他人的；
//   - （14）存在其他法律或行政法规禁止的内容。
// 2. 除非得到极态科技的事先书面许可，您不得从事以下任何一项行为：
//   - （1）删除本产品所有关于版权的信息和内容；
//   - （2）对本产品进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本产品的源代码；
//   - （3）采用任何方式（包括但不限于使用第三方软件、插件、外挂、系统、设备等）对本产品的功能和运行效果进行干扰、破坏、修改或施加其他影响。
// 3. 极态科技如发现或收到他人投诉您存在违反本协议约定、法律法规、监管要求或社会公序良俗的行为时，或极态科技有合理的理由认为您可能存在上述情况时，将会通过技术等手段采取必要措施，相关必要措施包括但不限于对您的账户采取临时或永久功能限制，或终止向您提供服务等，且极态科技有权依据中国法律法规之规定保存有关信息并向相关政府部门进行报告。极态科技可能会根据司法或监管机关的要求，或者在诉讼等法律程序中向相关有权机关提供案件所涉用户的注册信息、身份信息（如有）和联系方式。
// 4. 如您违反本协议约定、法律法规及监管要求导致第三方主张赔偿的，您应当独立承担责任，因此给极态科技造成损失的，您应承担全部的赔偿责任。
// 八、不可抗力及免责声明
// 1. 您理解并同意，您在使用极态科技的产品或服务的过程中可能遭受不可抗力，极态科技将努力配合相关单位或部门进行处理，但在法律允许的范围内对您或第三方遭受的损失免责。
// 2. 您理解并同意，对于极态科技所提供的任何信息、数据和分析结果，极态科技均不保证真实性、完整性和准确性，且相关信息和数据不作为任何投资建议或其他实际操作的建议，用户据此进行市场类、交易类或其它衍生商业决策以及操作所产生的后果由用户自行承担，具体提示请阅读《北京极态科技风险提示和法律声明》。
// 3. 除极态科技与用户签订独立的《用户等级协议》并明确相关服务等级条款的之外，极态科技不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性、连续性、安全性、出错发生都不作担保。极态科技拒绝提供任何担保，包括信息能否准确、及时、顺利地传送。用户理解并接受下载或通过极态科技产品服务取得的任何信息资料取决于用户自己，并由其承担系统受损或资料丢失的所有风险和责任。极态科技对在极态科技上得到的任何商品购物服务或交易进程，都不作担保。用户不会从极态科技收到口头或书面的意见或信息，极态科技也不会在这里作明确担保。在法律允许的范围内，极态科技对以下风险不向用户或者任何第三方承担责任：
//   - （1）计算机病毒、木马或其他恶意程序黑客攻击导致的风险；
//   - （2）用户的电脑软件、系统、硬件和通信线路出现故障导致的服务终端、数据丢失或损毁等风险；
//   - （3）网络信号不稳定导致的登录失败、服务中断、资料数据丢失等风险；
//   - （4）用户发布的内容被他人转发和分享的风险；
//   - （5）用户收到来自他人误导、欺骗、威胁或诽谤等非法或不良内容的风险；
//   - （6）用户操作不当或通过非极态科技授权的方式使用服务所导致的风险；
//   - （7）其他极态科技无法合理预见或控制的情形所导致的风险。
// 4. 您理解并同意极态科技对直接、间接、偶然、特殊及继起的损害不负责任，这些损害来自：不正当使用产品服务，非法使用服务或用户传送的信息有所变动。这些损害会导致公司形象受损，所以极态科技早已提出这种损害的可能性。
// 5. 您理解并同意，极态科技依据本协议约定获得处理违法违规内容的权利，但该权利不构成极态科技的任何承诺或义务，极态科技不保证能及时发现用户在使用极态科技的产品或服务时存在的违法违规行为，也不保证会对相关违法违规行为进行相应处理。
// 6. 您理解并同意，极态科技保留根据业务需求在不经通知的情况下单方面变更、暂停、终止全部或部分服务内容的权利。您接受极态科技行使变更或中断服务的权利，极态科技不需对用户或第三方负责。
// 7. 您理解并同意，极态科技保留对违反法律法规、监管要求、本协议规定或极态科技发布的其他可适用的规则、政策、指引等的用户暂停或终止向其提供服务的权利。
// 九、通知和送达
// 1. 极态科技可能会通过包括但不限于软件页面提示、网站公告、系统通知、官方管理账号通知（公开或者私下）、手机短信、三方推送、站内消息等通知方式中的一种或多种向您送达相关通知、提示等信息。通知成功发出时，即被视为已送达您。
// 2. 由于用户提供的手机等信息有误或因为其他不可归咎于极态科技的原因，导致用户未收到通知，不影响通知对该用户的效力。
// 3. 极态科技可能通过您的手机号、APP账号等发产品更新，功能更新，产品活动，营销以及其它提示性信息。
// 十、适用法律和争议解决方式
// 1. 本协议的成立、生效、履行、解释和争议解决适用中华人民共和国的法律（不包含港澳台地区法律），并且排除一切冲突法规定的适用。
// 2. 如出现任何争议和纠纷，极态科技将与用户友好协商处理；协商不成时，用户和极态科技一致同意有关本协议以及使用极态科技的服务产生的争议交由仲裁解决，但是极态科技有权选择采取诉讼方式，并有权选择受理该诉讼的有管辖权的法院。若有任何服务条款与法律相抵触，那这些条款将按尽可能接近的方法重新解析，而其它条款则保持对用户产生法律效力和影响。
// 十一、其他
// 1. 您使用极态科技提供的产品或服务视为您已经阅读并接受本协议全部条款的约束。您如果对本协议持有任何异议，应立即停止使用极态科技提供的产品和服务。
// 2. 极态科技有权在必要时修改本协议条款，您可以在相关服务页面查阅最新版本的协议条款。本协议变更后，您继续使用极态科技的产品和/或服务的，视为接受变更后的协议的约束。
// 3. 本协议条款的标题仅为阅读方便，本身无实际含义，不作为本协议涵义解释的依据。
// 4. 本协议条款部分无效或不可执行，其余条款仍有效，对双方具有约束力。
//     `,
//   },
//
//
//   // ProductManual.vue
//   ProductManual: {
//     xx: '极态AI Copilot 是什么',
//     xx: '极态AI的价值是什么',
//     xx: '极态AI的原理和独特优势是什么',
//     xx: '极态AI Copilot 功能模块介绍',
//     xx: 'Copilot 核心指标介绍/历史表现评估',
//
//     xx: '极态AI Copilot 是什么？',
//     xx: '极态AI Copilot是第一款为专业投资机构打造的端到端AI决策辅助平台。',
//     xx: '帮助用户快速掌握全市场的核心趋势动态和未来走势',
//     xx: '让用户抢先挖掘到潜在机会板块/行业机会，并更好的理解市场轮动周期',
//     xx: '诊断现有投资策略组合的优劣程度，提供优化方案',
//     xx: '帮助用户X-Ray每家上市公司的全历史并提供未来2周的走势预测',
//     xx: '帮助用户快速理解趋势背后的依据',
//
//     xx: '极态AI的价值是什么？',
//     xx: '1）极态AI将大量降低用户的投研时间。当下大部分金融机构的主要人力开支在搜集数据/整理数据/理解数据上。极态AI Copilot系统一站式搜集、归类、清洗、阅读并理解每天最新的宏观经济/金融环境，横跨130个L2行业、5000+全A上市公司的数亿笔交易，每天数千个公司动态事件，每天上万份研报/媒体报告和每天数百万的社交媒体互动。在其基础之上，提供可执行的预测结果。让用户从大量的投研工作中解放出来，从而提高决策效率。',
//     xx: '2）极态AI让投资决策更加理性、更具备量化基础。极态AI Copilot 所有的评分机制是基于系统算法计算，没有任何人工输入，更不是简单基于不同机构评分的加权平均，AI的预测输出完全依赖于深度学习寻找底层市场规律。',
//     xx: '3）极态AI让投资策略组合具备穿越牛熊市、大周期和不同行业周期的抗风险能力。正如股神巴菲特99%的财富是在50岁以后积累的。人类积累经验、总结、学习、认知、进化是一个漫长的且艰难的过程，”股神“也需要几十年的时间，在飞速发展的AI时代，我们又有几个几十年可以等待！极态AI第8代原生基座大经济模型的基础汇总了中国以及海外部分市场20年以上的详细宏观微观经济金融大数据，模型自我推导得出所有自然经济/金融规律作为我们预判未来的基准。让用户通过点几下鼠标就能获取N个经济周期、上百个行业、上千家公司的兴盛与衰败的底层规律和市场表现逻辑。新旧工具的更替短期内在行为习惯上是有适应成本的，但是当传统资管方法（基本面、量化）等策略在变幻莫测和充满诸多挑战的残酷市场环境下普遍失效并且出现严重亏损的局面下，即使克隆巴菲特，历史也无法重演。',
//
//     xx: '极态AI的原理和独特优势是什么？',
//     xx: '1）极态AI Copilot 产品，是基于我们第8代基座模型而打造的机构级应用产品。',
//     xx: '2）区别于其它利用机器学习模型的组织或机构，极态AI不堆PHD编辑“特征”，不做特征集的筛选，更不做每天或每周的平凡”模型调优“。我们认为一个足够强大的基座认知模型可以贯穿不同来源、串联不同时空的信息，在金融世界中自我寻求底层逻辑，这就是极态AI的核心工作原理。',
//     xx: '3）所以一个大模型相对传统N个小模型/堆因子的做法有什么优势？我们回顾一下在当下（2024年）人类堆因子 vs 深度学习在N个领域的结果比较一下哪个方式更优：',
//
//     xx: '象棋：StockFish（深度学习）',
//     xx: '围棋：AlphaZero（深度学习）',
//     xx: '画图：Midjourney/Stable diffusion（深度学习）',
//     xx: '语言理解/处理：GPT4/LLAMA3（深度学习）',
//     xx: '语音：Whisper（深度学习）',
//     xx: '蛋白质：AlphaFold（深度学习）',
//     xx: '实时策略游戏：AlphaStar（深度学习）',
//     xx: '自动驾驶：Tesla FSD（深度学习）',
//
//     xx: '趋势应该非常明显了，不是说堆因子一点用也没有，只是在深度学习面前完全是小巫见大巫。',
//     xx: '4）为什么市场上没有更多的公司做这件事情？',
//     xx: '首先，需要独立的基于第一原理重新架构一整套AI模型+配套工程体系的能力。这是一件极其高难度的事情，且非常耗时间。科研容不得半点马虎，更容不得包装。研发需要一个严谨的态度+持久的耐力和韧性。这次因素不代表你会成功，但是必备的基础。拿来注意在短期内看似解决了问题，赚了快钱，没有真正的看家本事，经不起外部力量的较量，迟早是要被卡脖子的。首先，这是极态AI的态度，所以极态AI完全是自研原生AI大经济模型，拥有完整且独立的知识产权。原始架构代码始于2019年，目前已迭代至第8代。在2023年是大模型元年，2024年是应用元年的时候，截止到2024年3月末，极态AI已经完成了3年的实盘数据验证，更是创造了碾压式的天花板业绩。',
//     xx: '极态科技作为一个创新创业型公司，架构出了极态AI这样复杂的原生基座大经济模型，与其独特的创始人背景息息相关。反之，这也是为什么目前国内很多大厂还未能实现的原因。',
//     xx: '王力的背景在海归里面算比较独特的，也许正是因为他的独特，才能研发出来了极态AI，也许正是因为他独特的经历，极态AI才能开辟一条通往AGI-通用人工智能的蹊径。王力出身于一个科学世家，3岁出国，小时候的课外活动是学习如何造原子弹，母语是英语，王力先生读大学期间，他学习的专业是应用数学和法律并修，研究课题是AI对于复杂系统的预测。早在2010年（人工智能寒冬期）就开始专注于AI、混沌论的研究和实践并深耕至今。１５岁参与中国A股市场，他对于金融的理解不是停留经济学课本上，而是把学费交在了实践市场的大课堂上，也正是因此，我们坚信通过博弈机制而迭代进化的大经济模型，是走向通用人工智能（A G I）的蹊径。',
//
//     xx: '极态AI Copilot 功能模块介绍：',
//     xx: '极态AI Copilot 投研助理目前包括三大模块：（全市场，行业，个股分析 ）',
//     xx: '全市场（A股）趋势预测模块：',
//     xx: '行业分析/趋势预测模块',
//     xx: '1）行业预测相图',
//     xx: '2）行业地图（treemap）',
//     xx: '3）行业历史+趋势预测和量价图',
//     xx: '个股分析/趋势预测模块',
//
//     xx: 'Copilot 核心指标介绍/历史表现评估：',
//     xx: '极态AI将提供多个基于不同维度的AI预测，最受关注的是强弱度指数。以下是强弱度指数从20230401 - 20240531 之间的实盘表现。',
//     xx: '最高分段 vs 最低分段的年化回报差距>30%年化。无论是对冲策略、宏观配置策略、指数增强策略或绝对收益策略，极态AI强弱度指数都能帮助客户的策略释放出巨大Alpha。',
//   },




  sageTradeView: {
    performance: 'Performance',
    tradeExecution: 'Trade Execution',
    tradeRecord: 'Trade Record',
    unitNav: 'Unit NAV:',
    totalNav: 'Total NAV:',
    benchmarkTrack: 'Benchmark: ',
    establishmentDate: 'Establishment Date',
    scale: 'Total Asset',
    brokerName: 'Broker',
    strategyName: 'Strategy Name',
    collapseMore: 'Collapse<<',
    viewMore: 'View More>>',
    basicInfo: 'Basic Information',
    accountName: 'Account Name',
    accountType: 'Account Type',
    simulated: 'Simulated',
    live: 'Live',
    productBelonging: 'Product',
    marketType: 'Market Type',
    currency: 'Currency',
    commissionRate: 'Commission Rate',
    stampDutyRate: 'Stamp Duty Rate',
    transferFeeRate: 'Transfer Fee Rate',
    accountStatus: 'Account Status',
    available: 'Available',
    unavailable: 'Unavailable',
    cumulativeGrowthRate: 'Cumulative Growth Rate',
    to: 'to',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectOverlayIndicator: 'Select Overlay Indicator',
    logarithm: 'Log',
    accountTradingInfo: 'Account Trading Info',
    totalAssets: 'Total Assets',
    currentMarketValue: 'Current Market Value',
    availableCash: 'Available Cash',
    dailyBuyQty: 'Daily Buy Qty',
    dailySellQty: 'Daily Sell Qty',
    dailyTradeAmount: 'Daily Trade Amount',
    dailyPnl: 'Daily P&L',
    totalPnl: 'Total P&L',
    totalCommission: 'Total Commission',
    totalStampDuty: 'Total Stamp Duty',
    latestNav: 'Latest NAV',
    performanceOverview: 'Performance Overview',
    cumulativeReturn: 'Cumulative Return',
    annualizedReturn: 'Annualized Return',
    maxDrawdown: 'Max Drawdown',
    annualizedVolatility: 'Annualized Volatility',
    benchmarkSuffix: '(Benchmark)',
    all: 'All',
    past3Months: 'Past 3M',
    past6Months: 'Past 6M',
    past2Months: 'Past 2M',
    past4Months: 'Past 4M',
    past1Year: 'Past 1Y',
  },
  sageTradeExecution: {
    selectDate: 'Select Date',
    rebalancingOverview: 'Rebalancing Overview',
    type: 'Type',
    plannedAdjustment: 'Planned Adjustment',
    actualAdjustment: 'Actual Adjustment',
    totalBuyAmount: 'Total Buy Amount',
    totalSellAmount: 'Total Sell Amount',
    totalAdjustedAmount: 'Total Adjusted Amount',
    totalBuyPosition: 'Total Buy Position',
    totalSellPosition: 'Total Sell Position',
    totalAdjustedPosition: 'Total Adjusted Position',
    slippageOverview: 'Slippage Overview',
    budgetValue: 'Budget',
    actualValue: 'Actual',
    buySlippageBp: 'Buy Slippage (bp)',
    sellSlippageBp: 'Sell Slippage (bp)',
    totalSlippageBp: 'Total Slippage (bp)',
    rebalancingProgress: 'Rebalancing Progress',
    completed: 'Completed',
    remaining: 'Remaining',
    position: 'Position',
    positionAdjustment: 'Position Adjustment',
    currentAssetDistribution: 'Current Asset Allocation',
    targetAssetDistribution: 'Target Asset Allocation',
    stock: 'Stock',
    fund: 'Fund',
    bond: 'Bond',
    repo: 'Repo',
    cash: 'Cash',
  },
  sageTradeList: {
    titleOrder: 'Trade Orders',
    titleHistory: 'Trade History',
    to: 'to',
    startDate: 'Start Date',
    endDate: 'End Date',
    name: 'Name',
    orderNo: 'Order No.',
    tradeNo: 'Trade No.',
    direction: 'Direction',
    buy: 'Buy',
    sell: 'Sell',
    cancel: 'Cancel',
    orderStatus: 'Order Status',
    filled: 'Filled',
    partialFilled: 'Partially Filled',
    unfilled: 'Unfilled',
    tradeQty: 'Trade Qty',
    tradeAvgPrice: 'Trade Avg Price',
    tradeAmount: 'Trade Amount',
    tradeTime: 'Trade Time',
    tradeDate: 'Trade Date',
    targetQty: 'Target Qty',
    targetPrice: 'Target Price',
    yuan: 'CNY',
  },
  sageTradeRecord: {
    total: 'Total',
    positionDetail: 'Position Detail',
    currentPositionDetail: 'Current Position Detail',
    rebalancePlan: 'Rebalance Plan',
    orderHistory: 'Order History',
    tradeHistory: 'Trade History',
    liquidatedStock: 'Liquidated Stocks',
    startDate: 'Start Date',
    endDate: 'End Date',
    tradeDate: 'Trade Date',
    selectDate: 'Select Date',
    dataDownload: 'Download',
    name: 'Name',
    positionQty: 'Position Qty (Shares)',
    positionQtyShort: 'Position (Shares)',
    positionAvgPrice: 'Avg Cost (CNY)',
    totalMarketValue: 'Market Value (CNY)',
    dailyPnl: 'Daily P&L (CNY)',
    floatPnl: 'Floating P&L (CNY)',
    currentPrice: 'Current Price (CNY)',
    restSellQty: 'Sellable Qty (Shares)',
    positionBuildAmount: 'Build Amount (CNY)',
    principal: 'Principal (CNY)',
    totalCommission: 'Total Commission (CNY)',
    totalStampDuty: 'Total Stamp Duty (CNY)',
    totalTransferFee: 'Total Transfer Fee (CNY)',
    dailyCommission: 'Daily Commission (CNY)',
    dailyStampDuty: 'Daily Stamp Duty (CNY)',
    dailyTransferFee: 'Daily Transfer Fee (CNY)',
    dailyBuyAmount: 'Daily Buy Amount (CNY)',
    dailySellAmount: 'Daily Sell Amount (CNY)',
    dailyBuyQty: 'Daily Buy Qty (Shares)',
    dailySellQty: 'Daily Sell Qty (Shares)',
    positionDate: 'Position Date',
    prevClosePrice: 'Prev Close (CNY)',
    cost: 'Cost (CNY)',
    marketValue: 'Market Value (CNY)',
    currentWeight: 'Current Weight',
    rebalanceDate: 'Rebalance Date',
    targetWeight: 'Target Weight',
    weightDelta: 'Weight Delta',
    tradeDirection: 'Direction',
    buy: 'Buy',
    sell: 'Sell',
    unchanged: 'Unchanged',
    orderNo: 'Order No.',
    tradeNo: 'Trade No.',
    direction: 'Direction',
    orderStatus: 'Order Status',
    filled: 'Filled',
    partialFilled: 'Partially Filled',
    unfilled: 'Unfilled',
    tradeQty: 'Trade Qty (Shares)',
    tradeAvgPrice: 'Trade Avg Price (CNY)',
    tradeAmount: 'Trade Amount (CNY)',
    targetQty: 'Target Qty (Shares)',
    targetPrice: 'Target Price (CNY)',
    winRate: 'Win Rate',
    payoffRatio: 'Payoff Ratio',
    securityName: 'Security Name',
    liquidatedDate: 'Liquidated Date',
    holdingDays: 'Holding Days',
    totalPnl: 'Total P&L (CNY)',
    holdingStartDate: 'Holding Start',
    holdingEndDate: 'Holding End',
    tradingFee: 'Trading Fee (CNY)',
    detail: 'Detail',
    viewDetail: 'View Detail',
    tradeDetail: 'Trade Detail',
    action: 'Action',
    tradePrice: 'Trade Price (CNY)',
    commission: 'Commission (CNY)',
    stampDuty: 'Stamp Duty (CNY)',
    transferFee: 'Transfer Fee (CNY)',
    totalTradeFee: 'Total Trade Fee (CNY)',
    close: 'Close',
    buildPosition: 'Build Position',
  },
  sageBacktestList: {
    title: 'Backtest History',
    strategyName: 'Strategy Name',
    creator: 'Creator',
    startTime: 'Start Time',
    endTime: 'End Time',
    action: 'Action',
    view: 'View',
  },
  sageEvaluation: {
    strategyName: 'Strategy Name',
    evaluationDate: 'Evaluation Date',
    annualizedReturn: 'Annualized Return',
    annualizedVolatility: 'Annualized Volatility',
    sharpeRatio: 'Sharpe Ratio',
    maxDrawdown: 'Max Drawdown',
    winRate: 'Win Rate',
    profitLossRatio: 'Profit/Loss Ratio',
    turnoverRate: 'Turnover Rate',
    capacity: 'Capacity',
    avgHoldingPeriod: 'Avg Holding Period',
    tradeFrequency: 'Trade Frequency',
    exposure: 'Market Exposure',
    trackingError: 'Tracking Error',
    evaluation: 'Comment:',
    evaluationHistory: 'Evaluation History',
    alpha: 'Alpha',
    beta: 'Beta',
    informationRatio: 'Information Ratio',
    turnoverCostRate: 'Trading Cost Rate',
    positionHistory: 'Position History',
    selectDate: 'Select Date',
    name: 'Name',
    positionQty: 'Position Qty',
    positionAvgPrice: 'Avg Cost',
    currentPrice: 'Current Price',
    totalMarketValue: 'Market Value',
    restSellQty: 'Sellable Qty',
    floatPnl: 'Floating P&L',
    totalPnl: 'Total P&L',
    dailyPnl: 'Daily P&L',
    dailyBuyQty: 'Daily Buy Qty',
    dailySellQty: 'Daily Sell Qty',
    dailyBuyAmount: 'Daily Buy Amount',
    dailySellAmount: 'Daily Sell Amount',
    dailyCommission: 'Daily Commission',
    dailyStampDuty: 'Daily Stamp Duty',
    dailyTransferFee: 'Daily Transfer Fee',
    tradeDate: 'Trade Date',
    status: 'Status',
    available: 'Available',
    unavailable: 'Unavailable',
    shareUnit: 'shares',
    yuanUnit: 'CNY',
    dayUnit: 'days',
    timesPerYear: 'times/year',
  },
};


